(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './compose-multiplatform-core-compose-ui-ui-unit.js', './kotlin-kotlin-stdlib.js', './compose-multiplatform-core-compose-ui-ui.js', './androidx-compose-runtime-runtime.js', './androidx-collection-collection.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./kotlin-kotlin-stdlib.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./androidx-compose-runtime-runtime.js'), require('./androidx-collection-collection.js'));
  else {
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation-layout'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation-layout'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation-layout'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation-layout'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation-layout'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation-layout'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation-layout'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation-layout'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-foundation-foundation-layout'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-foundation-foundation-layout'.");
    }
    globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] = factory(typeof globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-foundation-foundation-layout'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['androidx-compose-runtime-runtime'], globalThis['androidx-collection-collection']);
  }
}(function (_, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_kotlin, kotlin_org_jetbrains_compose_ui_ui, kotlin_androidx_compose_runtime_runtime, kotlin_androidx_collection_collection) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b4;
  var VOID = kotlin_kotlin.$_$.d;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var Companion_instance = kotlin_org_jetbrains_compose_ui_ui.$_$.ec;
  var get_FirstBaseline = kotlin_org_jetbrains_compose_ui_ui.$_$.d3;
  var get_LastBaseline = kotlin_org_jetbrains_compose_ui_ui.$_$.f3;
  var get_NoInspectorInfo = kotlin_org_jetbrains_compose_ui_ui.$_$.i7;
  var get_isDebugInspectorInfoEnabled = kotlin_org_jetbrains_compose_ui_ui.$_$.o7;
  var ModifierNodeElement = kotlin_org_jetbrains_compose_ui_ui.$_$.m5;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Dp__hashCode_impl_sxkrra = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j2;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Node = kotlin_org_jetbrains_compose_ui_ui.$_$.qa;
  var minIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.j5;
  var minIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.i5;
  var maxIntrinsicWidth = kotlin_org_jetbrains_compose_ui_ui.$_$.h5;
  var maxIntrinsicHeight = kotlin_org_jetbrains_compose_ui_ui.$_$.g5;
  var LayoutModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.k5;
  var Constraints__copy$default_impl_f452rp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w3;
  var _Constraints___get_maxWidth__impl__uuyqc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c2;
  var _Constraints___get_maxHeight__impl__dt3e8z = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b2;
  var coerceIn = kotlin_kotlin.$_$.ei;
  var _Constraints___get_minWidth__impl__hi9lfi = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e2;
  var _Constraints___get_minHeight__impl__ev4bgx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d2;
  var HorizontalAlignmentLine = kotlin_org_jetbrains_compose_ui_ui.$_$.e3;
  var Dp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.p;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var LayoutDirection_Rtl_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l4;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var Dp__toString_impl_kcddez = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k2;
  var toString = kotlin_kotlin.$_$.hp;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.dc;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var get_lastIndex = kotlin_kotlin.$_$.da;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var IntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var Companion_instance_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a4;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var get_currentCompositeKeyHashCode = kotlin_androidx_compose_runtime_runtime.$_$.l1;
  var materialize = kotlin_org_jetbrains_compose_ui_ui.$_$.wa;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui.$_$.vb;
  var invalidApplier = kotlin_androidx_compose_runtime_runtime.$_$.r1;
  var Applier = kotlin_androidx_compose_runtime_runtime.$_$.h;
  var _Updater___init__impl__rbfxm8 = kotlin_androidx_compose_runtime_runtime.$_$.r2;
  var Updater__set_impl_v7kwss = kotlin_androidx_compose_runtime_runtime.$_$.t2;
  var Updater__reconcile_impl_1mfi6g = kotlin_androidx_compose_runtime_runtime.$_$.s2;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var Placeable = kotlin_org_jetbrains_compose_ui_ui.$_$.b4;
  var _Constraints___get_value__impl__3ah2ax = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g2;
  var _Constraints___init__impl__v8ud31 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u1;
  var Constraints = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a;
  var toString_0 = kotlin_kotlin.$_$.hh;
  var minIntrinsicWidth_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.q3;
  var minIntrinsicHeight_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.p3;
  var maxIntrinsicWidth_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.o3;
  var maxIntrinsicHeight_0 = kotlin_org_jetbrains_compose_ui_ui.$_$.n3;
  var MeasurePolicy = kotlin_org_jetbrains_compose_ui_ui.$_$.r3;
  var ParentDataModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.n5;
  var Constraints_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b;
  var updateChangedFlags = kotlin_androidx_compose_runtime_runtime.$_$.q2;
  var Companion_getInstance_3 = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var SubcomposeLayout = kotlin_org_jetbrains_compose_ui_ui.$_$.e4;
  var _Constraints___get_hasBoundedWidth__impl__7hd0wr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.x1;
  var Constraints__toString_impl_37yskr = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f2;
  var Constraints__hashCode_impl_ij7484 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a2;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var composableLambdaInstance = kotlin_androidx_compose_runtime_runtime.$_$.b;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var coerceAtMost = kotlin_kotlin.$_$.zh;
  var Enum = kotlin_kotlin.$_$.en;
  var Companion_getInstance_4 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var constrain = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d1;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var invalidatePlacement = kotlin_org_jetbrains_compose_ui_ui.$_$.g6;
  var offset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j1;
  var constrainWidth = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c1;
  var constrainHeight = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b1;
  var Dp__compareTo_impl_tlg3dl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i2;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var androidx_compose_ui_Modifier_Node$stableprop_getter = kotlin_org_jetbrains_compose_ui_ui.$_$.ua;
  var multiply = kotlin_kotlin.$_$.ue;
  var numberToLong = kotlin_kotlin.$_$.we;
  var subtract = kotlin_kotlin.$_$.af;
  var compare = kotlin_kotlin.$_$.je;
  var toNumber = kotlin_kotlin.$_$.bf;
  var get_sign = kotlin_kotlin.$_$.nh;
  var add = kotlin_kotlin.$_$.fe;
  var _IntOffset___init__impl__rq8h7b = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.v2;
  var IntOffset = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.r;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var _Constraints___get_hasBoundedHeight__impl__bsh4rw = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w1;
  var _Constraints___get_hasFixedWidth__impl__4p17wc = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.z1;
  var _Constraints___get_hasFixedHeight__impl__y56fxx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.y1;
  var _DpSize___get_width__impl__o3d5gt = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.u2;
  var _DpSize___get_height__impl__5xueo2 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s2;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var invalidateMeasurement = kotlin_org_jetbrains_compose_ui_ui.$_$.f6;
  var traverseDescendants = kotlin_org_jetbrains_compose_ui_ui.$_$.p6;
  var TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance = kotlin_org_jetbrains_compose_ui_ui.$_$.jc;
  var traverseAncestors = kotlin_org_jetbrains_compose_ui_ui.$_$.o6;
  var TraversableNode = kotlin_org_jetbrains_compose_ui_ui.$_$.y5;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var get_LocalPlatformWindowInsets = kotlin_org_jetbrains_compose_ui_ui.$_$.b7;
  var get_safeDrawing = kotlin_org_jetbrains_compose_ui_ui.$_$.q7;
  var PlatformWindowInsetsProviderNode = kotlin_org_jetbrains_compose_ui_ui.$_$.k7;
  var observeReads = kotlin_org_jetbrains_compose_ui_ui.$_$.i6;
  var DelegatableNode = kotlin_org_jetbrains_compose_ui_ui.$_$.x4;
  var get_safeGestures = kotlin_org_jetbrains_compose_ui_ui.$_$.r7;
  var get_safeContent = kotlin_org_jetbrains_compose_ui_ui.$_$.p7;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(AlignmentLineOffsetDpElement, 'AlignmentLineOffsetDpElement', VOID, ModifierNodeElement);
  initMetadataForClass(AlignmentLineOffsetDpNode, 'AlignmentLineOffsetDpNode', VOID, Node, [LayoutModifierNode]);
  function get_spacing() {
    // Inline function 'androidx.compose.ui.unit.dp' call
    return _Dp___init__impl__ms3zkb(0);
  }
  initMetadataForInterface(Horizontal, 'Horizontal');
  initMetadataForClass(Arrangement$Absolute$Left$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Absolute$Center$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Absolute$Right$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Absolute$SpaceBetween$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Absolute$SpaceEvenly$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Absolute$SpaceAround$1, VOID, VOID, VOID, [Horizontal]);
  function get_spacing_0() {
    // Inline function 'androidx.compose.ui.unit.dp' call
    return _Dp___init__impl__ms3zkb(0);
  }
  initMetadataForInterface(Vertical, 'Vertical');
  initMetadataForObject(Absolute, 'Absolute');
  initMetadataForInterface(SpacingAlignmentCalculator, 'SpacingAlignmentCalculator');
  initMetadataForClass(SpacedAligned, 'SpacedAligned', VOID, VOID, [Horizontal, Vertical]);
  initMetadataForClass(sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0, 'sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0', VOID, VOID, [SpacingAlignmentCalculator, FunctionAdapter]);
  initMetadataForClass(Arrangement$Start$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$End$1, VOID, VOID, VOID, [Horizontal]);
  initMetadataForClass(Arrangement$Top$1, VOID, VOID, VOID, [Vertical]);
  initMetadataForClass(Arrangement$Bottom$1, VOID, VOID, VOID, [Vertical]);
  initMetadataForClass(Arrangement$Center$1, VOID, VOID, VOID, [Horizontal, Vertical]);
  initMetadataForClass(Arrangement$SpaceEvenly$1, VOID, VOID, VOID, [Horizontal, Vertical]);
  initMetadataForClass(Arrangement$SpaceBetween$1, VOID, VOID, VOID, [Horizontal, Vertical]);
  initMetadataForClass(Arrangement$SpaceAround$1, VOID, VOID, VOID, [Horizontal, Vertical]);
  initMetadataForObject(Arrangement, 'Arrangement');
  initMetadataForClass(AspectRatioElement, 'AspectRatioElement', VOID, ModifierNodeElement);
  initMetadataForClass(AspectRatioNode, 'AspectRatioNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(BoxMeasurePolicy, 'BoxMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForObject(BoxScopeInstance, 'BoxScopeInstance');
  initMetadataForClass(BoxChildDataElement, 'BoxChildDataElement', VOID, ModifierNodeElement);
  initMetadataForClass(BoxChildDataNode, 'BoxChildDataNode', VOID, Node, [ParentDataModifierNode]);
  initMetadataForClass(sam$androidx_compose_ui_layout_MeasurePolicy$0, 'sam$androidx_compose_ui_layout_MeasurePolicy$0', VOID, VOID, [MeasurePolicy, FunctionAdapter]);
  initMetadataForClass(BoxWithConstraintsScopeImpl, 'BoxWithConstraintsScopeImpl');
  function weight$default(_this__u8e3s4, weight, fill, $super) {
    fill = fill === VOID ? true : fill;
    return $super === VOID ? this.xds(_this__u8e3s4, weight, fill) : $super.xds.call(this, _this__u8e3s4, weight, fill);
  }
  initMetadataForInterface(ColumnScope, 'ColumnScope');
  function createConstraints$default(mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, isPrioritizing, $super) {
    isPrioritizing = isPrioritizing === VOID ? false : isPrioritizing;
    return $super === VOID ? this.ldt(mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, isPrioritizing) : $super.ldt.call(this, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, isPrioritizing).m5e_1;
  }
  initMetadataForInterface(RowColumnMeasurePolicy, 'RowColumnMeasurePolicy');
  initMetadataForClass(ColumnMeasurePolicy, 'ColumnMeasurePolicy', VOID, VOID, [MeasurePolicy, RowColumnMeasurePolicy]);
  initMetadataForObject(ColumnScopeInstance, 'ColumnScopeInstance', VOID, VOID, [ColumnScope]);
  initMetadataForClass(IntrinsicSize, 'IntrinsicSize', VOID, Enum);
  initMetadataForClass(IntrinsicWidthElement, 'IntrinsicWidthElement', VOID, ModifierNodeElement);
  initMetadataForClass(IntrinsicSizeModifier, 'IntrinsicSizeModifier', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(IntrinsicWidthNode, 'IntrinsicWidthNode', VOID, IntrinsicSizeModifier);
  initMetadataForClass(OffsetPxElement, 'OffsetPxElement', VOID, ModifierNodeElement);
  initMetadataForClass(OffsetPxNode, 'OffsetPxNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(PaddingValuesImpl, 'PaddingValuesImpl', PaddingValuesImpl);
  initMetadataForClass(PaddingElement, 'PaddingElement', VOID, ModifierNodeElement);
  initMetadataForClass(PaddingValuesElement, 'PaddingValuesElement', VOID, ModifierNodeElement);
  initMetadataForClass(PaddingNode, 'PaddingNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(PaddingValuesModifier, 'PaddingValuesModifier', VOID, Node, [LayoutModifierNode]);
  function weight$default_0(_this__u8e3s4, weight, fill, $super) {
    fill = fill === VOID ? true : fill;
    return $super === VOID ? this.xds(_this__u8e3s4, weight, fill) : $super.xds.call(this, _this__u8e3s4, weight, fill);
  }
  initMetadataForInterface(RowScope, 'RowScope');
  initMetadataForClass(RowMeasurePolicy, 'RowMeasurePolicy', VOID, VOID, [MeasurePolicy, RowColumnMeasurePolicy]);
  initMetadataForObject(RowScopeInstance, 'RowScopeInstance', VOID, VOID, [RowScope]);
  initMetadataForClass(RowColumnParentData, 'RowColumnParentData', RowColumnParentData);
  initMetadataForCompanion(Companion);
  initMetadataForClass(CrossAxisAlignment, 'CrossAxisAlignment');
  initMetadataForClass(HorizontalCrossAxisAlignment, 'HorizontalCrossAxisAlignment', VOID, CrossAxisAlignment);
  initMetadataForObject(IntrinsicMeasureBlocks, 'IntrinsicMeasureBlocks');
  initMetadataForClass(LayoutWeightElement, 'LayoutWeightElement', VOID, ModifierNodeElement);
  initMetadataForClass(HorizontalAlignElement, 'HorizontalAlignElement', VOID, ModifierNodeElement);
  initMetadataForClass(LayoutWeightNode, 'LayoutWeightNode', VOID, Node, [ParentDataModifierNode]);
  initMetadataForClass(HorizontalAlignNode, 'HorizontalAlignNode', VOID, Node, [ParentDataModifierNode]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(FillElement, 'FillElement', VOID, ModifierNodeElement);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(WrapContentElement, 'WrapContentElement', VOID, ModifierNodeElement);
  initMetadataForClass(SizeElement, 'SizeElement', VOID, ModifierNodeElement);
  initMetadataForClass(UnspecifiedConstraintsElement, 'UnspecifiedConstraintsElement', UnspecifiedConstraintsElement, ModifierNodeElement);
  initMetadataForClass(FillNode, 'FillNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(Direction, 'Direction', VOID, Enum);
  initMetadataForClass(WrapContentNode, 'WrapContentNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(SizeNode, 'SizeNode', VOID, Node, [LayoutModifierNode]);
  initMetadataForClass(UnspecifiedConstraintsNode, 'UnspecifiedConstraintsNode', UnspecifiedConstraintsNode, Node, [LayoutModifierNode]);
  initMetadataForObject(SpacerMeasurePolicy, 'SpacerMeasurePolicy', VOID, VOID, [MeasurePolicy]);
  initMetadataForCompanion(Companion_2);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(FixedIntInsets, 'FixedIntInsets');
  initMetadataForClass(LimitInsets, 'LimitInsets');
  initMetadataForClass(UnionInsets, 'UnionInsets');
  initMetadataForClass(ExcludeInsets, 'ExcludeInsets');
  initMetadataForClass(InsetsPaddingValues, 'InsetsPaddingValues');
  initMetadataForClass(InsetsPaddingModifierElement, 'InsetsPaddingModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(InsetsConsumingModifierNode, 'InsetsConsumingModifierNode', VOID, Node, [TraversableNode]);
  initMetadataForClass(InsetsPaddingModifierNode, 'InsetsPaddingModifierNode', VOID, InsetsConsumingModifierNode, [LayoutModifierNode]);
  initMetadataForClass(UnionInsetsConsumingModifierElement, 'UnionInsetsConsumingModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(ConsumedInsetsModifierElement, 'ConsumedInsetsModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(UnionInsetsConsumingModifierNode, 'UnionInsetsConsumingModifierNode', VOID, InsetsConsumingModifierNode);
  initMetadataForClass(ConsumedInsetsModifierNode, 'ConsumedInsetsModifierNode', VOID, InsetsConsumingModifierNode);
  initMetadataForClass(toWindowInsets$1);
  initMetadataForClass(PlatformInsetsPaddingModifierElement, 'PlatformInsetsPaddingModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(PlatformWindowInsetsPaddingModifierElement, 'PlatformWindowInsetsPaddingModifierElement', VOID, ModifierNodeElement);
  initMetadataForClass(PlatformInsetsPaddingModifierNode, 'PlatformInsetsPaddingModifierNode', PlatformInsetsPaddingModifierNode, InsetsPaddingModifierNode);
  initMetadataForClass(PlatformWindowInsetsPaddingModifierNode, 'PlatformWindowInsetsPaddingModifierNode', VOID, PlatformWindowInsetsProviderNode, [DelegatableNode]);
  //endregion
  function paddingFromBaseline(_this__u8e3s4, top, bottom) {
    top = top === VOID ? Companion_getInstance().p5f_1 : top;
    bottom = bottom === VOID ? Companion_getInstance().p5f_1 : bottom;
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(top))) {
      tmp = paddingFrom(Companion_instance, get_FirstBaseline(), top);
    } else {
      tmp = Companion_instance;
    }
    var tmp_0 = _this__u8e3s4.d8v(tmp);
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(bottom))) {
      tmp_1 = paddingFrom(Companion_instance, get_LastBaseline(), VOID, bottom);
    } else {
      tmp_1 = Companion_instance;
    }
    return tmp_0.d8v(tmp_1);
  }
  function paddingFrom(_this__u8e3s4, alignmentLine, before, after) {
    before = before === VOID ? Companion_getInstance().p5f_1 : before;
    after = after === VOID ? Companion_getInstance().p5f_1 : after;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = paddingFrom$lambda(alignmentLine, before, after);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new AlignmentLineOffsetDpElement(alignmentLine, before, after, tmp$ret$0));
  }
  function AlignmentLineOffsetDpElement(alignmentLine, before, after, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.odo_1 = alignmentLine;
    this.pdo_1 = before;
    this.qdo_1 = after;
    this.rdo_1 = inspectorInfo;
    var tmp;
    if (_Dp___get_value__impl__geb1vb(this.pdo_1) >= 0.0) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_0 = this.pdo_1;
      tmp = isNaN_0(_Dp___get_value__impl__geb1vb(this_0));
    }
    var tmp_0 = tmp;
    var tmp_1;
    if (_Dp___get_value__impl__geb1vb(this.qdo_1) >= 0.0) {
      tmp_1 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_1 = this.qdo_1;
      tmp_1 = isNaN_0(_Dp___get_value__impl__geb1vb(this_1));
    }
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!!!(tmp_0 & tmp_1)) {
      var tmp$ret$3 = 'Padding from alignment line must be a non-negative number';
      throwIllegalArgumentException(tmp$ret$3);
    }
  }
  protoOf(AlignmentLineOffsetDpElement).r3d = function () {
    return new AlignmentLineOffsetDpNode(this.odo_1, this.pdo_1, this.qdo_1);
  };
  protoOf(AlignmentLineOffsetDpElement).sdo = function (node) {
    node.hdp_1 = this.odo_1;
    node.idp_1 = this.pdo_1;
    node.jdp_1 = this.qdo_1;
  };
  protoOf(AlignmentLineOffsetDpElement).d8y = function (node) {
    return this.sdo(node instanceof AlignmentLineOffsetDpNode ? node : THROW_CCE());
  };
  protoOf(AlignmentLineOffsetDpElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof AlignmentLineOffsetDpElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return equals(this.odo_1, otherModifier.odo_1) && equals(this.pdo_1, otherModifier.pdo_1) && equals(this.qdo_1, otherModifier.qdo_1);
  };
  protoOf(AlignmentLineOffsetDpElement).hashCode = function () {
    var result = hashCode(this.odo_1);
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.pdo_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.qdo_1) | 0;
    return result;
  };
  function AlignmentLineOffsetDpNode(alignmentLine, before, after) {
    Node.call(this);
    this.hdp_1 = alignmentLine;
    this.idp_1 = before;
    this.jdp_1 = after;
  }
  protoOf(AlignmentLineOffsetDpNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    return alignmentLineOffsetMeasure(_this__u8e3s4, this.hdp_1, this.idp_1, this.jdp_1, measurable, constraints);
  };
  function alignmentLineOffsetMeasure(_this__u8e3s4, alignmentLine, before, after, measurable, constraints) {
    var placeable = measurable.h8y(get_horizontal(alignmentLine) ? Constraints__copy$default_impl_f452rp(constraints, VOID, VOID, 0) : Constraints__copy$default_impl_f452rp(constraints, 0));
    // Inline function 'kotlin.let' call
    var it = placeable.kah(alignmentLine);
    var linePosition = !(it === -2147483648) ? it : 0;
    var axis = get_horizontal(alignmentLine) ? placeable.j8y_1 : placeable.i8y_1;
    var axisMax = get_horizontal(alignmentLine) ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(before))) {
      tmp = _this__u8e3s4.w5e(before);
    } else {
      tmp = 0;
    }
    var paddingBefore = coerceIn(tmp - linePosition | 0, 0, axisMax - axis | 0);
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(after))) {
      tmp_0 = _this__u8e3s4.w5e(after);
    } else {
      tmp_0 = 0;
    }
    var paddingAfter = coerceIn((tmp_0 - axis | 0) + linePosition | 0, 0, (axisMax - axis | 0) - paddingBefore | 0);
    var tmp_1;
    if (get_horizontal(alignmentLine)) {
      tmp_1 = placeable.i8y_1;
    } else {
      var tmp0 = (paddingBefore + placeable.i8y_1 | 0) + paddingAfter | 0;
      // Inline function 'kotlin.math.max' call
      var b = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      tmp_1 = Math.max(tmp0, b);
    }
    var width = tmp_1;
    var tmp_2;
    if (get_horizontal(alignmentLine)) {
      var tmp0_0 = (paddingBefore + placeable.j8y_1 | 0) + paddingAfter | 0;
      // Inline function 'kotlin.math.max' call
      var b_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      tmp_2 = Math.max(tmp0_0, b_0);
    } else {
      tmp_2 = placeable.j8y_1;
    }
    var height = tmp_2;
    return _this__u8e3s4.n8y(width, height, VOID, alignmentLineOffsetMeasure$lambda(alignmentLine, before, paddingBefore, width, paddingAfter, placeable, height));
  }
  function get_horizontal(_this__u8e3s4) {
    return _this__u8e3s4 instanceof HorizontalAlignmentLine;
  }
  function paddingFrom$lambda($alignmentLine, $before, $after) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'paddingFrom';
      _this__u8e3s4.mdp_1.odp('alignmentLine', $alignmentLine);
      _this__u8e3s4.mdp_1.odp('before', new Dp($before));
      _this__u8e3s4.mdp_1.odp('after', new Dp($after));
      return Unit_instance;
    };
  }
  function alignmentLineOffsetMeasure$lambda($alignmentLine, $before, $paddingBefore, $width, $paddingAfter, $placeable, $height) {
    return function ($this$layout) {
      var x = get_horizontal($alignmentLine) ? 0 : !equals($before, Companion_getInstance().p5f_1) ? $paddingBefore : ($width - $paddingAfter | 0) - $placeable.i8y_1 | 0;
      var y = !get_horizontal($alignmentLine) ? 0 : !equals($before, Companion_getInstance().p5f_1) ? $paddingBefore : ($height - $paddingAfter | 0) - $placeable.j8y_1 | 0;
      $this$layout.a98($placeable, x, y);
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_layout_Arrangement_Absolute$stable;
  var androidx_compose_foundation_layout_Arrangement_SpacedAligned$stable;
  var androidx_compose_foundation_layout_Arrangement$stable;
  function Arrangement$Absolute$Left$1() {
  }
  protoOf(Arrangement$Absolute$Left$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().ydp(sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$Left$1).toString = function () {
    return 'AbsoluteArrangement#Left';
  };
  function Arrangement$Absolute$Center$1() {
  }
  protoOf(Arrangement$Absolute$Center$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().adq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$Center$1).toString = function () {
    return 'AbsoluteArrangement#Center';
  };
  function Arrangement$Absolute$Right$1() {
  }
  protoOf(Arrangement$Absolute$Right$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().bdq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$Right$1).toString = function () {
    return 'AbsoluteArrangement#Right';
  };
  function Arrangement$Absolute$SpaceBetween$1() {
  }
  protoOf(Arrangement$Absolute$SpaceBetween$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().cdq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$SpaceBetween$1).toString = function () {
    return 'AbsoluteArrangement#SpaceBetween';
  };
  function Arrangement$Absolute$SpaceEvenly$1() {
  }
  protoOf(Arrangement$Absolute$SpaceEvenly$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().ddq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$SpaceEvenly$1).toString = function () {
    return 'AbsoluteArrangement#SpaceEvenly';
  };
  function Arrangement$Absolute$SpaceAround$1() {
  }
  protoOf(Arrangement$Absolute$SpaceAround$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    return Arrangement_getInstance().edq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Absolute$SpaceAround$1).toString = function () {
    return 'AbsoluteArrangement#SpaceAround';
  };
  function Horizontal() {
  }
  function Vertical() {
  }
  function Absolute() {
    Absolute_instance = this;
    var tmp = this;
    tmp.gdq_1 = new Arrangement$Absolute$Left$1();
    var tmp_0 = this;
    tmp_0.hdq_1 = new Arrangement$Absolute$Center$1();
    var tmp_1 = this;
    tmp_1.idq_1 = new Arrangement$Absolute$Right$1();
    var tmp_2 = this;
    tmp_2.jdq_1 = new Arrangement$Absolute$SpaceBetween$1();
    var tmp_3 = this;
    tmp_3.kdq_1 = new Arrangement$Absolute$SpaceEvenly$1();
    var tmp_4 = this;
    tmp_4.ldq_1 = new Arrangement$Absolute$SpaceAround$1();
  }
  protoOf(Absolute).mdq = function (space) {
    return new SpacedAligned(space, false, null);
  };
  var Absolute_instance;
  function Absolute_getInstance() {
    if (Absolute_instance == null)
      new Absolute();
    return Absolute_instance;
  }
  function SpacingAlignmentCalculator() {
  }
  function SpacedAligned(space, rtlMirror, alignment) {
    this.odq_1 = space;
    this.pdq_1 = rtlMirror;
    this.qdq_1 = alignment;
    this.rdq_1 = this.odq_1;
  }
  protoOf(SpacedAligned).zdp = function () {
    return this.rdq_1;
  };
  protoOf(SpacedAligned).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (sizes.length === 0)
      return Unit_instance;
    var spacePx = _this__u8e3s4.w5e(this.odq_1);
    var isRtl = this.pdq_1 && layoutDirection.equals(LayoutDirection_Rtl_getInstance());
    var lastSpace = 0;
    var freeSpace = totalSize;
    if (isRtl) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable = 0;
      var last = sizes.length;
      while (inductionVariable < last) {
        var item = sizes[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = freeSpace - item | 0;
        outPositions[_unary__edvuaz] = Math.max(0, b);
        // Inline function 'kotlin.math.min' call
        var b_0 = outPositions[_unary__edvuaz];
        lastSpace = Math.min(spacePx, b_0);
        freeSpace = outPositions[_unary__edvuaz] - lastSpace | 0;
      }
      freeSpace = freeSpace + lastSpace | 0;
    } else {
      var occupied = 0;
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index_0 = 0;
      var inductionVariable_0 = 0;
      var last_0 = sizes.length;
      while (inductionVariable_0 < last_0) {
        var item_0 = sizes[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz_0 = index_0;
        index_0 = _unary__edvuaz_0 + 1 | 0;
        var tmp0 = occupied;
        // Inline function 'kotlin.math.min' call
        var b_1 = totalSize - item_0 | 0;
        outPositions[_unary__edvuaz_0] = Math.min(tmp0, b_1);
        // Inline function 'kotlin.math.min' call
        var b_2 = (totalSize - outPositions[_unary__edvuaz_0] | 0) - item_0 | 0;
        lastSpace = Math.min(spacePx, b_2);
        occupied = (outPositions[_unary__edvuaz_0] + item_0 | 0) + lastSpace | 0;
      }
      occupied = occupied - lastSpace | 0;
      freeSpace = totalSize - occupied | 0;
    }
    if (!(this.qdq_1 == null) && freeSpace > 0) {
      var groupPosition = this.qdq_1.ndq(freeSpace, layoutDirection);
      var offset = isRtl ? groupPosition - freeSpace | 0 : groupPosition;
      if (!(offset === 0)) {
        var inductionVariable_1 = 0;
        var last_1 = outPositions.length - 1 | 0;
        if (inductionVariable_1 <= last_1)
          do {
            var index_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            outPositions[index_1] = outPositions[index_1] + offset | 0;
          }
           while (inductionVariable_1 <= last_1);
      }
    }
  };
  protoOf(SpacedAligned).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return this.pdp(_this__u8e3s4, totalSize, sizes, LayoutDirection_Ltr_getInstance(), outPositions);
  };
  protoOf(SpacedAligned).toString = function () {
    return (this.pdq_1 ? '' : 'Absolute') + 'Arrangement#spacedAligned(' + Dp__toString_impl_kcddez(this.odq_1) + ', ' + toString(this.qdq_1) + ')';
  };
  protoOf(SpacedAligned).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.odq_1);
    result = imul(result, 31) + getBooleanHashCode(this.pdq_1) | 0;
    result = imul(result, 31) + (this.qdq_1 == null ? 0 : hashCode(this.qdq_1)) | 0;
    return result;
  };
  protoOf(SpacedAligned).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SpacedAligned))
      return false;
    if (!equals(this.odq_1, other.odq_1))
      return false;
    if (!(this.pdq_1 === other.pdq_1))
      return false;
    if (!equals(this.qdq_1, other.qdq_1))
      return false;
    return true;
  };
  function sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0(function_0) {
    this.sdq_1 = function_0;
  }
  protoOf(sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0).ndq = function (size, layoutDirection) {
    return this.sdq_1(size, layoutDirection);
  };
  protoOf(sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0).q3 = function () {
    return this.sdq_1;
  };
  protoOf(sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, SpacingAlignmentCalculator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function Arrangement$Start$1() {
  }
  protoOf(Arrangement$Start$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().ydp(sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().bdq(totalSize, sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$Start$1).toString = function () {
    return 'Arrangement#Start';
  };
  function Arrangement$End$1() {
  }
  protoOf(Arrangement$End$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().bdq(totalSize, sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().ydp(sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$End$1).toString = function () {
    return 'Arrangement#End';
  };
  function Arrangement$Top$1() {
  }
  protoOf(Arrangement$Top$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().ydp(sizes, outPositions, false);
  };
  protoOf(Arrangement$Top$1).toString = function () {
    return 'Arrangement#Top';
  };
  function Arrangement$Bottom$1() {
  }
  protoOf(Arrangement$Bottom$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().bdq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Bottom$1).toString = function () {
    return 'Arrangement#Bottom';
  };
  function Arrangement$Center$1() {
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.tdq_1 = _Dp___init__impl__ms3zkb(0);
  }
  protoOf(Arrangement$Center$1).zdp = function () {
    return this.tdq_1;
  };
  protoOf(Arrangement$Center$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().adq(totalSize, sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().adq(totalSize, sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$Center$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().adq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$Center$1).toString = function () {
    return 'Arrangement#Center';
  };
  function Arrangement$SpaceEvenly$1() {
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.udq_1 = _Dp___init__impl__ms3zkb(0);
  }
  protoOf(Arrangement$SpaceEvenly$1).zdp = function () {
    return this.udq_1;
  };
  protoOf(Arrangement$SpaceEvenly$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().ddq(totalSize, sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().ddq(totalSize, sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$SpaceEvenly$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().ddq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$SpaceEvenly$1).toString = function () {
    return 'Arrangement#SpaceEvenly';
  };
  function Arrangement$SpaceBetween$1() {
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.vdq_1 = _Dp___init__impl__ms3zkb(0);
  }
  protoOf(Arrangement$SpaceBetween$1).zdp = function () {
    return this.vdq_1;
  };
  protoOf(Arrangement$SpaceBetween$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().cdq(totalSize, sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().cdq(totalSize, sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$SpaceBetween$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().cdq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$SpaceBetween$1).toString = function () {
    return 'Arrangement#SpaceBetween';
  };
  function Arrangement$SpaceAround$1() {
    var tmp = this;
    // Inline function 'androidx.compose.ui.unit.dp' call
    tmp.wdq_1 = _Dp___init__impl__ms3zkb(0);
  }
  protoOf(Arrangement$SpaceAround$1).zdp = function () {
    return this.wdq_1;
  };
  protoOf(Arrangement$SpaceAround$1).pdp = function (_this__u8e3s4, totalSize, sizes, layoutDirection, outPositions) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      Arrangement_getInstance().edq(totalSize, sizes, outPositions, false);
      tmp = Unit_instance;
    } else {
      Arrangement_getInstance().edq(totalSize, sizes, outPositions, true);
      tmp = Unit_instance;
    }
    return tmp;
  };
  protoOf(Arrangement$SpaceAround$1).fdq = function (_this__u8e3s4, totalSize, sizes, outPositions) {
    return Arrangement_getInstance().edq(totalSize, sizes, outPositions, false);
  };
  protoOf(Arrangement$SpaceAround$1).toString = function () {
    return 'Arrangement#SpaceAround';
  };
  function Arrangement$spacedBy$lambda(size, layoutDirection) {
    return Companion_getInstance_0().w8t_1.a8u(0, size, layoutDirection);
  }
  function Arrangement() {
    Arrangement_instance = this;
    var tmp = this;
    tmp.qdp_1 = new Arrangement$Start$1();
    var tmp_0 = this;
    tmp_0.rdp_1 = new Arrangement$End$1();
    var tmp_1 = this;
    tmp_1.sdp_1 = new Arrangement$Top$1();
    var tmp_2 = this;
    tmp_2.tdp_1 = new Arrangement$Bottom$1();
    var tmp_3 = this;
    tmp_3.udp_1 = new Arrangement$Center$1();
    var tmp_4 = this;
    tmp_4.vdp_1 = new Arrangement$SpaceEvenly$1();
    var tmp_5 = this;
    tmp_5.wdp_1 = new Arrangement$SpaceBetween$1();
    var tmp_6 = this;
    tmp_6.xdp_1 = new Arrangement$SpaceAround$1();
  }
  protoOf(Arrangement).mdq = function (space) {
    var tmp = Arrangement$spacedBy$lambda;
    return new SpacedAligned(space, true, new sam$androidx_compose_foundation_layout_Arrangement_SpacingAlignmentCalculator$0(tmp));
  };
  protoOf(Arrangement).bdq = function (totalSize, size, outPosition, reverseInput) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 0;
    var inductionVariable = 0;
    var last = size.length;
    while (inductionVariable < last) {
      var element = size[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      accumulator = accumulator + element | 0;
    }
    var consumedSize = accumulator;
    var current = totalSize - consumedSize | 0;
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable_0 = 0;
      var last_0 = size.length;
      while (inductionVariable_0 < last_0) {
        var item = size[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        outPosition[_unary__edvuaz] = current;
        current = current + item | 0;
      }
    } else {
      var inductionVariable_1 = size.length - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var i = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var it = size[i];
          outPosition[i] = current;
          current = current + it | 0;
        }
         while (0 <= inductionVariable_1);
    }
  };
  protoOf(Arrangement).ydp = function (size, outPosition, reverseInput) {
    var current = 0;
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable = 0;
      var last = size.length;
      while (inductionVariable < last) {
        var item = size[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        outPosition[_unary__edvuaz] = current;
        current = current + item | 0;
      }
    } else {
      var inductionVariable_0 = size.length - 1 | 0;
      if (0 <= inductionVariable_0)
        do {
          var i = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + -1 | 0;
          var it = size[i];
          outPosition[i] = current;
          current = current + it | 0;
        }
         while (0 <= inductionVariable_0);
    }
  };
  protoOf(Arrangement).adq = function (totalSize, size, outPosition, reverseInput) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 0;
    var inductionVariable = 0;
    var last = size.length;
    while (inductionVariable < last) {
      var element = size[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      accumulator = accumulator + element | 0;
    }
    var consumedSize = accumulator;
    var current = (totalSize - consumedSize | 0) / 2;
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable_0 = 0;
      var last_0 = size.length;
      while (inductionVariable_0 < last_0) {
        var item = size[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = current;
        var tmp;
        if (isNaN_0(this_0)) {
          tmp = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp = roundToInt(this_0);
        }
        outPosition[_unary__edvuaz] = tmp;
        current = current + item;
      }
    } else {
      var inductionVariable_1 = size.length - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var i = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var it = size[i];
          // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
          var this_1 = current;
          var tmp_0;
          if (isNaN_0(this_1)) {
            tmp_0 = 0;
          } else {
            // Inline function 'kotlin.math.roundToInt' call
            tmp_0 = roundToInt(this_1);
          }
          outPosition[i] = tmp_0;
          current = current + it;
        }
         while (0 <= inductionVariable_1);
    }
  };
  protoOf(Arrangement).ddq = function (totalSize, size, outPosition, reverseInput) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 0;
    var inductionVariable = 0;
    var last = size.length;
    while (inductionVariable < last) {
      var element = size[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      accumulator = accumulator + element | 0;
    }
    var consumedSize = accumulator;
    var gapSize = (totalSize - consumedSize | 0) / (size.length + 1 | 0);
    var current = gapSize;
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable_0 = 0;
      var last_0 = size.length;
      while (inductionVariable_0 < last_0) {
        var item = size[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = current;
        var tmp;
        if (isNaN_0(this_0)) {
          tmp = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp = roundToInt(this_0);
        }
        outPosition[_unary__edvuaz] = tmp;
        current = current + (item + gapSize);
      }
    } else {
      var inductionVariable_1 = size.length - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var i = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var it = size[i];
          // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
          var this_1 = current;
          var tmp_0;
          if (isNaN_0(this_1)) {
            tmp_0 = 0;
          } else {
            // Inline function 'kotlin.math.roundToInt' call
            tmp_0 = roundToInt(this_1);
          }
          outPosition[i] = tmp_0;
          current = current + (it + gapSize);
        }
         while (0 <= inductionVariable_1);
    }
  };
  protoOf(Arrangement).cdq = function (totalSize, size, outPosition, reverseInput) {
    // Inline function 'kotlin.collections.isEmpty' call
    if (size.length === 0)
      return Unit_instance;
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 0;
    var inductionVariable = 0;
    var last = size.length;
    while (inductionVariable < last) {
      var element = size[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      accumulator = accumulator + element | 0;
    }
    var consumedSize = accumulator;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = get_lastIndex(size);
    var noOfGaps = Math.max(a, 1);
    var gapSize = (totalSize - consumedSize | 0) / noOfGaps;
    var current = 0.0;
    if (reverseInput && size.length === 1) {
      current = gapSize;
    }
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable_0 = 0;
      var last_0 = size.length;
      while (inductionVariable_0 < last_0) {
        var item = size[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = current;
        var tmp;
        if (isNaN_0(this_0)) {
          tmp = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp = roundToInt(this_0);
        }
        outPosition[_unary__edvuaz] = tmp;
        current = current + (item + gapSize);
      }
    } else {
      var inductionVariable_1 = size.length - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var i = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var it = size[i];
          // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
          var this_1 = current;
          var tmp_0;
          if (isNaN_0(this_1)) {
            tmp_0 = 0;
          } else {
            // Inline function 'kotlin.math.roundToInt' call
            tmp_0 = roundToInt(this_1);
          }
          outPosition[i] = tmp_0;
          current = current + (it + gapSize);
        }
         while (0 <= inductionVariable_1);
    }
  };
  protoOf(Arrangement).edq = function (totalSize, size, outPosition, reverseInput) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 0;
    var inductionVariable = 0;
    var last = size.length;
    while (inductionVariable < last) {
      var element = size[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      accumulator = accumulator + element | 0;
    }
    var consumedSize = accumulator;
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    // Inline function 'kotlin.collections.isEmpty' call
    if (!(size.length === 0)) {
      tmp = (totalSize - consumedSize | 0) / size.length;
    } else {
      tmp = 0.0;
    }
    var gapSize = tmp;
    var current = gapSize / 2;
    // Inline function 'androidx.compose.foundation.layout.Arrangement.forEachIndexed' call
    if (!reverseInput) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var inductionVariable_0 = 0;
      var last_0 = size.length;
      while (inductionVariable_0 < last_0) {
        var item = size[inductionVariable_0];
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = current;
        var tmp_0;
        if (isNaN_0(this_0)) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_0 = roundToInt(this_0);
        }
        outPosition[_unary__edvuaz] = tmp_0;
        current = current + (item + gapSize);
      }
    } else {
      var inductionVariable_1 = size.length - 1 | 0;
      if (0 <= inductionVariable_1)
        do {
          var i = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + -1 | 0;
          var it = size[i];
          // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
          var this_1 = current;
          var tmp_1;
          if (isNaN_0(this_1)) {
            tmp_1 = 0;
          } else {
            // Inline function 'kotlin.math.roundToInt' call
            tmp_1 = roundToInt(this_1);
          }
          outPosition[i] = tmp_1;
          current = current + (it + gapSize);
        }
         while (0 <= inductionVariable_1);
    }
  };
  var Arrangement_instance;
  function Arrangement_getInstance() {
    if (Arrangement_instance == null)
      new Arrangement();
    return Arrangement_instance;
  }
  function aspectRatio(_this__u8e3s4, ratio, matchHeightConstraintsFirst) {
    matchHeightConstraintsFirst = matchHeightConstraintsFirst === VOID ? false : matchHeightConstraintsFirst;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = aspectRatio$lambda(ratio, matchHeightConstraintsFirst);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new AspectRatioElement(ratio, matchHeightConstraintsFirst, tmp$ret$0));
  }
  function AspectRatioElement(aspectRatio, matchHeightConstraintsFirst, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.ydq_1 = aspectRatio;
    this.zdq_1 = matchHeightConstraintsFirst;
    this.adr_1 = inspectorInfo;
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!(this.ydq_1 > 0)) {
      var tmp$ret$1 = 'aspectRatio ' + this.ydq_1 + ' must be > 0';
      throwIllegalArgumentException(tmp$ret$1);
    }
  }
  protoOf(AspectRatioElement).r3d = function () {
    return new AspectRatioNode(this.ydq_1, this.zdq_1);
  };
  protoOf(AspectRatioElement).bdr = function (node) {
    node.qdr_1 = this.ydq_1;
    node.rdr_1 = this.zdq_1;
  };
  protoOf(AspectRatioElement).d8y = function (node) {
    return this.bdr(node instanceof AspectRatioNode ? node : THROW_CCE());
  };
  protoOf(AspectRatioElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof AspectRatioElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return this.ydq_1 === otherModifier.ydq_1 && this.zdq_1 === other.zdq_1;
  };
  protoOf(AspectRatioElement).hashCode = function () {
    return imul(getNumberHashCode(this.ydq_1), 31) + getBooleanHashCode(this.zdq_1) | 0;
  };
  function findSize($this, $receiver) {
    if (!$this.rdr_1) {
      // Inline function 'kotlin.also' call
      var this_0 = new IntSize(tryMaxWidth($this, $receiver, true));
      var it = this_0.o5g_1;
      if (!equals(it, Companion_getInstance_1().n5g_1))
        return it;
      this_0.o5g_1;
      // Inline function 'kotlin.also' call
      var this_1 = new IntSize(tryMaxHeight($this, $receiver, true));
      var it_0 = this_1.o5g_1;
      if (!equals(it_0, Companion_getInstance_1().n5g_1))
        return it_0;
      this_1.o5g_1;
      // Inline function 'kotlin.also' call
      var this_2 = new IntSize(tryMinWidth($this, $receiver, true));
      var it_1 = this_2.o5g_1;
      if (!equals(it_1, Companion_getInstance_1().n5g_1))
        return it_1;
      this_2.o5g_1;
      // Inline function 'kotlin.also' call
      var this_3 = new IntSize(tryMinHeight($this, $receiver, true));
      var it_2 = this_3.o5g_1;
      if (!equals(it_2, Companion_getInstance_1().n5g_1))
        return it_2;
      this_3.o5g_1;
      // Inline function 'kotlin.also' call
      var this_4 = new IntSize(tryMaxWidth($this, $receiver, false));
      var it_3 = this_4.o5g_1;
      if (!equals(it_3, Companion_getInstance_1().n5g_1))
        return it_3;
      this_4.o5g_1;
      // Inline function 'kotlin.also' call
      var this_5 = new IntSize(tryMaxHeight($this, $receiver, false));
      var it_4 = this_5.o5g_1;
      if (!equals(it_4, Companion_getInstance_1().n5g_1))
        return it_4;
      this_5.o5g_1;
      // Inline function 'kotlin.also' call
      var this_6 = new IntSize(tryMinWidth($this, $receiver, false));
      var it_5 = this_6.o5g_1;
      if (!equals(it_5, Companion_getInstance_1().n5g_1))
        return it_5;
      this_6.o5g_1;
      // Inline function 'kotlin.also' call
      var this_7 = new IntSize(tryMinHeight($this, $receiver, false));
      var it_6 = this_7.o5g_1;
      if (!equals(it_6, Companion_getInstance_1().n5g_1))
        return it_6;
      this_7.o5g_1;
    } else {
      // Inline function 'kotlin.also' call
      var this_8 = new IntSize(tryMaxHeight($this, $receiver, true));
      var it_7 = this_8.o5g_1;
      if (!equals(it_7, Companion_getInstance_1().n5g_1))
        return it_7;
      this_8.o5g_1;
      // Inline function 'kotlin.also' call
      var this_9 = new IntSize(tryMaxWidth($this, $receiver, true));
      var it_8 = this_9.o5g_1;
      if (!equals(it_8, Companion_getInstance_1().n5g_1))
        return it_8;
      this_9.o5g_1;
      // Inline function 'kotlin.also' call
      var this_10 = new IntSize(tryMinHeight($this, $receiver, true));
      var it_9 = this_10.o5g_1;
      if (!equals(it_9, Companion_getInstance_1().n5g_1))
        return it_9;
      this_10.o5g_1;
      // Inline function 'kotlin.also' call
      var this_11 = new IntSize(tryMinWidth($this, $receiver, true));
      var it_10 = this_11.o5g_1;
      if (!equals(it_10, Companion_getInstance_1().n5g_1))
        return it_10;
      this_11.o5g_1;
      // Inline function 'kotlin.also' call
      var this_12 = new IntSize(tryMaxHeight($this, $receiver, false));
      var it_11 = this_12.o5g_1;
      if (!equals(it_11, Companion_getInstance_1().n5g_1))
        return it_11;
      this_12.o5g_1;
      // Inline function 'kotlin.also' call
      var this_13 = new IntSize(tryMaxWidth($this, $receiver, false));
      var it_12 = this_13.o5g_1;
      if (!equals(it_12, Companion_getInstance_1().n5g_1))
        return it_12;
      this_13.o5g_1;
      // Inline function 'kotlin.also' call
      var this_14 = new IntSize(tryMinHeight($this, $receiver, false));
      var it_13 = this_14.o5g_1;
      if (!equals(it_13, Companion_getInstance_1().n5g_1))
        return it_13;
      this_14.o5g_1;
      // Inline function 'kotlin.also' call
      var this_15 = new IntSize(tryMinWidth($this, $receiver, false));
      var it_14 = this_15.o5g_1;
      if (!equals(it_14, Companion_getInstance_1().n5g_1))
        return it_14;
      this_15.o5g_1;
    }
    return Companion_getInstance_1().n5g_1;
  }
  function tryMaxWidth($this, $receiver, enforceConstraints) {
    var maxWidth = _Constraints___get_maxWidth__impl__uuyqc($receiver);
    if (!(maxWidth === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = maxWidth / $this.qdr_1;
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      var height = tmp;
      if (height > 0) {
        if (!enforceConstraints || isSatisfiedBy($receiver, maxWidth, height)) {
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(maxWidth), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
          return _IntSize___init__impl__emcjft(tmp$ret$3);
        }
      }
    }
    return Companion_getInstance_1().n5g_1;
  }
  function tryMaxHeight($this, $receiver, enforceConstraints) {
    var maxHeight = _Constraints___get_maxHeight__impl__dt3e8z($receiver);
    if (!(maxHeight === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = maxHeight * $this.qdr_1;
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      var width = tmp;
      if (width > 0) {
        if (!enforceConstraints || isSatisfiedBy($receiver, width, maxHeight)) {
          // Inline function 'androidx.compose.ui.unit.IntSize' call
          // Inline function 'androidx.compose.ui.util.packInts' call
          var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(maxHeight), new Long(-1, 0)));
          return _IntSize___init__impl__emcjft(tmp$ret$3);
        }
      }
    }
    return Companion_getInstance_1().n5g_1;
  }
  function tryMinWidth($this, $receiver, enforceConstraints) {
    var minWidth = _Constraints___get_minWidth__impl__hi9lfi($receiver);
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = minWidth / $this.qdr_1;
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    var height = tmp;
    if (height > 0) {
      if (!enforceConstraints || isSatisfiedBy($receiver, minWidth, height)) {
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(minWidth), 32), bitwiseAnd(fromInt(height), new Long(-1, 0)));
        return _IntSize___init__impl__emcjft(tmp$ret$3);
      }
    }
    return Companion_getInstance_1().n5g_1;
  }
  function tryMinHeight($this, $receiver, enforceConstraints) {
    var minHeight = _Constraints___get_minHeight__impl__ev4bgx($receiver);
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_0 = minHeight * $this.qdr_1;
    var tmp;
    if (isNaN_0(this_0)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_0);
    }
    var width = tmp;
    if (width > 0) {
      if (!enforceConstraints || isSatisfiedBy($receiver, width, minHeight)) {
        // Inline function 'androidx.compose.ui.unit.IntSize' call
        // Inline function 'androidx.compose.ui.util.packInts' call
        var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(width), 32), bitwiseAnd(fromInt(minHeight), new Long(-1, 0)));
        return _IntSize___init__impl__emcjft(tmp$ret$3);
      }
    }
    return Companion_getInstance_1().n5g_1;
  }
  function AspectRatioNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.a98($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function AspectRatioNode(aspectRatio, matchHeightConstraintsFirst) {
    Node.call(this);
    this.qdr_1 = aspectRatio;
    this.rdr_1 = matchHeightConstraintsFirst;
  }
  protoOf(AspectRatioNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var size = findSize(this, constraints);
    var tmp;
    if (!equals(size, Companion_getInstance_1().n5g_1)) {
      var tmp_0 = Companion_instance_0;
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp_1 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(size);
      var tmp$ret$2 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp = tmp_0.p5e(tmp_1, tmp$ret$2);
    } else {
      tmp = constraints;
    }
    var wrappedConstraints = tmp;
    var placeable = measurable.h8y(wrappedConstraints);
    var tmp_2 = placeable.i8y_1;
    var tmp_3 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp_2, tmp_3, VOID, AspectRatioNode$measure$lambda(placeable));
  };
  protoOf(AspectRatioNode).o8y = function (_this__u8e3s4, measurable, height) {
    var tmp;
    if (!(height === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = height * this.qdr_1;
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      tmp = tmp_0;
    } else {
      tmp = measurable.b98(height);
    }
    return tmp;
  };
  protoOf(AspectRatioNode).q8y = function (_this__u8e3s4, measurable, height) {
    var tmp;
    if (!(height === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = height * this.qdr_1;
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      tmp = tmp_0;
    } else {
      tmp = measurable.c98(height);
    }
    return tmp;
  };
  protoOf(AspectRatioNode).p8y = function (_this__u8e3s4, measurable, width) {
    var tmp;
    if (!(width === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = width / this.qdr_1;
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      tmp = tmp_0;
    } else {
      tmp = measurable.d98(width);
    }
    return tmp;
  };
  protoOf(AspectRatioNode).r8y = function (_this__u8e3s4, measurable, width) {
    var tmp;
    if (!(width === 2147483647)) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = width / this.qdr_1;
      var tmp_0;
      if (isNaN_0(this_0)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_0);
      }
      tmp = tmp_0;
    } else {
      tmp = measurable.e98(width);
    }
    return tmp;
  };
  function isSatisfiedBy(_this__u8e3s4, width, height) {
    var tmp;
    var containsLower = _Constraints___get_minWidth__impl__hi9lfi(_this__u8e3s4);
    if (width <= _Constraints___get_maxWidth__impl__uuyqc(_this__u8e3s4) ? containsLower <= width : false) {
      var containsLower_0 = _Constraints___get_minHeight__impl__ev4bgx(_this__u8e3s4);
      tmp = height <= _Constraints___get_maxHeight__impl__dt3e8z(_this__u8e3s4) ? containsLower_0 <= height : false;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function aspectRatio$lambda($ratio, $matchHeightConstraintsFirst) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'aspectRatio';
      _this__u8e3s4.mdp_1.odp('ratio', $ratio);
      _this__u8e3s4.mdp_1.odp('matchHeightConstraintsFirst', $matchHeightConstraintsFirst);
      return Unit_instance;
    };
  }
  function get_Cache1() {
    _init_properties_Box_kt__tvzvdl();
    return Cache1;
  }
  var Cache1;
  function get_Cache2() {
    _init_properties_Box_kt__tvzvdl();
    return Cache2;
  }
  var Cache2;
  var DefaultBoxMeasurePolicy;
  function get_EmptyBoxMeasurePolicy() {
    _init_properties_Box_kt__tvzvdl();
    return EmptyBoxMeasurePolicy;
  }
  var EmptyBoxMeasurePolicy;
  var androidx_compose_foundation_layout_BoxScopeInstance$stable;
  function Box(modifier, $composer, $changed) {
    _init_properties_Box_kt__tvzvdl();
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(-211209833);
    var $dirty = $changed;
    if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier) ? 4 : 2);
    if ($composer_0.r31(!(($dirty & 3) === 2), $dirty & 1)) {
      var tmp2 = get_EmptyBoxMeasurePolicy();
      // Inline function 'androidx.compose.ui.layout.Layout' call
      var modifier_0 = modifier;
      var $composer_1 = $composer_0;
      if (!((0 & 1) === 0))
        modifier_0 = Companion_instance;
      var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
      var materialized = materialize($composer_1, modifier_0);
      var localMap = $composer_1.t31();
      // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
      var factory = Companion_getInstance_2().oah_1;
      var $composer_2 = $composer_1;
      var tmp = $composer_2.g30();
      if (!isInterface(tmp, Applier)) {
        invalidApplier();
      }
      $composer_2.b31();
      if ($composer_2.h30()) {
        $composer_2.c31(factory);
      } else {
        $composer_2.d31();
      }
      var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, tmp2, Companion_getInstance_2().tah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_2().sah_1);
      Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_2().xah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_2().qah_1);
      Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_2().wah_1);
      $composer_2.e31();
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(Box$lambda(modifier, $changed));
    }
  }
  function cacheFor(propagate) {
    _init_properties_Box_kt__tvzvdl();
    // Inline function 'kotlin.apply' call
    var this_0 = new MutableScatterMap(9);
    this_0.h13(Companion_getInstance_0().k8t_1, new BoxMeasurePolicy(Companion_getInstance_0().k8t_1, propagate));
    this_0.h13(Companion_getInstance_0().l8t_1, new BoxMeasurePolicy(Companion_getInstance_0().l8t_1, propagate));
    this_0.h13(Companion_getInstance_0().m8t_1, new BoxMeasurePolicy(Companion_getInstance_0().m8t_1, propagate));
    this_0.h13(Companion_getInstance_0().n8t_1, new BoxMeasurePolicy(Companion_getInstance_0().n8t_1, propagate));
    this_0.h13(Companion_getInstance_0().o8t_1, new BoxMeasurePolicy(Companion_getInstance_0().o8t_1, propagate));
    this_0.h13(Companion_getInstance_0().p8t_1, new BoxMeasurePolicy(Companion_getInstance_0().p8t_1, propagate));
    this_0.h13(Companion_getInstance_0().q8t_1, new BoxMeasurePolicy(Companion_getInstance_0().q8t_1, propagate));
    this_0.h13(Companion_getInstance_0().r8t_1, new BoxMeasurePolicy(Companion_getInstance_0().r8t_1, propagate));
    this_0.h13(Companion_getInstance_0().s8t_1, new BoxMeasurePolicy(Companion_getInstance_0().s8t_1, propagate));
    return this_0;
  }
  function BoxMeasurePolicy$measure$lambda($this$layout) {
    return Unit_instance;
  }
  function BoxMeasurePolicy$measure$lambda_0($placeable, $measurable, $this_measure, $boxWidth, $boxHeight, this$0) {
    return function ($this$layout) {
      placeInBox($this$layout, $placeable, $measurable, $this_measure.r6p(), $boxWidth, $boxHeight, this$0.sdr_1);
      return Unit_instance;
    };
  }
  function BoxMeasurePolicy$measure$lambda_1($placeables, $measurables, $this_measure, $boxWidth, $boxHeight, this$0) {
    return function ($this$layout) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = $placeables;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        if (!(item instanceof Placeable))
          THROW_CCE();
        var measurable = $measurables.l1(_unary__edvuaz);
        placeInBox($this$layout, item, measurable, $this_measure.r6p(), $boxWidth._v, $boxHeight._v, this$0.sdr_1);
      }
      return Unit_instance;
    };
  }
  function BoxMeasurePolicy(alignment, propagateMinConstraints) {
    this.sdr_1 = alignment;
    this.tdr_1 = propagateMinConstraints;
  }
  protoOf(BoxMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    if (measurables.r()) {
      var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      return _this__u8e3s4.n8y(tmp, tmp_0, VOID, BoxMeasurePolicy$measure$lambda);
    }
    var tmp_1;
    if (this.tdr_1) {
      tmp_1 = constraints;
    } else {
      // Inline function 'androidx.compose.ui.unit.Constraints.copyMaxDimensions' call
      tmp_1 = _Constraints___init__impl__v8ud31(bitwiseAnd(_Constraints___get_value__impl__3ah2ax(constraints), new Long(3, -2)));
    }
    var contentConstraints = tmp_1;
    if (measurables.n1() === 1) {
      var measurable = measurables.l1(0);
      var boxWidth;
      var boxHeight;
      var placeable;
      if (!get_matchesParentSize(measurable)) {
        placeable = measurable.h8y(contentConstraints);
        var tmp0 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
        // Inline function 'kotlin.math.max' call
        var b = placeable.i8y_1;
        boxWidth = Math.max(tmp0, b);
        var tmp0_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
        // Inline function 'kotlin.math.max' call
        var b_0 = placeable.j8y_1;
        boxHeight = Math.max(tmp0_0, b_0);
      } else {
        boxWidth = _Constraints___get_minWidth__impl__hi9lfi(constraints);
        boxHeight = _Constraints___get_minHeight__impl__ev4bgx(constraints);
        placeable = measurable.h8y(Companion_instance_0.p5e(_Constraints___get_minWidth__impl__hi9lfi(constraints), _Constraints___get_minHeight__impl__ev4bgx(constraints)));
      }
      return _this__u8e3s4.n8y(boxWidth, boxHeight, VOID, BoxMeasurePolicy$measure$lambda_0(placeable, measurable, _this__u8e3s4, boxWidth, boxHeight, this));
    }
    // Inline function 'kotlin.arrayOfNulls' call
    var size = measurables.n1();
    var placeables = Array(size);
    var hasMatchParentSizeChildren = false;
    var boxWidth_0 = {_v: _Constraints___get_minWidth__impl__hi9lfi(constraints)};
    var boxHeight_0 = {_v: _Constraints___get_minHeight__impl__ev4bgx(constraints)};
    // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
    var inductionVariable = 0;
    var last = measurables.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = measurables.l1(index);
        if (!get_matchesParentSize(item)) {
          var placeable_0 = item.h8y(contentConstraints);
          placeables[index] = placeable_0;
          var tmp0_1 = boxWidth_0._v;
          // Inline function 'kotlin.math.max' call
          var b_1 = placeable_0.i8y_1;
          boxWidth_0._v = Math.max(tmp0_1, b_1);
          var tmp0_2 = boxHeight_0._v;
          // Inline function 'kotlin.math.max' call
          var b_2 = placeable_0.j8y_1;
          boxHeight_0._v = Math.max(tmp0_2, b_2);
        } else {
          hasMatchParentSizeChildren = true;
        }
      }
       while (inductionVariable <= last);
    if (hasMatchParentSizeChildren) {
      var tmp0_minWidth = !(boxWidth_0._v === 2147483647) ? boxWidth_0._v : 0;
      var tmp1_minHeight = !(boxHeight_0._v === 2147483647) ? boxHeight_0._v : 0;
      var tmp2_maxWidth = boxWidth_0._v;
      var tmp3_maxHeight = boxHeight_0._v;
      var matchParentSizeConstraints = Constraints(tmp0_minWidth, tmp2_maxWidth, tmp1_minHeight, tmp3_maxHeight);
      // Inline function 'androidx.compose.ui.util.fastForEachIndexed' call
      var inductionVariable_0 = 0;
      var last_0 = measurables.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = measurables.l1(index_0);
          if (get_matchesParentSize(item_0)) {
            placeables[index_0] = item_0.h8y(matchParentSizeConstraints);
          }
        }
         while (inductionVariable_0 <= last_0);
    }
    var tmp_2 = boxWidth_0._v;
    var tmp_3 = boxHeight_0._v;
    return _this__u8e3s4.n8y(tmp_2, tmp_3, VOID, BoxMeasurePolicy$measure$lambda_1(placeables, measurables, _this__u8e3s4, boxWidth_0, boxHeight_0, this));
  };
  protoOf(BoxMeasurePolicy).toString = function () {
    return 'BoxMeasurePolicy(alignment=' + toString_0(this.sdr_1) + ', propagateMinConstraints=' + this.tdr_1 + ')';
  };
  protoOf(BoxMeasurePolicy).hashCode = function () {
    var result = hashCode(this.sdr_1);
    result = imul(result, 31) + getBooleanHashCode(this.tdr_1) | 0;
    return result;
  };
  protoOf(BoxMeasurePolicy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxMeasurePolicy))
      return false;
    if (!equals(this.sdr_1, other.sdr_1))
      return false;
    if (!(this.tdr_1 === other.tdr_1))
      return false;
    return true;
  };
  function maybeCachedBoxMeasurePolicy(alignment, propagateMinConstraints) {
    _init_properties_Box_kt__tvzvdl();
    var cache = propagateMinConstraints ? get_Cache1() : get_Cache2();
    var tmp0_elvis_lhs = cache.w2(alignment);
    return tmp0_elvis_lhs == null ? new BoxMeasurePolicy(alignment, propagateMinConstraints) : tmp0_elvis_lhs;
  }
  function BoxScopeInstance$align$lambda($alignment) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'align';
      _this__u8e3s4.ldp_1 = $alignment;
      return Unit_instance;
    };
  }
  function BoxScopeInstance$matchParentSize$lambda(_this__u8e3s4) {
    _this__u8e3s4.kdp_1 = 'matchParentSize';
    return Unit_instance;
  }
  function BoxScopeInstance() {
  }
  protoOf(BoxScopeInstance).udr = function (_this__u8e3s4, alignment) {
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = BoxScopeInstance$align$lambda(alignment);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new BoxChildDataElement(alignment, false, tmp$ret$0));
  };
  protoOf(BoxScopeInstance).vdr = function (_this__u8e3s4) {
    var tmp = Companion_getInstance_0().o8t_1;
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp_0;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp_0 = BoxScopeInstance$matchParentSize$lambda;
    } else {
      tmp_0 = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp_0;
    return _this__u8e3s4.d8v(new BoxChildDataElement(tmp, true, tmp$ret$0));
  };
  var BoxScopeInstance_instance;
  function BoxScopeInstance_getInstance() {
    return BoxScopeInstance_instance;
  }
  function get_matchesParentSize(_this__u8e3s4) {
    _init_properties_Box_kt__tvzvdl();
    var tmp0_safe_receiver = get_boxChildDataNode(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.lds_1;
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function placeInBox(_this__u8e3s4, placeable, measurable, layoutDirection, boxWidth, boxHeight, alignment) {
    _init_properties_Box_kt__tvzvdl();
    var tmp0_safe_receiver = get_boxChildDataNode(measurable);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kds_1;
    var childAlignment = tmp1_elvis_lhs == null ? alignment : tmp1_elvis_lhs;
    var tmp0 = placeable.i8y_1;
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = placeable.j8y_1;
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp = _IntSize___init__impl__emcjft(tmp$ret$1);
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(boxWidth), 32), bitwiseAnd(fromInt(boxHeight), new Long(-1, 0)));
    var tmp$ret$2 = _IntSize___init__impl__emcjft(tmp$ret$3);
    var position = childAlignment.f8u(tmp, tmp$ret$2, layoutDirection);
    _this__u8e3s4.lal(placeable, position);
  }
  function BoxChildDataElement(alignment, matchParentSize, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.nds_1 = alignment;
    this.ods_1 = matchParentSize;
    this.pds_1 = inspectorInfo;
  }
  protoOf(BoxChildDataElement).r3d = function () {
    return new BoxChildDataNode(this.nds_1, this.ods_1);
  };
  protoOf(BoxChildDataElement).qds = function (node) {
    node.kds_1 = this.nds_1;
    node.lds_1 = this.ods_1;
  };
  protoOf(BoxChildDataElement).d8y = function (node) {
    return this.qds(node instanceof BoxChildDataNode ? node : THROW_CCE());
  };
  protoOf(BoxChildDataElement).hashCode = function () {
    var result = hashCode(this.nds_1);
    result = imul(31, result) + getBooleanHashCode(this.ods_1) | 0;
    return result;
  };
  protoOf(BoxChildDataElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof BoxChildDataElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return equals(this.nds_1, otherModifier.nds_1) && this.ods_1 === otherModifier.ods_1;
  };
  function BoxChildDataNode(alignment, matchParentSize) {
    Node.call(this);
    this.kds_1 = alignment;
    this.lds_1 = matchParentSize;
  }
  protoOf(BoxChildDataNode).aaj = function (_this__u8e3s4, parentData) {
    return this;
  };
  function get_boxChildDataNode(_this__u8e3s4) {
    _init_properties_Box_kt__tvzvdl();
    var tmp = _this__u8e3s4.xag();
    return tmp instanceof BoxChildDataNode ? tmp : null;
  }
  function sam$androidx_compose_ui_layout_MeasurePolicy$0(function_0) {
    this.rds_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).mak = function (_this__u8e3s4, measurables, constraints) {
    return this.rds_1(_this__u8e3s4, measurables, new Constraints_0(constraints));
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).q3 = function () {
    return this.rds_1;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, MeasurePolicy) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function EmptyBoxMeasurePolicy$lambda($this$MeasurePolicy, _unused_var__etf5q3, constraints) {
    _init_properties_Box_kt__tvzvdl();
    var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints.m5e_1);
    var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints.m5e_1);
    return $this$MeasurePolicy.n8y(tmp, tmp_0, VOID, EmptyBoxMeasurePolicy$lambda$lambda);
  }
  function EmptyBoxMeasurePolicy$lambda$lambda($this$layout) {
    _init_properties_Box_kt__tvzvdl();
    return Unit_instance;
  }
  function Box$lambda($modifier, $$changed) {
    return function ($composer, $force) {
      Box($modifier, $composer, updateChangedFlags($$changed | 1));
      return Unit_instance;
    };
  }
  var properties_initialized_Box_kt_kr8cbp;
  function _init_properties_Box_kt__tvzvdl() {
    if (!properties_initialized_Box_kt_kr8cbp) {
      properties_initialized_Box_kt_kr8cbp = true;
      Cache1 = cacheFor(true);
      Cache2 = cacheFor(false);
      DefaultBoxMeasurePolicy = new BoxMeasurePolicy(Companion_getInstance_0().k8t_1, false);
      var tmp = EmptyBoxMeasurePolicy$lambda;
      EmptyBoxMeasurePolicy = new sam$androidx_compose_ui_layout_MeasurePolicy$0(tmp);
      androidx_compose_foundation_layout_BoxScopeInstance$stable = 0;
    }
  }
  function BoxWithConstraints(modifier, contentAlignment, propagateMinConstraints, content, $composer, $changed, $default) {
    var modifier_0 = {_v: modifier};
    var contentAlignment_0 = {_v: contentAlignment};
    var propagateMinConstraints_0 = {_v: propagateMinConstraints};
    var $composer_0 = $composer;
    $composer_0 = $composer_0.s30(380139498);
    var $dirty = $changed;
    if (!(($default & 1) === 0))
      $dirty = $dirty | 6;
    else if (($changed & 6) === 0)
      $dirty = $dirty | ($composer_0.k31(modifier_0._v) ? 4 : 2);
    if (!(($default & 2) === 0))
      $dirty = $dirty | 48;
    else if (($changed & 48) === 0)
      $dirty = $dirty | ($composer_0.k31(contentAlignment_0._v) ? 32 : 16);
    if (!(($default & 4) === 0))
      $dirty = $dirty | 384;
    else if (($changed & 384) === 0)
      $dirty = $dirty | ($composer_0.l31(propagateMinConstraints_0._v) ? 256 : 128);
    if (($changed & 3072) === 0)
      $dirty = $dirty | ($composer_0.q31(content) ? 2048 : 1024);
    if ($composer_0.r31(!(($dirty & 1171) === 1170), $dirty & 1)) {
      if (!(($default & 1) === 0)) {
        modifier_0._v = Companion_instance;
      }
      if (!(($default & 2) === 0)) {
        contentAlignment_0._v = Companion_getInstance_0().k8t_1;
      }
      if (!(($default & 4) === 0)) {
        propagateMinConstraints_0._v = false;
      }
      var measurePolicy = maybeCachedBoxMeasurePolicy(contentAlignment_0._v, propagateMinConstraints_0._v);
      var tmp = modifier_0._v;
      var tmp0 = $composer_0;
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!(($dirty & 7168) === 2048 | $composer_0.k31(measurePolicy));
      // Inline function 'kotlin.let' call
      var it = tmp0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_3().f30_1) {
        var value = BoxWithConstraints$lambda(measurePolicy, content);
        tmp0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp$ret$0 = tmp_0;
      SubcomposeLayout(tmp, tmp$ret$0, $composer_0, 14 & $dirty, 0);
    } else {
      $composer_0.z30();
    }
    var tmp0_safe_receiver = $composer_0.t30();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p3c(BoxWithConstraints$lambda_0(modifier_0, contentAlignment_0, propagateMinConstraints_0, content, $changed, $default));
    }
  }
  function BoxWithConstraintsScopeImpl(density, constraints) {
    this.sds_1 = BoxScopeInstance_instance;
    this.tds_1 = density;
    this.uds_1 = constraints;
  }
  protoOf(BoxWithConstraintsScopeImpl).vds = function () {
    return this.uds_1;
  };
  protoOf(BoxWithConstraintsScopeImpl).wds = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.tds_1;
    return _Constraints___get_hasBoundedWidth__impl__7hd0wr(this.uds_1) ? $this$with.d5f(_Constraints___get_maxWidth__impl__uuyqc(this.uds_1)) : Companion_getInstance().o5f_1;
  };
  protoOf(BoxWithConstraintsScopeImpl).toString = function () {
    return 'BoxWithConstraintsScopeImpl(density=' + toString_0(this.tds_1) + ', constraints=' + Constraints__toString_impl_37yskr(this.uds_1) + ')';
  };
  protoOf(BoxWithConstraintsScopeImpl).hashCode = function () {
    var result = hashCode(this.tds_1);
    result = imul(result, 31) + Constraints__hashCode_impl_ij7484(this.uds_1) | 0;
    return result;
  };
  protoOf(BoxWithConstraintsScopeImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BoxWithConstraintsScopeImpl))
      return false;
    if (!equals(this.tds_1, other.tds_1))
      return false;
    if (!equals(this.uds_1, other.uds_1))
      return false;
    return true;
  };
  protoOf(BoxWithConstraintsScopeImpl).udr = function (_this__u8e3s4, alignment) {
    return this.sds_1.udr(_this__u8e3s4, alignment);
  };
  protoOf(BoxWithConstraintsScopeImpl).vdr = function (_this__u8e3s4) {
    return this.sds_1.vdr(_this__u8e3s4);
  };
  function ComposableLambda$invoke$ref(p0) {
    return constructCallableReference(function (p0_0, p1) {
      p0.t50(p0_0, p1);
      return Unit_instance;
    }, 2, 0, 17, VOID, [p0]);
  }
  function BoxWithConstraints$lambda$lambda($content, $scope) {
    return function ($composer, $changed) {
      var $composer_0 = $composer;
      var tmp;
      if ($composer_0.r31(!(($changed & 3) === 2), $changed & 1)) {
        tmp = $content($scope, $composer_0, 0);
      } else {
        $composer_0.z30();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function BoxWithConstraints$lambda($measurePolicy, $content) {
    return function ($this$SubcomposeLayout, constraints) {
      var scope = new BoxWithConstraintsScopeImpl($this$SubcomposeLayout, constraints.m5e_1);
      var measurables = $this$SubcomposeLayout.aaw(Unit_instance, ComposableLambda$invoke$ref(composableLambdaInstance(-431986394, true, BoxWithConstraints$lambda$lambda($content, scope))));
      // Inline function 'kotlin.with' call
      return $measurePolicy.mak($this$SubcomposeLayout, measurables, constraints.m5e_1);
    };
  }
  function BoxWithConstraints$lambda_0($modifier, $contentAlignment, $propagateMinConstraints, $content, $$changed, $$default) {
    return function ($composer, $force) {
      BoxWithConstraints($modifier._v, $contentAlignment._v, $propagateMinConstraints._v, $content, $composer, updateChangedFlags($$changed | 1), $$default);
      return Unit_instance;
    };
  }
  function get_DefaultColumnMeasurePolicy() {
    _init_properties_Column_kt__s1zb92();
    return DefaultColumnMeasurePolicy;
  }
  var DefaultColumnMeasurePolicy;
  var androidx_compose_foundation_layout_ColumnMeasurePolicy$stable;
  var androidx_compose_foundation_layout_ColumnScopeInstance$stable;
  function ColumnScope() {
  }
  function getCrossAxisPosition($this, placeable, parentData, crossAxisLayoutSize, beforeCrossAxisAlignmentLine, layoutDirection) {
    var childCrossAlignment = parentData == null ? null : parentData.cdt_1;
    var tmp2_elvis_lhs = childCrossAlignment == null ? null : childCrossAlignment.hdt(crossAxisLayoutSize, $this.gdt(placeable), layoutDirection, placeable, beforeCrossAxisAlignmentLine);
    return tmp2_elvis_lhs == null ? $this.fdt_1.a8u($this.gdt(placeable), crossAxisLayoutSize, layoutDirection) : tmp2_elvis_lhs;
  }
  function ColumnMeasurePolicy$placeHelper$lambda($placeables, this$0, $crossAxisLayoutSize, $beforeCrossAxisAlignmentLine, $measureScope, $mainAxisPositions) {
    return function ($this$layout) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = $placeables;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        var crossAxisPosition = getCrossAxisPosition(this$0, ensureNotNull(item), get_rowColumnParentData(item), $crossAxisLayoutSize, $beforeCrossAxisAlignmentLine, $measureScope.r6p());
        $this$layout.jal(item, crossAxisPosition, $mainAxisPositions[_unary__edvuaz]);
      }
      return Unit_instance;
    };
  }
  function ColumnMeasurePolicy(verticalArrangement, horizontalAlignment) {
    this.edt_1 = verticalArrangement;
    this.fdt_1 = horizontalAlignment;
  }
  protoOf(ColumnMeasurePolicy).idt = function (_this__u8e3s4) {
    return _this__u8e3s4.j8y_1;
  };
  protoOf(ColumnMeasurePolicy).gdt = function (_this__u8e3s4) {
    return _this__u8e3s4.i8y_1;
  };
  protoOf(ColumnMeasurePolicy).jdt = function (mainAxisLayoutSize, childrenMainAxisSize, mainAxisPositions, measureScope) {
    // Inline function 'kotlin.with' call
    this.edt_1.fdq(measureScope, mainAxisLayoutSize, childrenMainAxisSize, mainAxisPositions);
  };
  protoOf(ColumnMeasurePolicy).kdt = function (placeables, measureScope, beforeCrossAxisAlignmentLine, mainAxisPositions, mainAxisLayoutSize, crossAxisLayoutSize, crossAxisOffset, currentLineIndex, startIndex, endIndex) {
    // Inline function 'kotlin.with' call
    return measureScope.n8y(crossAxisLayoutSize, mainAxisLayoutSize, VOID, ColumnMeasurePolicy$placeHelper$lambda(placeables, this, crossAxisLayoutSize, beforeCrossAxisAlignmentLine, measureScope, mainAxisPositions));
  };
  protoOf(ColumnMeasurePolicy).ldt = function (mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, isPrioritizing) {
    return createColumnConstraints(isPrioritizing, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax);
  };
  protoOf(ColumnMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    var tmp = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    var tmp_0 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    var tmp_1 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var tmp_2 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_3 = _this__u8e3s4.w5e(this.edt_1.zdp());
    // Inline function 'kotlin.arrayOfNulls' call
    var size = measurables.n1();
    var tmp$ret$0 = Array(size);
    return measure(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, _this__u8e3s4, measurables, tmp$ret$0, 0, measurables.n1());
  };
  protoOf(ColumnMeasurePolicy).nak = function (_this__u8e3s4, measurables, height) {
    return IntrinsicMeasureBlocks_instance.ndt(measurables, height, _this__u8e3s4.w5e(this.edt_1.zdp()));
  };
  protoOf(ColumnMeasurePolicy).oak = function (_this__u8e3s4, measurables, width) {
    return IntrinsicMeasureBlocks_instance.odt(measurables, width, _this__u8e3s4.w5e(this.edt_1.zdp()));
  };
  protoOf(ColumnMeasurePolicy).pak = function (_this__u8e3s4, measurables, height) {
    return IntrinsicMeasureBlocks_instance.pdt(measurables, height, _this__u8e3s4.w5e(this.edt_1.zdp()));
  };
  protoOf(ColumnMeasurePolicy).qak = function (_this__u8e3s4, measurables, width) {
    return IntrinsicMeasureBlocks_instance.qdt(measurables, width, _this__u8e3s4.w5e(this.edt_1.zdp()));
  };
  protoOf(ColumnMeasurePolicy).toString = function () {
    return 'ColumnMeasurePolicy(verticalArrangement=' + toString_0(this.edt_1) + ', horizontalAlignment=' + toString_0(this.fdt_1) + ')';
  };
  protoOf(ColumnMeasurePolicy).hashCode = function () {
    var result = hashCode(this.edt_1);
    result = imul(result, 31) + hashCode(this.fdt_1) | 0;
    return result;
  };
  protoOf(ColumnMeasurePolicy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColumnMeasurePolicy))
      return false;
    if (!equals(this.edt_1, other.edt_1))
      return false;
    if (!equals(this.fdt_1, other.fdt_1))
      return false;
    return true;
  };
  function columnMeasurePolicy(verticalArrangement, horizontalAlignment, $composer, $changed) {
    _init_properties_Column_kt__s1zb92();
    var $composer_0 = $composer;
    var tmp;
    if (equals(verticalArrangement, Arrangement_getInstance().sdp_1) && equals(horizontalAlignment, Companion_getInstance_0().w8t_1)) {
      $composer_0.m30(-1446604504);
      $composer_0.n30();
      tmp = get_DefaultColumnMeasurePolicy();
    } else {
      $composer_0.m30(-1446550657);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(verticalArrangement) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(horizontalAlignment) || ($changed & 48) === 32));
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_3().f30_1) {
        var value = new ColumnMeasurePolicy(verticalArrangement, horizontalAlignment);
        $composer_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp1_group = tmp_0;
      $composer_0.n30();
      tmp = tmp1_group;
    }
    return tmp;
  }
  function ColumnScopeInstance() {
  }
  protoOf(ColumnScopeInstance).xds = function (_this__u8e3s4, weight, fill) {
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!(weight > 0.0)) {
      var tmp$ret$1 = 'invalid weight; must be greater than zero';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _this__u8e3s4.d8v(new LayoutWeightElement(coerceAtMost(weight, 3.4028235E38), fill));
  };
  protoOf(ColumnScopeInstance).zds = function (_this__u8e3s4, alignment) {
    return _this__u8e3s4.d8v(new HorizontalAlignElement(alignment));
  };
  var ColumnScopeInstance_instance;
  function ColumnScopeInstance_getInstance() {
    return ColumnScopeInstance_instance;
  }
  function createColumnConstraints(isPrioritizing, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax) {
    _init_properties_Column_kt__s1zb92();
    var tmp;
    if (!isPrioritizing) {
      tmp = Constraints(crossAxisMin, crossAxisMax, mainAxisMin, mainAxisMax);
    } else {
      tmp = Companion_instance_0.t5e(crossAxisMin, crossAxisMax, mainAxisMin, mainAxisMax);
    }
    return tmp;
  }
  var properties_initialized_Column_kt_nm4x4;
  function _init_properties_Column_kt__s1zb92() {
    if (!properties_initialized_Column_kt_nm4x4) {
      properties_initialized_Column_kt_nm4x4 = true;
      DefaultColumnMeasurePolicy = new ColumnMeasurePolicy(Arrangement_getInstance().sdp_1, Companion_getInstance_0().w8t_1);
      androidx_compose_foundation_layout_ColumnMeasurePolicy$stable = 0;
      androidx_compose_foundation_layout_ColumnScopeInstance$stable = 0;
    }
  }
  var androidx_compose_foundation_layout_ComposeFoundationLayoutFlags$stable;
  var androidx_compose_foundation_layout_ContextualFlowRowScopeImpl$stable;
  var androidx_compose_foundation_layout_ContextualFlowColumnScopeImpl$stable;
  var androidx_compose_foundation_layout_ContextualFlowRowOverflowScopeImpl$stable;
  var androidx_compose_foundation_layout_ContextualFlowColumnOverflowScopeImpl$stable;
  var androidx_compose_foundation_layout_ContextualFlowItemIterator$stable;
  var androidx_compose_foundation_layout_FlowLineInfo$stable;
  var androidx_compose_foundation_layout_FlowLayoutBuildingBlocks_WrapInfo$stable;
  var androidx_compose_foundation_layout_FlowLayoutBuildingBlocks_WrapEllipsisInfo$stable;
  var androidx_compose_foundation_layout_FlowLayoutBuildingBlocks$stable;
  var androidx_compose_foundation_layout_FlowRowOverflow$stable;
  var androidx_compose_foundation_layout_FlowColumnOverflow$stable;
  var androidx_compose_foundation_layout_ContextualFlowRowOverflow$stable;
  var androidx_compose_foundation_layout_ContextualFlowColumnOverflow$stable;
  var androidx_compose_foundation_layout_FlowLayoutOverflow$stable;
  var androidx_compose_foundation_layout_FlowLayoutOverflowState$stable;
  var androidx_compose_foundation_layout_GridScopeInstance$stable;
  var androidx_compose_foundation_layout_GridMeasurePolicy$stable;
  function width(_this__u8e3s4, intrinsicSize) {
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = width$lambda(intrinsicSize);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new IntrinsicWidthElement(intrinsicSize, true, tmp$ret$0));
  }
  var IntrinsicSize_Min_instance;
  var IntrinsicSize_Max_instance;
  var IntrinsicSize_entriesInitialized;
  function IntrinsicSize_initEntries() {
    if (IntrinsicSize_entriesInitialized)
      return Unit_instance;
    IntrinsicSize_entriesInitialized = true;
    IntrinsicSize_Min_instance = new IntrinsicSize('Min', 0);
    IntrinsicSize_Max_instance = new IntrinsicSize('Max', 1);
  }
  function IntrinsicSize(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function IntrinsicWidthElement(width, enforceIncoming, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.sdt_1 = width;
    this.tdt_1 = enforceIncoming;
    this.udt_1 = inspectorInfo;
  }
  protoOf(IntrinsicWidthElement).r3d = function () {
    return new IntrinsicWidthNode(this.sdt_1, this.tdt_1);
  };
  protoOf(IntrinsicWidthElement).vdt = function (node) {
    node.kdu_1 = this.sdt_1;
    node.ldu_1 = this.tdt_1;
  };
  protoOf(IntrinsicWidthElement).d8y = function (node) {
    return this.vdt(node instanceof IntrinsicWidthNode ? node : THROW_CCE());
  };
  protoOf(IntrinsicWidthElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof IntrinsicWidthElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifierElement = tmp;
    return this.sdt_1.equals(otherModifierElement.sdt_1) && this.tdt_1 === otherModifierElement.tdt_1;
  };
  protoOf(IntrinsicWidthElement).hashCode = function () {
    return imul(31, this.sdt_1.hashCode()) + getBooleanHashCode(this.tdt_1) | 0;
  };
  function IntrinsicWidthNode(width, enforceIncoming) {
    IntrinsicSizeModifier.call(this);
    this.kdu_1 = width;
    this.ldu_1 = enforceIncoming;
  }
  protoOf(IntrinsicWidthNode).mdu = function () {
    return this.ldu_1;
  };
  protoOf(IntrinsicWidthNode).ndu = function (_this__u8e3s4, measurable, constraints) {
    var tmp;
    if (this.kdu_1.equals(IntrinsicSize_Min_getInstance())) {
      tmp = measurable.b98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
    } else {
      tmp = measurable.c98(_Constraints___get_maxHeight__impl__dt3e8z(constraints));
    }
    var measuredWidth = tmp;
    if (measuredWidth < 0) {
      measuredWidth = 0;
    }
    return Companion_instance_0.q5e(measuredWidth);
  };
  protoOf(IntrinsicWidthNode).o8y = function (_this__u8e3s4, measurable, height) {
    return this.kdu_1.equals(IntrinsicSize_Min_getInstance()) ? measurable.b98(height) : measurable.c98(height);
  };
  protoOf(IntrinsicWidthNode).q8y = function (_this__u8e3s4, measurable, height) {
    return this.kdu_1.equals(IntrinsicSize_Min_getInstance()) ? measurable.b98(height) : measurable.c98(height);
  };
  function IntrinsicSizeModifier$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.hal($placeable, Companion_getInstance_4().c5g_1);
      return Unit_instance;
    };
  }
  function IntrinsicSizeModifier() {
    Node.call(this);
  }
  protoOf(IntrinsicSizeModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var contentConstraints = this.ndu(_this__u8e3s4, measurable, constraints);
    var placeable = measurable.h8y(this.mdu() ? constrain(constraints, contentConstraints) : contentConstraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, IntrinsicSizeModifier$measure$lambda(placeable));
  };
  protoOf(IntrinsicSizeModifier).o8y = function (_this__u8e3s4, measurable, height) {
    return measurable.b98(height);
  };
  protoOf(IntrinsicSizeModifier).p8y = function (_this__u8e3s4, measurable, width) {
    return measurable.d98(width);
  };
  protoOf(IntrinsicSizeModifier).q8y = function (_this__u8e3s4, measurable, height) {
    return measurable.c98(height);
  };
  protoOf(IntrinsicSizeModifier).r8y = function (_this__u8e3s4, measurable, width) {
    return measurable.e98(width);
  };
  function width$lambda($intrinsicSize) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'width';
      _this__u8e3s4.mdp_1.odp('intrinsicSize', $intrinsicSize);
      return Unit_instance;
    };
  }
  function IntrinsicSize_Min_getInstance() {
    IntrinsicSize_initEntries();
    return IntrinsicSize_Min_instance;
  }
  function IntrinsicSize_Max_getInstance() {
    IntrinsicSize_initEntries();
    return IntrinsicSize_Max_instance;
  }
  function offset_0(_this__u8e3s4, offset) {
    return _this__u8e3s4.d8v(new OffsetPxElement(offset, true, offset$lambda(offset)));
  }
  function OffsetPxElement(offset, rtlAware, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.ddv_1 = offset;
    this.edv_1 = rtlAware;
    this.fdv_1 = inspectorInfo;
  }
  protoOf(OffsetPxElement).r3d = function () {
    return new OffsetPxNode(this.ddv_1, this.edv_1);
  };
  protoOf(OffsetPxElement).gdv = function (node) {
    node.ydv(this.ddv_1, this.edv_1);
  };
  protoOf(OffsetPxElement).d8y = function (node) {
    return this.gdv(node instanceof OffsetPxNode ? node : THROW_CCE());
  };
  protoOf(OffsetPxElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof OffsetPxElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return this.ddv_1 === otherModifier.ddv_1 && this.edv_1 === otherModifier.edv_1;
  };
  protoOf(OffsetPxElement).toString = function () {
    return 'OffsetPxModifier(offset=' + toString_0(this.ddv_1) + ', rtlAware=' + this.edv_1 + ')';
  };
  protoOf(OffsetPxElement).hashCode = function () {
    var result = hashCode(this.ddv_1);
    result = imul(31, result) + getBooleanHashCode(this.edv_1) | 0;
    return result;
  };
  function OffsetPxNode$measure$lambda(this$0, $placeable) {
    return function ($this$layout) {
      var offsetValue = this$0.vdv_1($this$layout).a5g_1;
      var tmp;
      if (this$0.wdv_1) {
        $this$layout.pal($placeable, _IntOffset___get_x__impl__qiqr5o(offsetValue), _IntOffset___get_y__impl__2avpwj(offsetValue));
        tmp = Unit_instance;
      } else {
        $this$layout.j9i($placeable, _IntOffset___get_x__impl__qiqr5o(offsetValue), _IntOffset___get_y__impl__2avpwj(offsetValue));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function OffsetPxNode(offset, rtlAware) {
    Node.call(this);
    this.vdv_1 = offset;
    this.wdv_1 = rtlAware;
    this.xdv_1 = false;
  }
  protoOf(OffsetPxNode).b8w = function () {
    return this.xdv_1;
  };
  protoOf(OffsetPxNode).ydv = function (offset, rtlAware) {
    if (!(this.vdv_1 === offset) || !(this.wdv_1 === rtlAware)) {
      invalidatePlacement(this);
    }
    this.vdv_1 = offset;
    this.wdv_1 = rtlAware;
  };
  protoOf(OffsetPxNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var placeable = measurable.h8y(constraints);
    var tmp = placeable.i8y_1;
    var tmp_0 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp, tmp_0, VOID, OffsetPxNode$measure$lambda(this, placeable));
  };
  function offset$lambda($offset) {
    return function ($this$OffsetPxElement) {
      $this$OffsetPxElement.kdp_1 = 'offset';
      $this$OffsetPxElement.mdp_1.odp('offset', $offset);
      return Unit_instance;
    };
  }
  var androidx_compose_foundation_layout_PaddingValues_Absolute$stable;
  var androidx_compose_foundation_layout_PaddingValuesImpl$stable;
  function PaddingValues(all) {
    return new PaddingValuesImpl(all, all, all, all);
  }
  function PaddingValues_0(start, top, end, bottom) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    return new PaddingValuesImpl(start, top, end, bottom);
  }
  function padding(_this__u8e3s4, start, top, end, bottom) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    return _this__u8e3s4.d8v(new PaddingElement(start, top, end, bottom, true, padding$lambda(start, top, end, bottom)));
  }
  function padding_0(_this__u8e3s4, horizontal, vertical) {
    var tmp;
    if (horizontal === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = horizontal;
    }
    horizontal = tmp;
    var tmp_0;
    if (vertical === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = vertical;
    }
    vertical = tmp_0;
    return _this__u8e3s4.d8v(new PaddingElement(horizontal, vertical, horizontal, vertical, true, padding$lambda_0(horizontal, vertical)));
  }
  function PaddingValues_1(horizontal, vertical) {
    var tmp;
    if (horizontal === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = horizontal;
    }
    horizontal = tmp;
    var tmp_0;
    if (vertical === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = vertical;
    }
    vertical = tmp_0;
    return new PaddingValuesImpl(horizontal, vertical, horizontal, vertical);
  }
  function calculateStartPadding(_this__u8e3s4, layoutDirection) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = _this__u8e3s4.adw(layoutDirection);
    } else {
      tmp = _this__u8e3s4.zdv(layoutDirection);
    }
    return tmp;
  }
  function calculateEndPadding(_this__u8e3s4, layoutDirection) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = _this__u8e3s4.zdv(layoutDirection);
    } else {
      tmp = _this__u8e3s4.adw(layoutDirection);
    }
    return tmp;
  }
  function padding_1(_this__u8e3s4, paddingValues) {
    return _this__u8e3s4.d8v(new PaddingValuesElement(paddingValues, padding$lambda_1(paddingValues)));
  }
  function PaddingValuesImpl(start, top, end, bottom) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    this.bdw_1 = start;
    this.cdw_1 = top;
    this.ddw_1 = end;
    this.edw_1 = bottom;
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!!!(!!(!!(_Dp___get_value__impl__geb1vb(this.bdw_1) >= 0.0 & _Dp___get_value__impl__geb1vb(this.cdw_1) >= 0.0) & _Dp___get_value__impl__geb1vb(this.ddw_1) >= 0.0) & _Dp___get_value__impl__geb1vb(this.edw_1) >= 0.0)) {
      var tmp$ret$5 = 'Padding must be non-negative';
      throwIllegalArgumentException(tmp$ret$5);
    }
  }
  protoOf(PaddingValuesImpl).adw = function (layoutDirection) {
    return layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? this.bdw_1 : this.ddw_1;
  };
  protoOf(PaddingValuesImpl).fdw = function () {
    return this.cdw_1;
  };
  protoOf(PaddingValuesImpl).zdv = function (layoutDirection) {
    return layoutDirection.equals(LayoutDirection_Ltr_getInstance()) ? this.ddw_1 : this.bdw_1;
  };
  protoOf(PaddingValuesImpl).gdw = function () {
    return this.edw_1;
  };
  protoOf(PaddingValuesImpl).equals = function (other) {
    if (!(other instanceof PaddingValuesImpl))
      return false;
    return equals(this.bdw_1, other.bdw_1) && equals(this.cdw_1, other.cdw_1) && equals(this.ddw_1, other.ddw_1) && equals(this.edw_1, other.edw_1);
  };
  protoOf(PaddingValuesImpl).hashCode = function () {
    return imul(imul(imul(Dp__hashCode_impl_sxkrra(this.bdw_1), 31) + Dp__hashCode_impl_sxkrra(this.cdw_1) | 0, 31) + Dp__hashCode_impl_sxkrra(this.ddw_1) | 0, 31) + Dp__hashCode_impl_sxkrra(this.edw_1) | 0;
  };
  protoOf(PaddingValuesImpl).toString = function () {
    return 'PaddingValues(start=' + Dp__toString_impl_kcddez(this.bdw_1) + ', top=' + Dp__toString_impl_kcddez(this.cdw_1) + ', end=' + Dp__toString_impl_kcddez(this.ddw_1) + ', bottom=' + Dp__toString_impl_kcddez(this.edw_1) + ')';
  };
  function PaddingElement(start, top, end, bottom, rtlAware, inspectorInfo) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    ModifierNodeElement.call(this);
    this.idw_1 = start;
    this.jdw_1 = top;
    this.kdw_1 = end;
    this.ldw_1 = bottom;
    this.mdw_1 = rtlAware;
    this.ndw_1 = inspectorInfo;
    var tmp_3;
    if (_Dp___get_value__impl__geb1vb(this.idw_1) >= 0.0) {
      tmp_3 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_0 = this.idw_1;
      tmp_3 = isNaN_0(_Dp___get_value__impl__geb1vb(this_0));
    }
    var tmp_4 = tmp_3;
    var tmp_5;
    if (_Dp___get_value__impl__geb1vb(this.jdw_1) >= 0.0) {
      tmp_5 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_1 = this.jdw_1;
      tmp_5 = isNaN_0(_Dp___get_value__impl__geb1vb(this_1));
    }
    var tmp_6 = !!(tmp_4 & tmp_5);
    var tmp_7;
    if (_Dp___get_value__impl__geb1vb(this.kdw_1) >= 0.0) {
      tmp_7 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_2 = this.kdw_1;
      tmp_7 = isNaN_0(_Dp___get_value__impl__geb1vb(this_2));
    }
    var tmp_8 = !!(tmp_6 & tmp_7);
    var tmp_9;
    if (_Dp___get_value__impl__geb1vb(this.ldw_1) >= 0.0) {
      tmp_9 = true;
    } else {
      // Inline function 'androidx.compose.ui.unit.isUnspecified' call
      var this_3 = this.ldw_1;
      tmp_9 = isNaN_0(_Dp___get_value__impl__geb1vb(this_3));
    }
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!!!(tmp_8 & tmp_9)) {
      var tmp$ret$9 = 'Padding must be non-negative';
      throwIllegalArgumentException(tmp$ret$9);
    }
  }
  protoOf(PaddingElement).r3d = function () {
    return new PaddingNode(this.idw_1, this.jdw_1, this.kdw_1, this.ldw_1, this.mdw_1);
  };
  protoOf(PaddingElement).odw = function (node) {
    node.ddx_1 = this.idw_1;
    node.edx_1 = this.jdw_1;
    node.fdx_1 = this.kdw_1;
    node.gdx_1 = this.ldw_1;
    node.hdx_1 = this.mdw_1;
  };
  protoOf(PaddingElement).d8y = function (node) {
    return this.odw(node instanceof PaddingNode ? node : THROW_CCE());
  };
  protoOf(PaddingElement).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.idw_1);
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.jdw_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.kdw_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.ldw_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.mdw_1) | 0;
    return result;
  };
  protoOf(PaddingElement).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof PaddingElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifierElement = tmp;
    return equals(this.idw_1, otherModifierElement.idw_1) && equals(this.jdw_1, otherModifierElement.jdw_1) && equals(this.kdw_1, otherModifierElement.kdw_1) && equals(this.ldw_1, otherModifierElement.ldw_1) && this.mdw_1 === otherModifierElement.mdw_1;
  };
  function PaddingValuesElement(paddingValues, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.jdx_1 = paddingValues;
    this.kdx_1 = inspectorInfo;
  }
  protoOf(PaddingValuesElement).r3d = function () {
    return new PaddingValuesModifier(this.jdx_1);
  };
  protoOf(PaddingValuesElement).ldx = function (node) {
    node.ady_1 = this.jdx_1;
  };
  protoOf(PaddingValuesElement).d8y = function (node) {
    return this.ldx(node instanceof PaddingValuesModifier ? node : THROW_CCE());
  };
  protoOf(PaddingValuesElement).hashCode = function () {
    return hashCode(this.jdx_1);
  };
  protoOf(PaddingValuesElement).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof PaddingValuesElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherElement = tmp;
    return equals(this.jdx_1, otherElement.jdx_1);
  };
  function PaddingNode$measure$lambda(this$0, $placeable) {
    return function ($this$layout) {
      var tmp;
      if (this$0.hdx_1) {
        $this$layout.a98($placeable, $this$layout.w5e(this$0.ddx_1), $this$layout.w5e(this$0.edx_1));
        tmp = Unit_instance;
      } else {
        $this$layout.jal($placeable, $this$layout.w5e(this$0.ddx_1), $this$layout.w5e(this$0.edx_1));
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function PaddingNode(start, top, end, bottom, rtlAware) {
    var tmp;
    if (start === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = start;
    }
    start = tmp;
    var tmp_0;
    if (top === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_0 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_0 = top;
    }
    top = tmp_0;
    var tmp_1;
    if (end === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_1 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_1 = end;
    }
    end = tmp_1;
    var tmp_2;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp_2 = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp_2 = bottom;
    }
    bottom = tmp_2;
    Node.call(this);
    this.ddx_1 = start;
    this.edx_1 = top;
    this.fdx_1 = end;
    this.gdx_1 = bottom;
    this.hdx_1 = rtlAware;
  }
  protoOf(PaddingNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var horizontal = _this__u8e3s4.w5e(this.ddx_1) + _this__u8e3s4.w5e(this.fdx_1) | 0;
    var vertical = _this__u8e3s4.w5e(this.edx_1) + _this__u8e3s4.w5e(this.gdx_1) | 0;
    var placeable = measurable.h8y(offset(constraints, -horizontal | 0, -vertical | 0));
    var width = constrainWidth(constraints, placeable.i8y_1 + horizontal | 0);
    var height = constrainHeight(constraints, placeable.j8y_1 + vertical | 0);
    return _this__u8e3s4.n8y(width, height, VOID, PaddingNode$measure$lambda(this, placeable));
  };
  function PaddingValuesModifier$measure$lambda($placeable, $roundedLeftPadding, $roundedTopPadding) {
    return function ($this$layout) {
      $this$layout.jal($placeable, $roundedLeftPadding, $roundedTopPadding);
      return Unit_instance;
    };
  }
  function PaddingValuesModifier(paddingValues) {
    Node.call(this);
    this.ady_1 = paddingValues;
  }
  protoOf(PaddingValuesModifier).g8y = function (_this__u8e3s4, measurable, constraints) {
    var leftPadding = this.ady_1.adw(_this__u8e3s4.r6p());
    var topPadding = this.ady_1.fdw();
    var rightPadding = this.ady_1.zdv(_this__u8e3s4.r6p());
    var bottomPadding = this.ady_1.gdw();
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$0 = _Dp___init__impl__ms3zkb(0);
    var tmp = Dp__compareTo_impl_tlg3dl(leftPadding, tmp$ret$0) >= 0;
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$1 = _Dp___init__impl__ms3zkb(0);
    var tmp_0 = !!(tmp & Dp__compareTo_impl_tlg3dl(topPadding, tmp$ret$1) >= 0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$2 = _Dp___init__impl__ms3zkb(0);
    var tmp_1 = !!(tmp_0 & Dp__compareTo_impl_tlg3dl(rightPadding, tmp$ret$2) >= 0);
    // Inline function 'androidx.compose.ui.unit.dp' call
    var tmp$ret$3 = _Dp___init__impl__ms3zkb(0);
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!!!(tmp_1 & Dp__compareTo_impl_tlg3dl(bottomPadding, tmp$ret$3) >= 0)) {
      var tmp$ret$5 = 'Padding must be non-negative';
      throwIllegalArgumentException(tmp$ret$5);
    }
    var roundedLeftPadding = _this__u8e3s4.w5e(leftPadding);
    var horizontal = roundedLeftPadding + _this__u8e3s4.w5e(rightPadding) | 0;
    var roundedTopPadding = _this__u8e3s4.w5e(topPadding);
    var vertical = roundedTopPadding + _this__u8e3s4.w5e(bottomPadding) | 0;
    var placeable = measurable.h8y(offset(constraints, -horizontal | 0, -vertical | 0));
    var width = constrainWidth(constraints, placeable.i8y_1 + horizontal | 0);
    var height = constrainHeight(constraints, placeable.j8y_1 + vertical | 0);
    return _this__u8e3s4.n8y(width, height, VOID, PaddingValuesModifier$measure$lambda(placeable, roundedLeftPadding, roundedTopPadding));
  };
  function padding_2(_this__u8e3s4, all) {
    return _this__u8e3s4.d8v(new PaddingElement(all, all, all, all, true, padding$lambda_2(all)));
  }
  function padding$lambda($start, $top, $end, $bottom) {
    return function ($this$PaddingElement) {
      $this$PaddingElement.kdp_1 = 'padding';
      $this$PaddingElement.mdp_1.odp('start', new Dp($start));
      $this$PaddingElement.mdp_1.odp('top', new Dp($top));
      $this$PaddingElement.mdp_1.odp('end', new Dp($end));
      $this$PaddingElement.mdp_1.odp('bottom', new Dp($bottom));
      return Unit_instance;
    };
  }
  function padding$lambda_0($horizontal, $vertical) {
    return function ($this$PaddingElement) {
      $this$PaddingElement.kdp_1 = 'padding';
      $this$PaddingElement.mdp_1.odp('horizontal', new Dp($horizontal));
      $this$PaddingElement.mdp_1.odp('vertical', new Dp($vertical));
      return Unit_instance;
    };
  }
  function padding$lambda_1($paddingValues) {
    return function ($this$PaddingValuesElement) {
      $this$PaddingValuesElement.kdp_1 = 'padding';
      $this$PaddingValuesElement.mdp_1.odp('paddingValues', $paddingValues);
      return Unit_instance;
    };
  }
  function padding$lambda_2($all) {
    return function ($this$PaddingElement) {
      $this$PaddingElement.kdp_1 = 'padding';
      $this$PaddingElement.ldp_1 = new Dp($all);
      return Unit_instance;
    };
  }
  function get_DefaultRowMeasurePolicy() {
    _init_properties_Row_kt__jenljs();
    return DefaultRowMeasurePolicy;
  }
  var DefaultRowMeasurePolicy;
  var androidx_compose_foundation_layout_RowMeasurePolicy$stable;
  var androidx_compose_foundation_layout_RowScopeInstance$stable;
  function RowScope() {
  }
  function getCrossAxisPosition_0($this, placeable, parentData, crossAxisLayoutSize, beforeCrossAxisAlignmentLine) {
    var childCrossAlignment = parentData == null ? null : parentData.cdt_1;
    var tmp2_elvis_lhs = childCrossAlignment == null ? null : childCrossAlignment.hdt(crossAxisLayoutSize, $this.gdt(placeable), LayoutDirection_Ltr_getInstance(), placeable, beforeCrossAxisAlignmentLine);
    return tmp2_elvis_lhs == null ? $this.ddy_1.c8u($this.gdt(placeable), crossAxisLayoutSize) : tmp2_elvis_lhs;
  }
  function RowMeasurePolicy$placeHelper$lambda($placeables, this$0, $crossAxisLayoutSize, $beforeCrossAxisAlignmentLine, $mainAxisPositions) {
    return function ($this$layout) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var indexedObject = $placeables;
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var item = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        var crossAxisPosition = getCrossAxisPosition_0(this$0, ensureNotNull(item), get_rowColumnParentData(item), $crossAxisLayoutSize, $beforeCrossAxisAlignmentLine);
        $this$layout.jal(item, $mainAxisPositions[_unary__edvuaz], crossAxisPosition);
      }
      return Unit_instance;
    };
  }
  function RowMeasurePolicy(horizontalArrangement, verticalAlignment) {
    this.cdy_1 = horizontalArrangement;
    this.ddy_1 = verticalAlignment;
  }
  protoOf(RowMeasurePolicy).idt = function (_this__u8e3s4) {
    return _this__u8e3s4.i8y_1;
  };
  protoOf(RowMeasurePolicy).gdt = function (_this__u8e3s4) {
    return _this__u8e3s4.j8y_1;
  };
  protoOf(RowMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    var tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    var tmp_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    var tmp_1 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_2 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    var tmp_3 = _this__u8e3s4.w5e(this.cdy_1.zdp());
    // Inline function 'kotlin.arrayOfNulls' call
    var size = measurables.n1();
    var tmp$ret$0 = Array(size);
    return measure(this, tmp, tmp_0, tmp_1, tmp_2, tmp_3, _this__u8e3s4, measurables, tmp$ret$0, 0, measurables.n1());
  };
  protoOf(RowMeasurePolicy).jdt = function (mainAxisLayoutSize, childrenMainAxisSize, mainAxisPositions, measureScope) {
    // Inline function 'kotlin.with' call
    this.cdy_1.pdp(measureScope, mainAxisLayoutSize, childrenMainAxisSize, measureScope.r6p(), mainAxisPositions);
  };
  protoOf(RowMeasurePolicy).kdt = function (placeables, measureScope, beforeCrossAxisAlignmentLine, mainAxisPositions, mainAxisLayoutSize, crossAxisLayoutSize, crossAxisOffset, currentLineIndex, startIndex, endIndex) {
    // Inline function 'kotlin.with' call
    return measureScope.n8y(mainAxisLayoutSize, crossAxisLayoutSize, VOID, RowMeasurePolicy$placeHelper$lambda(placeables, this, crossAxisLayoutSize, beforeCrossAxisAlignmentLine, mainAxisPositions));
  };
  protoOf(RowMeasurePolicy).ldt = function (mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, isPrioritizing) {
    return createRowConstraints(isPrioritizing, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax);
  };
  protoOf(RowMeasurePolicy).nak = function (_this__u8e3s4, measurables, height) {
    return IntrinsicMeasureBlocks_instance.edy(measurables, height, _this__u8e3s4.w5e(this.cdy_1.zdp()));
  };
  protoOf(RowMeasurePolicy).oak = function (_this__u8e3s4, measurables, width) {
    return IntrinsicMeasureBlocks_instance.fdy(measurables, width, _this__u8e3s4.w5e(this.cdy_1.zdp()));
  };
  protoOf(RowMeasurePolicy).pak = function (_this__u8e3s4, measurables, height) {
    return IntrinsicMeasureBlocks_instance.gdy(measurables, height, _this__u8e3s4.w5e(this.cdy_1.zdp()));
  };
  protoOf(RowMeasurePolicy).qak = function (_this__u8e3s4, measurables, width) {
    return IntrinsicMeasureBlocks_instance.hdy(measurables, width, _this__u8e3s4.w5e(this.cdy_1.zdp()));
  };
  protoOf(RowMeasurePolicy).toString = function () {
    return 'RowMeasurePolicy(horizontalArrangement=' + toString_0(this.cdy_1) + ', verticalAlignment=' + toString_0(this.ddy_1) + ')';
  };
  protoOf(RowMeasurePolicy).hashCode = function () {
    var result = hashCode(this.cdy_1);
    result = imul(result, 31) + hashCode(this.ddy_1) | 0;
    return result;
  };
  protoOf(RowMeasurePolicy).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RowMeasurePolicy))
      return false;
    if (!equals(this.cdy_1, other.cdy_1))
      return false;
    if (!equals(this.ddy_1, other.ddy_1))
      return false;
    return true;
  };
  function rowMeasurePolicy(horizontalArrangement, verticalAlignment, $composer, $changed) {
    _init_properties_Row_kt__jenljs();
    var $composer_0 = $composer;
    var tmp;
    if (equals(horizontalArrangement, Arrangement_getInstance().qdp_1) && equals(verticalAlignment, Companion_getInstance_0().t8t_1)) {
      $composer_0.m30(-1073830487);
      $composer_0.n30();
      tmp = get_DefaultRowMeasurePolicy();
    } else {
      $composer_0.m30(-1073779616);
      // Inline function 'androidx.compose.runtime.cache' call
      var invalid = !!((($changed & 14 ^ 6) > 4 && $composer_0.k31(horizontalArrangement) || ($changed & 6) === 4) | (($changed & 112 ^ 48) > 32 && $composer_0.k31(verticalAlignment) || ($changed & 48) === 32));
      // Inline function 'kotlin.let' call
      var it = $composer_0.i31();
      var tmp_0;
      if (invalid || it === Companion_getInstance_3().f30_1) {
        var value = new RowMeasurePolicy(horizontalArrangement, verticalAlignment);
        $composer_0.j31(value);
        tmp_0 = value;
      } else {
        tmp_0 = it;
      }
      var tmp1_group = tmp_0;
      $composer_0.n30();
      tmp = tmp1_group;
    }
    return tmp;
  }
  function RowScopeInstance() {
  }
  protoOf(RowScopeInstance).xds = function (_this__u8e3s4, weight, fill) {
    // Inline function 'androidx.compose.foundation.layout.internal.requirePrecondition' call
    if (!(weight > 0.0)) {
      var tmp$ret$1 = 'invalid weight; must be greater than zero';
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _this__u8e3s4.d8v(new LayoutWeightElement(coerceAtMost(weight, 3.4028235E38), fill));
  };
  var RowScopeInstance_instance;
  function RowScopeInstance_getInstance() {
    return RowScopeInstance_instance;
  }
  function createRowConstraints(isPrioritizing, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax) {
    _init_properties_Row_kt__jenljs();
    var tmp;
    if (!isPrioritizing) {
      tmp = Constraints(mainAxisMin, mainAxisMax, crossAxisMin, crossAxisMax);
    } else {
      tmp = Companion_instance_0.s5e(mainAxisMin, mainAxisMax, crossAxisMin, crossAxisMax);
    }
    return tmp;
  }
  var properties_initialized_Row_kt_sbxnna;
  function _init_properties_Row_kt__jenljs() {
    if (!properties_initialized_Row_kt_sbxnna) {
      properties_initialized_Row_kt_sbxnna = true;
      DefaultRowMeasurePolicy = new RowMeasurePolicy(Arrangement_getInstance().qdp_1, Companion_getInstance_0().t8t_1);
      androidx_compose_foundation_layout_RowMeasurePolicy$stable = 0;
      androidx_compose_foundation_layout_RowScopeInstance$stable = 0;
    }
  }
  var androidx_compose_foundation_layout_CrossAxisAlignment$stable;
  var androidx_compose_foundation_layout_IntrinsicMeasureBlocks$stable;
  var androidx_compose_foundation_layout_LayoutWeightElement$stable;
  var androidx_compose_foundation_layout_LayoutWeightNode$stable;
  var androidx_compose_foundation_layout_WithAlignmentLineBlockElement$stable;
  var androidx_compose_foundation_layout_WithAlignmentLineElement$stable;
  var androidx_compose_foundation_layout_SiblingsAlignedNode_WithAlignmentLineBlockNode$stable;
  var androidx_compose_foundation_layout_SiblingsAlignedNode_WithAlignmentLineNode$stable;
  var androidx_compose_foundation_layout_SiblingsAlignedNode$stable;
  var androidx_compose_foundation_layout_HorizontalAlignElement$stable;
  var androidx_compose_foundation_layout_HorizontalAlignNode$stable;
  var androidx_compose_foundation_layout_VerticalAlignElement$stable;
  var androidx_compose_foundation_layout_VerticalAlignNode$stable;
  var androidx_compose_foundation_layout_RowColumnParentData$stable;
  var androidx_compose_foundation_layout_AlignmentLineProvider_Block$stable;
  var androidx_compose_foundation_layout_AlignmentLineProvider_Value$stable;
  var androidx_compose_foundation_layout_AlignmentLineProvider$stable;
  function RowColumnParentData(weight, fill, crossAxisAlignment, flowLayoutData) {
    weight = weight === VOID ? 0.0 : weight;
    fill = fill === VOID ? true : fill;
    crossAxisAlignment = crossAxisAlignment === VOID ? null : crossAxisAlignment;
    flowLayoutData = flowLayoutData === VOID ? null : flowLayoutData;
    this.adt_1 = weight;
    this.bdt_1 = fill;
    this.cdt_1 = crossAxisAlignment;
    this.ddt_1 = flowLayoutData;
  }
  protoOf(RowColumnParentData).toString = function () {
    return 'RowColumnParentData(weight=' + this.adt_1 + ', fill=' + this.bdt_1 + ', crossAxisAlignment=' + toString(this.cdt_1) + ', flowLayoutData=' + toString(this.ddt_1) + ')';
  };
  protoOf(RowColumnParentData).hashCode = function () {
    var result = getNumberHashCode(this.adt_1);
    result = imul(result, 31) + getBooleanHashCode(this.bdt_1) | 0;
    result = imul(result, 31) + (this.cdt_1 == null ? 0 : hashCode(this.cdt_1)) | 0;
    result = imul(result, 31) + (this.ddt_1 == null ? 0 : this.ddt_1.hashCode()) | 0;
    return result;
  };
  protoOf(RowColumnParentData).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RowColumnParentData))
      return false;
    if (!equals(this.adt_1, other.adt_1))
      return false;
    if (!(this.bdt_1 === other.bdt_1))
      return false;
    if (!equals(this.cdt_1, other.cdt_1))
      return false;
    if (!equals(this.ddt_1, other.ddt_1))
      return false;
    return true;
  };
  function get_rowColumnParentData(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    var tmp = _this__u8e3s4.xag();
    return tmp instanceof RowColumnParentData ? tmp : null;
  }
  function Companion() {
  }
  protoOf(Companion).idy = function (horizontal) {
    return new HorizontalCrossAxisAlignment(horizontal);
  };
  var Companion_instance_1;
  function Companion_getInstance_5() {
    return Companion_instance_1;
  }
  function HorizontalCrossAxisAlignment(horizontal) {
    CrossAxisAlignment.call(this);
    this.jdy_1 = horizontal;
  }
  protoOf(HorizontalCrossAxisAlignment).hdt = function (size, itemCrossAxisSize, layoutDirection, placeable, beforeCrossAxisAlignmentLine) {
    return this.jdy_1.a8u(itemCrossAxisSize, size, layoutDirection);
  };
  protoOf(HorizontalCrossAxisAlignment).toString = function () {
    return 'HorizontalCrossAxisAlignment(horizontal=' + toString_0(this.jdy_1) + ')';
  };
  protoOf(HorizontalCrossAxisAlignment).hashCode = function () {
    return hashCode(this.jdy_1);
  };
  protoOf(HorizontalCrossAxisAlignment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorizontalCrossAxisAlignment))
      return false;
    if (!equals(this.jdy_1, other.jdy_1))
      return false;
    return true;
  };
  function CrossAxisAlignment() {
  }
  protoOf(CrossAxisAlignment).kdy = function () {
    return false;
  };
  protoOf(CrossAxisAlignment).ldy = function (placeable) {
    return null;
  };
  function IntrinsicMeasureBlocks() {
  }
  protoOf(IntrinsicMeasureBlocks).edy = function (measurables, availableHeight, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicMainAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var weightUnitSpace = 0;
      var fixedSpace = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          var size = item.b98(availableHeight);
          if (weight === 0.0) {
            fixedSpace = fixedSpace + size | 0;
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
            var tmp0 = weightUnitSpace;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_0 = size / weight;
            var tmp;
            if (isNaN_0(this_0)) {
              tmp = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp = roundToInt(this_0);
            }
            // Inline function 'kotlin.math.max' call
            var b = tmp;
            weightUnitSpace = Math.max(tmp0, b);
          }
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = weightUnitSpace * totalWeight;
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      tmp$ret$0 = (tmp_0 + fixedSpace | 0) + imul(measurables.n1() - 1 | 0, mainAxisSpacing) | 0;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).ndt = function (measurables, availableHeight, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicCrossAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      // Inline function 'kotlin.math.min' call
      var a = imul(measurables.n1() - 1 | 0, mainAxisSpacing);
      var fixedSpace = Math.min(a, availableHeight);
      var crossAxisMax = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          if (weight === 0.0) {
            var remaining = availableHeight === 2147483647 ? 2147483647 : availableHeight - fixedSpace | 0;
            var w = 2147483647;
            // Inline function 'kotlin.math.min' call
            var a_0 = item.e98(w);
            var mainAxisSpace = Math.min(a_0, remaining);
            fixedSpace = fixedSpace + mainAxisSpace | 0;
            var tmp0 = crossAxisMax;
            // Inline function 'kotlin.math.max' call
            var b = item.b98(mainAxisSpace);
            crossAxisMax = Math.max(tmp0, b);
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
          }
        }
         while (inductionVariable <= last);
      var tmp;
      if (totalWeight === 0.0) {
        tmp = 0;
      } else if (availableHeight === 2147483647) {
        tmp = 2147483647;
      } else {
        // Inline function 'kotlin.math.max' call
        var a_1 = availableHeight - fixedSpace | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = Math.max(a_1, 0) / totalWeight;
        var tmp_0;
        if (isNaN_0(this_0)) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_0 = roundToInt(this_0);
        }
        tmp = tmp_0;
      }
      var weightUnitSpace = tmp;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = measurables.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = measurables.l1(index_0);
          var weight_0 = get_weight(get_rowColumnParentData_0(item_0));
          if (weight_0 > 0.0) {
            var tmp0_0 = crossAxisMax;
            var tmp_1;
            if (!(weightUnitSpace === 2147483647)) {
              // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
              var this_1 = weightUnitSpace * weight_0;
              var tmp_2;
              if (isNaN_0(this_1)) {
                tmp_2 = 0;
              } else {
                // Inline function 'kotlin.math.roundToInt' call
                tmp_2 = roundToInt(this_1);
              }
              tmp_1 = tmp_2;
            } else {
              tmp_1 = 2147483647;
            }
            var h = tmp_1;
            // Inline function 'kotlin.math.max' call
            var b_0 = item_0.b98(h);
            crossAxisMax = Math.max(tmp0_0, b_0);
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$0 = crossAxisMax;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).fdy = function (measurables, availableWidth, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicCrossAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      // Inline function 'kotlin.math.min' call
      var a = imul(measurables.n1() - 1 | 0, mainAxisSpacing);
      var fixedSpace = Math.min(a, availableWidth);
      var crossAxisMax = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          if (weight === 0.0) {
            var remaining = availableWidth === 2147483647 ? 2147483647 : availableWidth - fixedSpace | 0;
            var h = 2147483647;
            // Inline function 'kotlin.math.min' call
            var a_0 = item.c98(h);
            var mainAxisSpace = Math.min(a_0, remaining);
            fixedSpace = fixedSpace + mainAxisSpace | 0;
            var tmp0 = crossAxisMax;
            // Inline function 'kotlin.math.max' call
            var b = item.d98(mainAxisSpace);
            crossAxisMax = Math.max(tmp0, b);
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
          }
        }
         while (inductionVariable <= last);
      var tmp;
      if (totalWeight === 0.0) {
        tmp = 0;
      } else if (availableWidth === 2147483647) {
        tmp = 2147483647;
      } else {
        // Inline function 'kotlin.math.max' call
        var a_1 = availableWidth - fixedSpace | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = Math.max(a_1, 0) / totalWeight;
        var tmp_0;
        if (isNaN_0(this_0)) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_0 = roundToInt(this_0);
        }
        tmp = tmp_0;
      }
      var weightUnitSpace = tmp;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = measurables.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = measurables.l1(index_0);
          var weight_0 = get_weight(get_rowColumnParentData_0(item_0));
          if (weight_0 > 0.0) {
            var tmp0_0 = crossAxisMax;
            var tmp_1;
            if (!(weightUnitSpace === 2147483647)) {
              // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
              var this_1 = weightUnitSpace * weight_0;
              var tmp_2;
              if (isNaN_0(this_1)) {
                tmp_2 = 0;
              } else {
                // Inline function 'kotlin.math.roundToInt' call
                tmp_2 = roundToInt(this_1);
              }
              tmp_1 = tmp_2;
            } else {
              tmp_1 = 2147483647;
            }
            var w = tmp_1;
            // Inline function 'kotlin.math.max' call
            var b_0 = item_0.d98(w);
            crossAxisMax = Math.max(tmp0_0, b_0);
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$0 = crossAxisMax;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).odt = function (measurables, availableWidth, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicMainAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var weightUnitSpace = 0;
      var fixedSpace = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          var size = item.d98(availableWidth);
          if (weight === 0.0) {
            fixedSpace = fixedSpace + size | 0;
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
            var tmp0 = weightUnitSpace;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_0 = size / weight;
            var tmp;
            if (isNaN_0(this_0)) {
              tmp = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp = roundToInt(this_0);
            }
            // Inline function 'kotlin.math.max' call
            var b = tmp;
            weightUnitSpace = Math.max(tmp0, b);
          }
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = weightUnitSpace * totalWeight;
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      tmp$ret$0 = (tmp_0 + fixedSpace | 0) + imul(measurables.n1() - 1 | 0, mainAxisSpacing) | 0;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).gdy = function (measurables, availableHeight, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicMainAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var weightUnitSpace = 0;
      var fixedSpace = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          var size = item.c98(availableHeight);
          if (weight === 0.0) {
            fixedSpace = fixedSpace + size | 0;
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
            var tmp0 = weightUnitSpace;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_0 = size / weight;
            var tmp;
            if (isNaN_0(this_0)) {
              tmp = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp = roundToInt(this_0);
            }
            // Inline function 'kotlin.math.max' call
            var b = tmp;
            weightUnitSpace = Math.max(tmp0, b);
          }
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = weightUnitSpace * totalWeight;
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      tmp$ret$0 = (tmp_0 + fixedSpace | 0) + imul(measurables.n1() - 1 | 0, mainAxisSpacing) | 0;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).pdt = function (measurables, availableHeight, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicCrossAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      // Inline function 'kotlin.math.min' call
      var a = imul(measurables.n1() - 1 | 0, mainAxisSpacing);
      var fixedSpace = Math.min(a, availableHeight);
      var crossAxisMax = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          if (weight === 0.0) {
            var remaining = availableHeight === 2147483647 ? 2147483647 : availableHeight - fixedSpace | 0;
            var w = 2147483647;
            // Inline function 'kotlin.math.min' call
            var a_0 = item.e98(w);
            var mainAxisSpace = Math.min(a_0, remaining);
            fixedSpace = fixedSpace + mainAxisSpace | 0;
            var tmp0 = crossAxisMax;
            // Inline function 'kotlin.math.max' call
            var b = item.c98(mainAxisSpace);
            crossAxisMax = Math.max(tmp0, b);
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
          }
        }
         while (inductionVariable <= last);
      var tmp;
      if (totalWeight === 0.0) {
        tmp = 0;
      } else if (availableHeight === 2147483647) {
        tmp = 2147483647;
      } else {
        // Inline function 'kotlin.math.max' call
        var a_1 = availableHeight - fixedSpace | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = Math.max(a_1, 0) / totalWeight;
        var tmp_0;
        if (isNaN_0(this_0)) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_0 = roundToInt(this_0);
        }
        tmp = tmp_0;
      }
      var weightUnitSpace = tmp;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = measurables.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = measurables.l1(index_0);
          var weight_0 = get_weight(get_rowColumnParentData_0(item_0));
          if (weight_0 > 0.0) {
            var tmp0_0 = crossAxisMax;
            var tmp_1;
            if (!(weightUnitSpace === 2147483647)) {
              // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
              var this_1 = weightUnitSpace * weight_0;
              var tmp_2;
              if (isNaN_0(this_1)) {
                tmp_2 = 0;
              } else {
                // Inline function 'kotlin.math.roundToInt' call
                tmp_2 = roundToInt(this_1);
              }
              tmp_1 = tmp_2;
            } else {
              tmp_1 = 2147483647;
            }
            var h = tmp_1;
            // Inline function 'kotlin.math.max' call
            var b_0 = item_0.c98(h);
            crossAxisMax = Math.max(tmp0_0, b_0);
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$0 = crossAxisMax;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).hdy = function (measurables, availableWidth, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicCrossAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      // Inline function 'kotlin.math.min' call
      var a = imul(measurables.n1() - 1 | 0, mainAxisSpacing);
      var fixedSpace = Math.min(a, availableWidth);
      var crossAxisMax = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          if (weight === 0.0) {
            var remaining = availableWidth === 2147483647 ? 2147483647 : availableWidth - fixedSpace | 0;
            var h = 2147483647;
            // Inline function 'kotlin.math.min' call
            var a_0 = item.c98(h);
            var mainAxisSpace = Math.min(a_0, remaining);
            fixedSpace = fixedSpace + mainAxisSpace | 0;
            var tmp0 = crossAxisMax;
            // Inline function 'kotlin.math.max' call
            var b = item.e98(mainAxisSpace);
            crossAxisMax = Math.max(tmp0, b);
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
          }
        }
         while (inductionVariable <= last);
      var tmp;
      if (totalWeight === 0.0) {
        tmp = 0;
      } else if (availableWidth === 2147483647) {
        tmp = 2147483647;
      } else {
        // Inline function 'kotlin.math.max' call
        var a_1 = availableWidth - fixedSpace | 0;
        // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
        var this_0 = Math.max(a_1, 0) / totalWeight;
        var tmp_0;
        if (isNaN_0(this_0)) {
          tmp_0 = 0;
        } else {
          // Inline function 'kotlin.math.roundToInt' call
          tmp_0 = roundToInt(this_0);
        }
        tmp = tmp_0;
      }
      var weightUnitSpace = tmp;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable_0 = 0;
      var last_0 = measurables.n1() - 1 | 0;
      if (inductionVariable_0 <= last_0)
        do {
          var index_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var item_0 = measurables.l1(index_0);
          var weight_0 = get_weight(get_rowColumnParentData_0(item_0));
          if (weight_0 > 0.0) {
            var tmp0_0 = crossAxisMax;
            var tmp_1;
            if (!(weightUnitSpace === 2147483647)) {
              // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
              var this_1 = weightUnitSpace * weight_0;
              var tmp_2;
              if (isNaN_0(this_1)) {
                tmp_2 = 0;
              } else {
                // Inline function 'kotlin.math.roundToInt' call
                tmp_2 = roundToInt(this_1);
              }
              tmp_1 = tmp_2;
            } else {
              tmp_1 = 2147483647;
            }
            var w = tmp_1;
            // Inline function 'kotlin.math.max' call
            var b_0 = item_0.e98(w);
            crossAxisMax = Math.max(tmp0_0, b_0);
          }
        }
         while (inductionVariable_0 <= last_0);
      tmp$ret$0 = crossAxisMax;
    }
    return tmp$ret$0;
  };
  protoOf(IntrinsicMeasureBlocks).qdt = function (measurables, availableWidth, mainAxisSpacing) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'androidx.compose.foundation.layout.intrinsicMainAxisSize' call
      if (measurables.r()) {
        tmp$ret$0 = 0;
        break $l$block;
      }
      var weightUnitSpace = 0;
      var fixedSpace = 0;
      var totalWeight = 0.0;
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = measurables.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = measurables.l1(index);
          var weight = get_weight(get_rowColumnParentData_0(item));
          var size = item.e98(availableWidth);
          if (weight === 0.0) {
            fixedSpace = fixedSpace + size | 0;
          } else if (weight > 0.0) {
            totalWeight = totalWeight + weight;
            var tmp0 = weightUnitSpace;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var this_0 = size / weight;
            var tmp;
            if (isNaN_0(this_0)) {
              tmp = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp = roundToInt(this_0);
            }
            // Inline function 'kotlin.math.max' call
            var b = tmp;
            weightUnitSpace = Math.max(tmp0, b);
          }
        }
         while (inductionVariable <= last);
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_1 = weightUnitSpace * totalWeight;
      var tmp_0;
      if (isNaN_0(this_1)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_1);
      }
      tmp$ret$0 = (tmp_0 + fixedSpace | 0) + imul(measurables.n1() - 1 | 0, mainAxisSpacing) | 0;
    }
    return tmp$ret$0;
  };
  var IntrinsicMeasureBlocks_instance;
  function IntrinsicMeasureBlocks_getInstance() {
    return IntrinsicMeasureBlocks_instance;
  }
  function LayoutWeightElement(weight, fill) {
    ModifierNodeElement.call(this);
    this.ndy_1 = weight;
    this.ody_1 = fill;
  }
  protoOf(LayoutWeightElement).r3d = function () {
    return new LayoutWeightNode(this.ndy_1, this.ody_1);
  };
  protoOf(LayoutWeightElement).pdy = function (node) {
    node.edz_1 = this.ndy_1;
    node.fdz_1 = this.ody_1;
  };
  protoOf(LayoutWeightElement).d8y = function (node) {
    return this.pdy(node instanceof LayoutWeightNode ? node : THROW_CCE());
  };
  protoOf(LayoutWeightElement).hashCode = function () {
    var result = getNumberHashCode(this.ndy_1);
    result = imul(31, result) + getBooleanHashCode(this.ody_1) | 0;
    return result;
  };
  protoOf(LayoutWeightElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof LayoutWeightElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return this.ndy_1 === otherModifier.ndy_1 && this.ody_1 === otherModifier.ody_1;
  };
  function HorizontalAlignElement(horizontal) {
    ModifierNodeElement.call(this);
    this.hdz_1 = horizontal;
  }
  protoOf(HorizontalAlignElement).r3d = function () {
    return new HorizontalAlignNode(this.hdz_1);
  };
  protoOf(HorizontalAlignElement).idz = function (node) {
    node.xdz_1 = this.hdz_1;
  };
  protoOf(HorizontalAlignElement).d8y = function (node) {
    return this.idz(node instanceof HorizontalAlignNode ? node : THROW_CCE());
  };
  protoOf(HorizontalAlignElement).hashCode = function () {
    return hashCode(this.hdz_1);
  };
  protoOf(HorizontalAlignElement).equals = function (other) {
    if (this === other)
      return true;
    var tmp0_elvis_lhs = other instanceof HorizontalAlignElement ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherModifier = tmp;
    return equals(this.hdz_1, otherModifier.hdz_1);
  };
  function LayoutWeightNode(weight, fill) {
    Node.call(this);
    this.edz_1 = weight;
    this.fdz_1 = fill;
  }
  protoOf(LayoutWeightNode).aaj = function (_this__u8e3s4, parentData) {
    var tmp0_elvis_lhs = parentData instanceof RowColumnParentData ? parentData : null;
    // Inline function 'kotlin.also' call
    var this_0 = tmp0_elvis_lhs == null ? new RowColumnParentData() : tmp0_elvis_lhs;
    this_0.adt_1 = this.edz_1;
    this_0.bdt_1 = this.fdz_1;
    return this_0;
  };
  function HorizontalAlignNode(horizontal) {
    Node.call(this);
    this.xdz_1 = horizontal;
  }
  protoOf(HorizontalAlignNode).aaj = function (_this__u8e3s4, parentData) {
    var tmp0_elvis_lhs = parentData instanceof RowColumnParentData ? parentData : null;
    // Inline function 'kotlin.also' call
    var this_0 = tmp0_elvis_lhs == null ? new RowColumnParentData() : tmp0_elvis_lhs;
    this_0.cdt_1 = Companion_instance_1.idy(this.xdz_1);
    return this_0;
  };
  function get_weight(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.adt_1;
    return tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  }
  function get_rowColumnParentData_0(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    var tmp = _this__u8e3s4.xag();
    return tmp instanceof RowColumnParentData ? tmp : null;
  }
  function get_isRelative(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    var tmp0_safe_receiver = get_crossAxisAlignment(_this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kdy();
    return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  }
  function get_fill(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    var tmp1_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.bdt_1;
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  }
  function get_crossAxisAlignment(_this__u8e3s4) {
    _init_properties_RowColumnImpl_kt__c7pbaa();
    return _this__u8e3s4 == null ? null : _this__u8e3s4.cdt_1;
  }
  var properties_initialized_RowColumnImpl_kt_57qerk;
  function _init_properties_RowColumnImpl_kt__c7pbaa() {
    if (!properties_initialized_RowColumnImpl_kt_57qerk) {
      properties_initialized_RowColumnImpl_kt_57qerk = true;
      androidx_compose_foundation_layout_CrossAxisAlignment$stable = 0;
      androidx_compose_foundation_layout_IntrinsicMeasureBlocks$stable = 0;
      androidx_compose_foundation_layout_LayoutWeightElement$stable = 0;
      androidx_compose_foundation_layout_LayoutWeightNode$stable = 8;
      androidx_compose_foundation_layout_WithAlignmentLineBlockElement$stable = 0;
      androidx_compose_foundation_layout_WithAlignmentLineElement$stable = 0;
      androidx_compose_foundation_layout_SiblingsAlignedNode_WithAlignmentLineBlockNode$stable = 8;
      androidx_compose_foundation_layout_SiblingsAlignedNode_WithAlignmentLineNode$stable = 8;
      androidx_compose_foundation_layout_SiblingsAlignedNode$stable = androidx_compose_ui_Modifier_Node$stableprop_getter();
      androidx_compose_foundation_layout_HorizontalAlignElement$stable = 0;
      androidx_compose_foundation_layout_HorizontalAlignNode$stable = 8;
      androidx_compose_foundation_layout_VerticalAlignElement$stable = 0;
      androidx_compose_foundation_layout_VerticalAlignNode$stable = 8;
      androidx_compose_foundation_layout_RowColumnParentData$stable = 8;
      androidx_compose_foundation_layout_AlignmentLineProvider_Block$stable = 8;
      androidx_compose_foundation_layout_AlignmentLineProvider_Value$stable = 0;
      androidx_compose_foundation_layout_AlignmentLineProvider$stable = 0;
    }
  }
  function RowColumnMeasurePolicy() {
  }
  function measure(_this__u8e3s4, mainAxisMin, crossAxisMin, mainAxisMax, crossAxisMax, arrangementSpacingInt, measureScope, measurables, placeables, startIndex, endIndex, crossAxisOffset, currentLineIndex) {
    crossAxisOffset = crossAxisOffset === VOID ? null : crossAxisOffset;
    currentLineIndex = currentLineIndex === VOID ? 0 : currentLineIndex;
    var arrangementSpacingPx = fromInt(arrangementSpacingInt);
    var totalWeight = 0.0;
    var fixedSpace = 0;
    var crossAxisSpace = 0;
    var weightChildrenCount = 0;
    var anyAlignBy = false;
    var subSize = endIndex - startIndex | 0;
    var childrenMainAxisSize = new Int32Array(subSize);
    var beforeCrossAxisAlignmentLine = 0;
    var afterCrossAxisAlignmentLine = 0;
    var spaceAfterLastNoWeight = 0;
    var inductionVariable = startIndex;
    if (inductionVariable < endIndex)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var child = measurables.l1(i);
        var parentData = get_rowColumnParentData_0(child);
        var weight = get_weight(parentData);
        anyAlignBy = anyAlignBy || get_isRelative(parentData);
        if (weight > 0.0) {
          totalWeight = totalWeight + weight;
          weightChildrenCount = weightChildrenCount + 1 | 0;
        } else {
          var tmp;
          if (crossAxisMax === 2147483647) {
            tmp = null;
          } else {
            var tmp1_safe_receiver = parentData == null ? null : parentData.ddt_1;
            var tmp_0;
            if (tmp1_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
              var this_0 = tmp1_safe_receiver.ydz_1 * crossAxisMax;
              var tmp_1;
              if (isNaN_0(this_0)) {
                tmp_1 = 0;
              } else {
                // Inline function 'kotlin.math.roundToInt' call
                tmp_1 = roundToInt(this_0);
              }
              tmp_0 = tmp_1;
            }
            tmp = tmp_0;
          }
          var crossAxisDesiredSize = tmp;
          var remaining = mainAxisMax - fixedSpace | 0;
          var tmp2_elvis_lhs = placeables[i];
          var tmp_2;
          if (tmp2_elvis_lhs == null) {
            var tmp_3 = crossAxisDesiredSize == null ? 0 : crossAxisDesiredSize;
            var tmp_4;
            if (mainAxisMax === 2147483647) {
              tmp_4 = 2147483647;
            } else {
              // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
              tmp_4 = remaining < 0 ? 0 : remaining;
            }
            var tmp_5 = tmp_4;
            tmp_2 = child.h8y(_this__u8e3s4.mdt(0, tmp_3, tmp_5, crossAxisDesiredSize == null ? crossAxisMax : crossAxisDesiredSize));
          } else {
            tmp_2 = tmp2_elvis_lhs;
          }
          var placeable = tmp_2;
          var placeableMainAxisSize = _this__u8e3s4.idt(placeable);
          var placeableCrossAxisSize = _this__u8e3s4.gdt(placeable);
          childrenMainAxisSize[i - startIndex | 0] = placeableMainAxisSize;
          // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
          var this_1 = remaining - placeableMainAxisSize | 0;
          // Inline function 'kotlin.math.min' call
          var b = this_1 < 0 ? 0 : this_1;
          spaceAfterLastNoWeight = Math.min(arrangementSpacingInt, b);
          fixedSpace = fixedSpace + (placeableMainAxisSize + spaceAfterLastNoWeight | 0) | 0;
          // Inline function 'kotlin.math.max' call
          var a = crossAxisSpace;
          crossAxisSpace = Math.max(a, placeableCrossAxisSize);
          placeables[i] = placeable;
        }
      }
       while (inductionVariable < endIndex);
    var weightedSpace = 0;
    if (weightChildrenCount === 0) {
      fixedSpace = fixedSpace - spaceAfterLastNoWeight | 0;
    } else {
      var tmp_6;
      if (!(mainAxisMax === 2147483647)) {
        tmp_6 = mainAxisMax;
      } else {
        tmp_6 = mainAxisMin;
      }
      var targetSpace = tmp_6;
      // Inline function 'kotlin.Long.times' call
      var other = weightChildrenCount - 1 | 0;
      var arrangementSpacingTotal = multiply(arrangementSpacingPx, fromInt(other));
      var tmp0 = subtract(numberToLong(targetSpace - fixedSpace | 0), arrangementSpacingTotal);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var minimumValue = new Long(0, 0);
      var remainingToTarget = compare(tmp0, minimumValue) < 0 ? minimumValue : tmp0;
      // Inline function 'kotlin.Long.div' call
      var other_0 = totalWeight;
      var weightUnitSpace = toNumber(remainingToTarget) / other_0;
      var remainder = remainingToTarget;
      var inductionVariable_0 = startIndex;
      if (inductionVariable_0 < endIndex)
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var measurable = measurables.l1(i_0);
          var itemWeight = get_weight(get_rowColumnParentData_0(measurable));
          var weightedSize = weightUnitSpace * itemWeight;
          var tmp0_0 = remainder;
          // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
          var tmp_7;
          if (isNaN_0(weightedSize)) {
            tmp_7 = 0;
          } else {
            // Inline function 'kotlin.math.roundToInt' call
            tmp_7 = roundToInt(weightedSize);
          }
          // Inline function 'kotlin.Long.minus' call
          var other_1 = tmp_7;
          remainder = subtract(tmp0_0, fromInt(other_1));
        }
         while (inductionVariable_0 < endIndex);
      var inductionVariable_1 = startIndex;
      if (inductionVariable_1 < endIndex)
        do {
          var i_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          if (placeables[i_1] == null) {
            var child_0 = measurables.l1(i_1);
            var parentData_0 = get_rowColumnParentData_0(child_0);
            var weight_0 = get_weight(parentData_0);
            var tmp_8;
            if (crossAxisMax === 2147483647) {
              tmp_8 = null;
            } else {
              var tmp6_safe_receiver = parentData_0 == null ? null : parentData_0.ddt_1;
              var tmp_9;
              if (tmp6_safe_receiver == null) {
                tmp_9 = null;
              } else {
                // Inline function 'kotlin.let' call
                // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
                var this_2 = tmp6_safe_receiver.ydz_1 * crossAxisMax;
                var tmp_10;
                if (isNaN_0(this_2)) {
                  tmp_10 = 0;
                } else {
                  // Inline function 'kotlin.math.roundToInt' call
                  tmp_10 = roundToInt(this_2);
                }
                tmp_9 = tmp_10;
              }
              tmp_8 = tmp_9;
            }
            var crossAxisDesiredSize_0 = tmp_8;
            // Inline function 'androidx.compose.foundation.layout.internal.checkPrecondition' call
            if (!(weight_0 > 0)) {
              var tmp$ret$19 = 'All weights <= 0 should have placeables';
              throwIllegalStateException(tmp$ret$19);
            }
            var remainderUnit = get_sign(remainder);
            // Inline function 'kotlin.Long.minus' call
            var this_3 = remainder;
            remainder = subtract(this_3, fromInt(remainderUnit));
            var weightedSize_0 = weightUnitSpace * weight_0;
            // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
            var tmp_11;
            if (isNaN_0(weightedSize_0)) {
              tmp_11 = 0;
            } else {
              // Inline function 'kotlin.math.roundToInt' call
              tmp_11 = roundToInt(weightedSize_0);
            }
            // Inline function 'kotlin.math.max' call
            var b_0 = tmp_11 + remainderUnit | 0;
            var childMainAxisSize = Math.max(0, b_0);
            var tmp_12;
            if (get_fill(parentData_0) && !(childMainAxisSize === 2147483647)) {
              tmp_12 = childMainAxisSize;
            } else {
              tmp_12 = 0;
            }
            var tmp_13 = tmp_12;
            var tmp_14 = crossAxisDesiredSize_0 == null ? 0 : crossAxisDesiredSize_0;
            var childConstraints = _this__u8e3s4.ldt(tmp_13, tmp_14, childMainAxisSize, crossAxisDesiredSize_0 == null ? crossAxisMax : crossAxisDesiredSize_0, true);
            var placeable_0 = child_0.h8y(childConstraints);
            var placeableMainAxisSize_0 = _this__u8e3s4.idt(placeable_0);
            var placeableCrossAxisSize_0 = _this__u8e3s4.gdt(placeable_0);
            childrenMainAxisSize[i_1 - startIndex | 0] = placeableMainAxisSize_0;
            weightedSpace = weightedSpace + placeableMainAxisSize_0 | 0;
            // Inline function 'kotlin.math.max' call
            var a_0 = crossAxisSpace;
            crossAxisSpace = Math.max(a_0, placeableCrossAxisSize_0);
            placeables[i_1] = placeable_0;
          }
        }
         while (inductionVariable_1 < endIndex);
      var tmp0_1 = convertToInt(add(numberToLong(weightedSpace), arrangementSpacingTotal));
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue = mainAxisMax - fixedSpace | 0;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_4 = tmp0_1 < 0 ? 0 : tmp0_1;
      weightedSpace = this_4 > maximumValue ? maximumValue : this_4;
    }
    if (anyAlignBy) {
      var inductionVariable_2 = startIndex;
      if (inductionVariable_2 < endIndex)
        do {
          var i_2 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var placeable_1 = placeables[i_2];
          var parentData_1 = get_rowColumnParentData(ensureNotNull(placeable_1));
          var tmp9_safe_receiver = get_crossAxisAlignment(parentData_1);
          var alignmentLinePosition = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.ldy(placeable_1);
          if (alignmentLinePosition == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var placeableCrossAxisSize_1 = _this__u8e3s4.gdt(placeable_1);
            var tmp0_2 = beforeCrossAxisAlignmentLine;
            // Inline function 'kotlin.math.max' call
            var b_1 = !(alignmentLinePosition === -2147483648) ? alignmentLinePosition : 0;
            beforeCrossAxisAlignmentLine = Math.max(tmp0_2, b_1);
            var tmp0_3 = afterCrossAxisAlignmentLine;
            var tmp_15;
            if (!(alignmentLinePosition === -2147483648)) {
              tmp_15 = alignmentLinePosition;
            } else {
              tmp_15 = placeableCrossAxisSize_1;
            }
            // Inline function 'kotlin.math.max' call
            var b_2 = placeableCrossAxisSize_1 - tmp_15 | 0;
            afterCrossAxisAlignmentLine = Math.max(tmp0_3, b_2);
          }
        }
         while (inductionVariable_2 < endIndex);
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_5 = fixedSpace + weightedSpace | 0;
    // Inline function 'kotlin.math.max' call
    var a_1 = this_5 < 0 ? 0 : this_5;
    var mainAxisLayoutSize = Math.max(a_1, mainAxisMin);
    var tmp0_4 = crossAxisSpace;
    // Inline function 'kotlin.comparisons.maxOf' call
    var c = beforeCrossAxisAlignmentLine + afterCrossAxisAlignmentLine | 0;
    var crossAxisLayoutSize = Math.max(tmp0_4, crossAxisMin, c);
    var mainAxisPositions = new Int32Array(subSize);
    _this__u8e3s4.jdt(mainAxisLayoutSize, childrenMainAxisSize, mainAxisPositions, measureScope);
    return _this__u8e3s4.kdt(placeables, measureScope, beforeCrossAxisAlignmentLine, mainAxisPositions, mainAxisLayoutSize, crossAxisLayoutSize, crossAxisOffset, currentLineIndex, startIndex, endIndex);
  }
  function get_FillWholeMaxWidth() {
    _init_properties_Size_kt__jcru8v();
    return FillWholeMaxWidth;
  }
  var FillWholeMaxWidth;
  function get_FillWholeMaxHeight() {
    _init_properties_Size_kt__jcru8v();
    return FillWholeMaxHeight;
  }
  var FillWholeMaxHeight;
  function get_FillWholeMaxSize() {
    _init_properties_Size_kt__jcru8v();
    return FillWholeMaxSize;
  }
  var FillWholeMaxSize;
  function get_WrapContentWidthCenter() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentWidthCenter;
  }
  var WrapContentWidthCenter;
  function get_WrapContentWidthStart() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentWidthStart;
  }
  var WrapContentWidthStart;
  function get_WrapContentHeightCenter() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentHeightCenter;
  }
  var WrapContentHeightCenter;
  function get_WrapContentHeightTop() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentHeightTop;
  }
  var WrapContentHeightTop;
  function get_WrapContentSizeCenter() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentSizeCenter;
  }
  var WrapContentSizeCenter;
  function get_WrapContentSizeTopStart() {
    _init_properties_Size_kt__jcru8v();
    return WrapContentSizeTopStart;
  }
  var WrapContentSizeTopStart;
  function wrapContentHeight(_this__u8e3s4, align, unbounded) {
    align = align === VOID ? Companion_getInstance_0().u8t_1 : align;
    unbounded = unbounded === VOID ? false : unbounded;
    _init_properties_Size_kt__jcru8v();
    var tmp;
    if (equals(align, Companion_getInstance_0().u8t_1) && !unbounded) {
      tmp = get_WrapContentHeightCenter();
    } else if (equals(align, Companion_getInstance_0().t8t_1) && !unbounded) {
      tmp = get_WrapContentHeightTop();
    } else {
      tmp = Companion_instance_3.zdz(align, unbounded);
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function fillMaxWidth(_this__u8e3s4, fraction) {
    fraction = fraction === VOID ? 1.0 : fraction;
    _init_properties_Size_kt__jcru8v();
    return _this__u8e3s4.d8v(fraction === 1.0 ? get_FillWholeMaxWidth() : Companion_instance_2.ae0(fraction));
  }
  function sizeIn(_this__u8e3s4, minWidth, minHeight, maxWidth, maxHeight) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    maxWidth = maxWidth === VOID ? Companion_getInstance().p5f_1 : maxWidth;
    maxHeight = maxHeight === VOID ? Companion_getInstance().p5f_1 : maxHeight;
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = sizeIn$lambda(minWidth, minHeight, maxWidth, maxHeight);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(minWidth, minHeight, maxWidth, maxHeight, true, tmp$ret$0));
  }
  function size(_this__u8e3s4, size) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = size$lambda(size);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return _this__u8e3s4.d8v(new SizeElement(size, size, size, size, true, tmp0_inspectorInfo));
  }
  function defaultMinSize(_this__u8e3s4, minWidth, minHeight) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    _init_properties_Size_kt__jcru8v();
    return _this__u8e3s4.d8v(new UnspecifiedConstraintsElement(minWidth, minHeight));
  }
  function widthIn(_this__u8e3s4, min, max) {
    min = min === VOID ? Companion_getInstance().p5f_1 : min;
    max = max === VOID ? Companion_getInstance().p5f_1 : max;
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = widthIn$lambda(min, max);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(min, VOID, max, VOID, true, tmp$ret$0));
  }
  function fillMaxHeight(_this__u8e3s4, fraction) {
    fraction = fraction === VOID ? 1.0 : fraction;
    _init_properties_Size_kt__jcru8v();
    return _this__u8e3s4.d8v(fraction === 1.0 ? get_FillWholeMaxHeight() : Companion_instance_2.be0(fraction));
  }
  function height(_this__u8e3s4, height) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = height$lambda(height);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(VOID, height, VOID, height, true, tmp$ret$0));
  }
  function fillMaxSize(_this__u8e3s4, fraction) {
    fraction = fraction === VOID ? 1.0 : fraction;
    _init_properties_Size_kt__jcru8v();
    return _this__u8e3s4.d8v(fraction === 1.0 ? get_FillWholeMaxSize() : Companion_instance_2.ce0(fraction));
  }
  function heightIn(_this__u8e3s4, min, max) {
    min = min === VOID ? Companion_getInstance().p5f_1 : min;
    max = max === VOID ? Companion_getInstance().p5f_1 : max;
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = heightIn$lambda(min, max);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(VOID, min, VOID, max, true, tmp$ret$0));
  }
  function Companion_0() {
  }
  protoOf(Companion_0).ae0 = function (fraction) {
    return new FillElement(Direction_Horizontal_getInstance(), fraction, 'fillMaxWidth');
  };
  protoOf(Companion_0).be0 = function (fraction) {
    return new FillElement(Direction_Vertical_getInstance(), fraction, 'fillMaxHeight');
  };
  protoOf(Companion_0).ce0 = function (fraction) {
    return new FillElement(Direction_Both_getInstance(), fraction, 'fillMaxSize');
  };
  var Companion_instance_2;
  function Companion_getInstance_6() {
    return Companion_instance_2;
  }
  function FillElement(direction, fraction, inspectorName) {
    ModifierNodeElement.call(this);
    this.ee0_1 = direction;
    this.fe0_1 = fraction;
    this.ge0_1 = inspectorName;
  }
  protoOf(FillElement).r3d = function () {
    return new FillNode(this.ee0_1, this.fe0_1);
  };
  protoOf(FillElement).he0 = function (node) {
    node.we0_1 = this.ee0_1;
    node.xe0_1 = this.fe0_1;
  };
  protoOf(FillElement).d8y = function (node) {
    return this.he0(node instanceof FillNode ? node : THROW_CCE());
  };
  protoOf(FillElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof FillElement))
      return false;
    if (!this.ee0_1.equals(other.ee0_1))
      return false;
    if (!(this.fe0_1 === other.fe0_1))
      return false;
    return true;
  };
  protoOf(FillElement).hashCode = function () {
    var result = this.ee0_1.hashCode();
    result = imul(31, result) + getNumberHashCode(this.fe0_1) | 0;
    return result;
  };
  function WrapContentElement$Companion$width$lambda($align) {
    return function (size, layoutDirection) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      var this_0 = size.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(shiftRight(value, 32));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val1 = $align.a8u(0, tmp$ret$0, layoutDirection);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(val1), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function WrapContentElement$Companion$height$lambda($align) {
    return function (size, _unused_var__etf5q3) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      var this_0 = size.o5g_1;
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value = _IntSize___get_packedValue__impl__uho7jf(this_0);
      var tmp$ret$0 = convertToInt(bitwiseAnd(value, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.unit.IntOffset' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $align.c8u(0, tmp$ret$0);
      var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$2 = _IntOffset___init__impl__rq8h7b(tmp$ret$3);
      return new IntOffset(tmp$ret$2);
    };
  }
  function WrapContentElement$Companion$size$lambda($align) {
    return function (size, layoutDirection) {
      return new IntOffset($align.f8u(Companion_getInstance_1().n5g_1, size.o5g_1, layoutDirection));
    };
  }
  function Companion_1() {
  }
  protoOf(Companion_1).ye0 = function (align, unbounded) {
    var tmp = Direction_Horizontal_getInstance();
    return new WrapContentElement(tmp, unbounded, WrapContentElement$Companion$width$lambda(align), align, 'wrapContentWidth');
  };
  protoOf(Companion_1).zdz = function (align, unbounded) {
    var tmp = Direction_Vertical_getInstance();
    return new WrapContentElement(tmp, unbounded, WrapContentElement$Companion$height$lambda(align), align, 'wrapContentHeight');
  };
  protoOf(Companion_1).ze0 = function (align, unbounded) {
    var tmp = Direction_Both_getInstance();
    return new WrapContentElement(tmp, unbounded, WrapContentElement$Companion$size$lambda(align), align, 'wrapContentSize');
  };
  var Companion_instance_3;
  function Companion_getInstance_7() {
    return Companion_instance_3;
  }
  function WrapContentElement(direction, unbounded, alignmentCallback, align, inspectorName) {
    ModifierNodeElement.call(this);
    this.be1_1 = direction;
    this.ce1_1 = unbounded;
    this.de1_1 = alignmentCallback;
    this.ee1_1 = align;
    this.fe1_1 = inspectorName;
  }
  protoOf(WrapContentElement).r3d = function () {
    return new WrapContentNode(this.be1_1, this.ce1_1, this.de1_1);
  };
  protoOf(WrapContentElement).ge1 = function (node) {
    node.ve1_1 = this.be1_1;
    node.we1_1 = this.ce1_1;
    node.xe1_1 = this.de1_1;
  };
  protoOf(WrapContentElement).d8y = function (node) {
    return this.ge1(node instanceof WrapContentNode ? node : THROW_CCE());
  };
  protoOf(WrapContentElement).equals = function (other) {
    if (this === other)
      return true;
    if (other === null)
      return false;
    if (!getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof WrapContentElement))
      THROW_CCE();
    if (!this.be1_1.equals(other.be1_1))
      return false;
    if (!(this.ce1_1 === other.ce1_1))
      return false;
    if (!equals(this.ee1_1, other.ee1_1))
      return false;
    return true;
  };
  protoOf(WrapContentElement).hashCode = function () {
    var result = this.be1_1.hashCode();
    result = imul(31, result) + getBooleanHashCode(this.ce1_1) | 0;
    result = imul(31, result) + hashCode(this.ee1_1) | 0;
    return result;
  };
  function SizeElement(minWidth, minHeight, maxWidth, maxHeight, enforceIncoming, inspectorInfo) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    maxWidth = maxWidth === VOID ? Companion_getInstance().p5f_1 : maxWidth;
    maxHeight = maxHeight === VOID ? Companion_getInstance().p5f_1 : maxHeight;
    ModifierNodeElement.call(this);
    this.ze1_1 = minWidth;
    this.ae2_1 = minHeight;
    this.be2_1 = maxWidth;
    this.ce2_1 = maxHeight;
    this.de2_1 = enforceIncoming;
    this.ee2_1 = inspectorInfo;
  }
  protoOf(SizeElement).r3d = function () {
    return new SizeNode(this.ze1_1, this.ae2_1, this.be2_1, this.ce2_1, this.de2_1);
  };
  protoOf(SizeElement).fe2 = function (node) {
    node.ue2_1 = this.ze1_1;
    node.ve2_1 = this.ae2_1;
    node.we2_1 = this.be2_1;
    node.xe2_1 = this.ce2_1;
    node.ye2_1 = this.de2_1;
  };
  protoOf(SizeElement).d8y = function (node) {
    return this.fe2(node instanceof SizeNode ? node : THROW_CCE());
  };
  protoOf(SizeElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeElement))
      return false;
    if (!equals(this.ze1_1, other.ze1_1))
      return false;
    if (!equals(this.ae2_1, other.ae2_1))
      return false;
    if (!equals(this.be2_1, other.be2_1))
      return false;
    if (!equals(this.ce2_1, other.ce2_1))
      return false;
    if (!(this.de2_1 === other.de2_1))
      return false;
    return true;
  };
  protoOf(SizeElement).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.ze1_1);
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.ae2_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.be2_1) | 0;
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.ce2_1) | 0;
    result = imul(31, result) + getBooleanHashCode(this.de2_1) | 0;
    return result;
  };
  function UnspecifiedConstraintsElement(minWidth, minHeight) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    ModifierNodeElement.call(this);
    this.ae3_1 = minWidth;
    this.be3_1 = minHeight;
  }
  protoOf(UnspecifiedConstraintsElement).r3d = function () {
    return new UnspecifiedConstraintsNode(this.ae3_1, this.be3_1);
  };
  protoOf(UnspecifiedConstraintsElement).ce3 = function (node) {
    node.re3_1 = this.ae3_1;
    node.se3_1 = this.be3_1;
  };
  protoOf(UnspecifiedConstraintsElement).d8y = function (node) {
    return this.ce3(node instanceof UnspecifiedConstraintsNode ? node : THROW_CCE());
  };
  protoOf(UnspecifiedConstraintsElement).equals = function (other) {
    if (!(other instanceof UnspecifiedConstraintsElement))
      return false;
    return equals(this.ae3_1, other.ae3_1) && equals(this.be3_1, other.be3_1);
  };
  protoOf(UnspecifiedConstraintsElement).hashCode = function () {
    return imul(Dp__hashCode_impl_sxkrra(this.ae3_1), 31) + Dp__hashCode_impl_sxkrra(this.be3_1) | 0;
  };
  function FillNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.a98($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function FillNode(direction, fraction) {
    Node.call(this);
    this.we0_1 = direction;
    this.xe0_1 = fraction;
  }
  protoOf(FillNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var minWidth;
    var maxWidth;
    if (_Constraints___get_hasBoundedWidth__impl__7hd0wr(constraints) && !this.we0_1.equals(Direction_Vertical_getInstance())) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_0 = _Constraints___get_maxWidth__impl__uuyqc(constraints) * this.xe0_1;
      var tmp;
      if (isNaN_0(this_0)) {
        tmp = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp = roundToInt(this_0);
      }
      var tmp0 = tmp;
      var tmp2 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue = _Constraints___get_maxWidth__impl__uuyqc(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_1 = tmp0 < tmp2 ? tmp2 : tmp0;
      var width = this_1 > maximumValue ? maximumValue : this_1;
      minWidth = width;
      maxWidth = width;
    } else {
      minWidth = _Constraints___get_minWidth__impl__hi9lfi(constraints);
      maxWidth = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    }
    var minHeight;
    var maxHeight;
    if (_Constraints___get_hasBoundedHeight__impl__bsh4rw(constraints) && !this.we0_1.equals(Direction_Horizontal_getInstance())) {
      // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
      var this_2 = _Constraints___get_maxHeight__impl__dt3e8z(constraints) * this.xe0_1;
      var tmp_0;
      if (isNaN_0(this_2)) {
        tmp_0 = 0;
      } else {
        // Inline function 'kotlin.math.roundToInt' call
        tmp_0 = roundToInt(this_2);
      }
      var tmp0_0 = tmp_0;
      var tmp2_0 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = tmp0_0 < tmp2_0 ? tmp2_0 : tmp0_0;
      var height = this_3 > maximumValue_0 ? maximumValue_0 : this_3;
      minHeight = height;
      maxHeight = height;
    } else {
      minHeight = _Constraints___get_minHeight__impl__ev4bgx(constraints);
      maxHeight = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    }
    var placeable = measurable.h8y(Constraints(minWidth, maxWidth, minHeight, maxHeight));
    var tmp_1 = placeable.i8y_1;
    var tmp_2 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp_1, tmp_2, VOID, FillNode$measure$lambda(placeable));
  };
  var Direction_Vertical_instance;
  var Direction_Horizontal_instance;
  var Direction_Both_instance;
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_instance;
    Direction_entriesInitialized = true;
    Direction_Vertical_instance = new Direction('Vertical', 0);
    Direction_Horizontal_instance = new Direction('Horizontal', 1);
    Direction_Both_instance = new Direction('Both', 2);
  }
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function WrapContentNode$measure$lambda(this$0, $wrapperWidth, $placeable, $wrapperHeight, $this_measure) {
    return function ($this$layout) {
      var tmp = this$0.xe1_1;
      var tmp0 = $wrapperWidth - $placeable.i8y_1 | 0;
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = $wrapperHeight - $placeable.j8y_1 | 0;
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      var tmp$ret$0 = _IntSize___init__impl__emcjft(tmp$ret$1);
      var position = tmp(new IntSize(tmp$ret$0), $this_measure.r6p()).a5g_1;
      $this$layout.lal($placeable, position);
      return Unit_instance;
    };
  }
  function WrapContentNode(direction, unbounded, alignmentCallback) {
    Node.call(this);
    this.ve1_1 = direction;
    this.we1_1 = unbounded;
    this.xe1_1 = alignmentCallback;
  }
  protoOf(WrapContentNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var tmp0_minWidth = !this.ve1_1.equals(Direction_Vertical_getInstance()) ? 0 : _Constraints___get_minWidth__impl__hi9lfi(constraints);
    var tmp1_minHeight = !this.ve1_1.equals(Direction_Horizontal_getInstance()) ? 0 : _Constraints___get_minHeight__impl__ev4bgx(constraints);
    var tmp;
    if (!this.ve1_1.equals(Direction_Vertical_getInstance()) && this.we1_1) {
      tmp = 2147483647;
    } else {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    }
    var tmp2_maxWidth = tmp;
    var tmp_0;
    if (!this.ve1_1.equals(Direction_Horizontal_getInstance()) && this.we1_1) {
      tmp_0 = 2147483647;
    } else {
      tmp_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    }
    var tmp3_maxHeight = tmp_0;
    var wrappedConstraints = Constraints(tmp0_minWidth, tmp2_maxWidth, tmp1_minHeight, tmp3_maxHeight);
    var placeable = measurable.h8y(wrappedConstraints);
    var wrapperWidth = coerceIn(placeable.i8y_1, _Constraints___get_minWidth__impl__hi9lfi(constraints), _Constraints___get_maxWidth__impl__uuyqc(constraints));
    var wrapperHeight = coerceIn(placeable.j8y_1, _Constraints___get_minHeight__impl__ev4bgx(constraints), _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    return _this__u8e3s4.n8y(wrapperWidth, wrapperHeight, VOID, WrapContentNode$measure$lambda(this, wrapperWidth, placeable, wrapperHeight, _this__u8e3s4));
  };
  function _get_targetConstraints__wn7g24($this, $receiver) {
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = $this.we2_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_1 = $receiver.w5e($this.we2_1);
      tmp = this_1 < 0 ? 0 : this_1;
    } else {
      tmp = 2147483647;
    }
    var maxWidth = tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_2 = $this.xe2_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_2))) {
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_3 = $receiver.w5e($this.xe2_1);
      tmp_0 = this_3 < 0 ? 0 : this_3;
    } else {
      tmp_0 = 2147483647;
    }
    var maxHeight = tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_4 = $this.ue2_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_4))) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_5 = $receiver.w5e($this.ue2_1);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_6 = this_5 < 0 ? 0 : this_5;
      // Inline function 'kotlin.let' call
      var it = this_6 > maxWidth ? maxWidth : this_6;
      tmp_1 = !(it === 2147483647) ? it : 0;
    } else {
      tmp_1 = 0;
    }
    var minWidth = tmp_1;
    var tmp_2;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_7 = $this.ve2_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_7))) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var this_8 = $receiver.w5e($this.ve2_1);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_9 = this_8 < 0 ? 0 : this_8;
      // Inline function 'kotlin.let' call
      var it_0 = this_9 > maxHeight ? maxHeight : this_9;
      tmp_2 = !(it_0 === 2147483647) ? it_0 : 0;
    } else {
      tmp_2 = 0;
    }
    var minHeight = tmp_2;
    return Constraints(minWidth, maxWidth, minHeight, maxHeight);
  }
  function SizeNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.a98($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function SizeNode(minWidth, minHeight, maxWidth, maxHeight, enforceIncoming) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    maxWidth = maxWidth === VOID ? Companion_getInstance().p5f_1 : maxWidth;
    maxHeight = maxHeight === VOID ? Companion_getInstance().p5f_1 : maxHeight;
    Node.call(this);
    this.ue2_1 = minWidth;
    this.ve2_1 = minHeight;
    this.we2_1 = maxWidth;
    this.xe2_1 = maxHeight;
    this.ye2_1 = enforceIncoming;
  }
  protoOf(SizeNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    // Inline function 'kotlin.let' call
    var targetConstraints = _get_targetConstraints__wn7g24(this, _this__u8e3s4);
    var tmp;
    if (this.ye2_1) {
      tmp = constrain(constraints, targetConstraints);
    } else {
      var tmp_0;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      var this_0 = this.ue2_1;
      if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
        tmp_0 = _Constraints___get_minWidth__impl__hi9lfi(targetConstraints);
      } else {
        var tmp0 = _Constraints___get_minWidth__impl__hi9lfi(constraints);
        // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
        var maximumValue = _Constraints___get_maxWidth__impl__uuyqc(targetConstraints);
        tmp_0 = tmp0 > maximumValue ? maximumValue : tmp0;
      }
      var resolvedMinWidth = tmp_0;
      var tmp_1;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      var this_1 = this.we2_1;
      if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_1))) {
        tmp_1 = _Constraints___get_maxWidth__impl__uuyqc(targetConstraints);
      } else {
        var tmp0_0 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        var minimumValue = _Constraints___get_minWidth__impl__hi9lfi(targetConstraints);
        tmp_1 = tmp0_0 < minimumValue ? minimumValue : tmp0_0;
      }
      var resolvedMaxWidth = tmp_1;
      var tmp_2;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      var this_2 = this.ve2_1;
      if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_2))) {
        tmp_2 = _Constraints___get_minHeight__impl__ev4bgx(targetConstraints);
      } else {
        var tmp0_1 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
        // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
        var maximumValue_0 = _Constraints___get_maxHeight__impl__dt3e8z(targetConstraints);
        tmp_2 = tmp0_1 > maximumValue_0 ? maximumValue_0 : tmp0_1;
      }
      var resolvedMinHeight = tmp_2;
      var tmp_3;
      // Inline function 'androidx.compose.ui.unit.isSpecified' call
      var this_3 = this.xe2_1;
      if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_3))) {
        tmp_3 = _Constraints___get_maxHeight__impl__dt3e8z(targetConstraints);
      } else {
        var tmp0_2 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        var minimumValue_0 = _Constraints___get_minHeight__impl__ev4bgx(targetConstraints);
        tmp_3 = tmp0_2 < minimumValue_0 ? minimumValue_0 : tmp0_2;
      }
      var resolvedMaxHeight = tmp_3;
      tmp = Constraints(resolvedMinWidth, resolvedMaxWidth, resolvedMinHeight, resolvedMaxHeight);
    }
    var wrappedConstraints = tmp;
    var placeable = measurable.h8y(wrappedConstraints);
    var tmp_4 = placeable.i8y_1;
    var tmp_5 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp_4, tmp_5, VOID, SizeNode$measure$lambda(placeable));
  };
  protoOf(SizeNode).o8y = function (_this__u8e3s4, measurable, height) {
    var constraints = _get_targetConstraints__wn7g24(this, _this__u8e3s4);
    var tmp;
    if (_Constraints___get_hasFixedWidth__impl__4p17wc(constraints)) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      var childHeight = this.ye2_1 ? height : constrainHeight(constraints, height);
      tmp = constrainWidth(constraints, measurable.b98(childHeight));
    }
    return tmp;
  };
  protoOf(SizeNode).p8y = function (_this__u8e3s4, measurable, width) {
    var constraints = _get_targetConstraints__wn7g24(this, _this__u8e3s4);
    var tmp;
    if (_Constraints___get_hasFixedHeight__impl__y56fxx(constraints)) {
      tmp = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    } else {
      var childWidth = this.ye2_1 ? width : constrainWidth(constraints, width);
      tmp = constrainHeight(constraints, measurable.d98(childWidth));
    }
    return tmp;
  };
  protoOf(SizeNode).q8y = function (_this__u8e3s4, measurable, height) {
    var constraints = _get_targetConstraints__wn7g24(this, _this__u8e3s4);
    var tmp;
    if (_Constraints___get_hasFixedWidth__impl__4p17wc(constraints)) {
      tmp = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    } else {
      var childHeight = this.ye2_1 ? height : constrainHeight(constraints, height);
      tmp = constrainWidth(constraints, measurable.c98(childHeight));
    }
    return tmp;
  };
  protoOf(SizeNode).r8y = function (_this__u8e3s4, measurable, width) {
    var constraints = _get_targetConstraints__wn7g24(this, _this__u8e3s4);
    var tmp;
    if (_Constraints___get_hasFixedHeight__impl__y56fxx(constraints)) {
      tmp = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
    } else {
      var childWidth = this.ye2_1 ? width : constrainWidth(constraints, width);
      tmp = constrainHeight(constraints, measurable.e98(childWidth));
    }
    return tmp;
  };
  function UnspecifiedConstraintsNode$measure$lambda($placeable) {
    return function ($this$layout) {
      $this$layout.a98($placeable, 0, 0);
      return Unit_instance;
    };
  }
  function UnspecifiedConstraintsNode(minWidth, minHeight) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    Node.call(this);
    this.re3_1 = minWidth;
    this.se3_1 = minHeight;
  }
  protoOf(UnspecifiedConstraintsNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = this.re3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp_0 = _Constraints___get_minWidth__impl__hi9lfi(constraints) === 0;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp0 = _this__u8e3s4.w5e(this.re3_1);
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue = _Constraints___get_maxWidth__impl__uuyqc(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_1 = tmp0 < 0 ? 0 : tmp0;
      tmp = this_1 > maximumValue ? maximumValue : this_1;
    } else {
      tmp = _Constraints___get_minWidth__impl__hi9lfi(constraints);
    }
    var tmp_1 = tmp;
    var tmp_2 = _Constraints___get_maxWidth__impl__uuyqc(constraints);
    var tmp_3;
    var tmp_4;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_2 = this.se3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_2))) {
      tmp_4 = _Constraints___get_minHeight__impl__ev4bgx(constraints) === 0;
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      var tmp0_0 = _this__u8e3s4.w5e(this.se3_1);
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      var maximumValue_0 = _Constraints___get_maxHeight__impl__dt3e8z(constraints);
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = tmp0_0 < 0 ? 0 : tmp0_0;
      tmp_3 = this_3 > maximumValue_0 ? maximumValue_0 : this_3;
    } else {
      tmp_3 = _Constraints___get_minHeight__impl__ev4bgx(constraints);
    }
    var wrappedConstraints = Constraints(tmp_1, tmp_2, tmp_3, _Constraints___get_maxHeight__impl__dt3e8z(constraints));
    var placeable = measurable.h8y(wrappedConstraints);
    var tmp_5 = placeable.i8y_1;
    var tmp_6 = placeable.j8y_1;
    return _this__u8e3s4.n8y(tmp_5, tmp_6, VOID, UnspecifiedConstraintsNode$measure$lambda(placeable));
  };
  protoOf(UnspecifiedConstraintsNode).o8y = function (_this__u8e3s4, measurable, height) {
    var tmp0 = measurable.b98(height);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = this.re3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp = _this__u8e3s4.w5e(this.re3_1);
    } else {
      tmp = 0;
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = tmp;
    return tmp0 < minimumValue ? minimumValue : tmp0;
  };
  protoOf(UnspecifiedConstraintsNode).q8y = function (_this__u8e3s4, measurable, height) {
    var tmp0 = measurable.c98(height);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = this.re3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp = _this__u8e3s4.w5e(this.re3_1);
    } else {
      tmp = 0;
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = tmp;
    return tmp0 < minimumValue ? minimumValue : tmp0;
  };
  protoOf(UnspecifiedConstraintsNode).p8y = function (_this__u8e3s4, measurable, width) {
    var tmp0 = measurable.d98(width);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = this.se3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp = _this__u8e3s4.w5e(this.se3_1);
    } else {
      tmp = 0;
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = tmp;
    return tmp0 < minimumValue ? minimumValue : tmp0;
  };
  protoOf(UnspecifiedConstraintsNode).r8y = function (_this__u8e3s4, measurable, width) {
    var tmp0 = measurable.e98(width);
    var tmp;
    // Inline function 'androidx.compose.ui.unit.isSpecified' call
    var this_0 = this.se3_1;
    if (!isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp = _this__u8e3s4.w5e(this.se3_1);
    } else {
      tmp = 0;
    }
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = tmp;
    return tmp0 < minimumValue ? minimumValue : tmp0;
  };
  function requiredSizeIn(_this__u8e3s4, minWidth, minHeight, maxWidth, maxHeight) {
    minWidth = minWidth === VOID ? Companion_getInstance().p5f_1 : minWidth;
    minHeight = minHeight === VOID ? Companion_getInstance().p5f_1 : minHeight;
    maxWidth = maxWidth === VOID ? Companion_getInstance().p5f_1 : maxWidth;
    maxHeight = maxHeight === VOID ? Companion_getInstance().p5f_1 : maxHeight;
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = requiredSizeIn$lambda(minWidth, minHeight, maxWidth, maxHeight);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(minWidth, minHeight, maxWidth, maxHeight, false, tmp$ret$0));
  }
  function size_0(_this__u8e3s4, width, height) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = size$lambda_0(width, height);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return _this__u8e3s4.d8v(new SizeElement(width, height, width, height, true, tmp0_inspectorInfo));
  }
  function width_0(_this__u8e3s4, width) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = width$lambda_0(width);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(width, VOID, width, VOID, true, tmp$ret$0));
  }
  function size_1(_this__u8e3s4, size) {
    _init_properties_Size_kt__jcru8v();
    return size_0(_this__u8e3s4, _DpSize___get_width__impl__o3d5gt(size), _DpSize___get_height__impl__5xueo2(size));
  }
  function requiredWidth(_this__u8e3s4, width) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = requiredWidth$lambda(width);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(width, VOID, width, VOID, false, tmp$ret$0));
  }
  function requiredHeight(_this__u8e3s4, height) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = requiredHeight$lambda(height);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new SizeElement(VOID, height, VOID, height, false, tmp$ret$0));
  }
  function wrapContentSize(_this__u8e3s4, align, unbounded) {
    align = align === VOID ? Companion_getInstance_0().o8t_1 : align;
    unbounded = unbounded === VOID ? false : unbounded;
    _init_properties_Size_kt__jcru8v();
    var tmp;
    if (equals(align, Companion_getInstance_0().o8t_1) && !unbounded) {
      tmp = get_WrapContentSizeCenter();
    } else if (equals(align, Companion_getInstance_0().k8t_1) && !unbounded) {
      tmp = get_WrapContentSizeTopStart();
    } else {
      tmp = Companion_instance_3.ze0(align, unbounded);
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function requiredSize(_this__u8e3s4, size) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = requiredSize$lambda(size);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return _this__u8e3s4.d8v(new SizeElement(size, size, size, size, false, tmp0_inspectorInfo));
  }
  function requiredSize_0(_this__u8e3s4, width, height) {
    _init_properties_Size_kt__jcru8v();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = requiredSize$lambda_0(width, height);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp0_inspectorInfo = tmp;
    return _this__u8e3s4.d8v(new SizeElement(width, height, width, height, false, tmp0_inspectorInfo));
  }
  function wrapContentWidth(_this__u8e3s4, align, unbounded) {
    align = align === VOID ? Companion_getInstance_0().x8t_1 : align;
    unbounded = unbounded === VOID ? false : unbounded;
    _init_properties_Size_kt__jcru8v();
    var tmp;
    if (equals(align, Companion_getInstance_0().x8t_1) && !unbounded) {
      tmp = get_WrapContentWidthCenter();
    } else if (equals(align, Companion_getInstance_0().w8t_1) && !unbounded) {
      tmp = get_WrapContentWidthStart();
    } else {
      tmp = Companion_instance_3.ye0(align, unbounded);
    }
    return _this__u8e3s4.d8v(tmp);
  }
  function sizeIn$lambda($minWidth, $minHeight, $maxWidth, $maxHeight) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'sizeIn';
      _this__u8e3s4.mdp_1.odp('minWidth', new Dp($minWidth));
      _this__u8e3s4.mdp_1.odp('minHeight', new Dp($minHeight));
      _this__u8e3s4.mdp_1.odp('maxWidth', new Dp($maxWidth));
      _this__u8e3s4.mdp_1.odp('maxHeight', new Dp($maxHeight));
      return Unit_instance;
    };
  }
  function size$lambda($size) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'size';
      _this__u8e3s4.ldp_1 = new Dp($size);
      return Unit_instance;
    };
  }
  function widthIn$lambda($min, $max) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'widthIn';
      _this__u8e3s4.mdp_1.odp('min', new Dp($min));
      _this__u8e3s4.mdp_1.odp('max', new Dp($max));
      return Unit_instance;
    };
  }
  function height$lambda($height) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'height';
      _this__u8e3s4.ldp_1 = new Dp($height);
      return Unit_instance;
    };
  }
  function heightIn$lambda($min, $max) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'heightIn';
      _this__u8e3s4.mdp_1.odp('min', new Dp($min));
      _this__u8e3s4.mdp_1.odp('max', new Dp($max));
      return Unit_instance;
    };
  }
  function requiredSizeIn$lambda($minWidth, $minHeight, $maxWidth, $maxHeight) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'requiredSizeIn';
      _this__u8e3s4.mdp_1.odp('minWidth', new Dp($minWidth));
      _this__u8e3s4.mdp_1.odp('minHeight', new Dp($minHeight));
      _this__u8e3s4.mdp_1.odp('maxWidth', new Dp($maxWidth));
      _this__u8e3s4.mdp_1.odp('maxHeight', new Dp($maxHeight));
      return Unit_instance;
    };
  }
  function size$lambda_0($width, $height) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'size';
      _this__u8e3s4.mdp_1.odp('width', new Dp($width));
      _this__u8e3s4.mdp_1.odp('height', new Dp($height));
      return Unit_instance;
    };
  }
  function width$lambda_0($width) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'width';
      _this__u8e3s4.ldp_1 = new Dp($width);
      return Unit_instance;
    };
  }
  function requiredWidth$lambda($width) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'requiredWidth';
      _this__u8e3s4.ldp_1 = new Dp($width);
      return Unit_instance;
    };
  }
  function requiredHeight$lambda($height) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'requiredHeight';
      _this__u8e3s4.ldp_1 = new Dp($height);
      return Unit_instance;
    };
  }
  function requiredSize$lambda($size) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'requiredSize';
      _this__u8e3s4.ldp_1 = new Dp($size);
      return Unit_instance;
    };
  }
  function requiredSize$lambda_0($width, $height) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'requiredSize';
      _this__u8e3s4.mdp_1.odp('width', new Dp($width));
      _this__u8e3s4.mdp_1.odp('height', new Dp($height));
      return Unit_instance;
    };
  }
  function Direction_Vertical_getInstance() {
    Direction_initEntries();
    return Direction_Vertical_instance;
  }
  function Direction_Horizontal_getInstance() {
    Direction_initEntries();
    return Direction_Horizontal_instance;
  }
  function Direction_Both_getInstance() {
    Direction_initEntries();
    return Direction_Both_instance;
  }
  var properties_initialized_Size_kt_x7rk2r;
  function _init_properties_Size_kt__jcru8v() {
    if (!properties_initialized_Size_kt_x7rk2r) {
      properties_initialized_Size_kt_x7rk2r = true;
      FillWholeMaxWidth = Companion_instance_2.ae0(1.0);
      FillWholeMaxHeight = Companion_instance_2.be0(1.0);
      FillWholeMaxSize = Companion_instance_2.ce0(1.0);
      WrapContentWidthCenter = Companion_instance_3.ye0(Companion_getInstance_0().x8t_1, false);
      WrapContentWidthStart = Companion_instance_3.ye0(Companion_getInstance_0().w8t_1, false);
      WrapContentHeightCenter = Companion_instance_3.zdz(Companion_getInstance_0().u8t_1, false);
      WrapContentHeightTop = Companion_instance_3.zdz(Companion_getInstance_0().t8t_1, false);
      WrapContentSizeCenter = Companion_instance_3.ze0(Companion_getInstance_0().o8t_1, false);
      WrapContentSizeTopStart = Companion_instance_3.ze0(Companion_getInstance_0().k8t_1, false);
    }
  }
  function Spacer(modifier, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.ui.layout.Layout' call
    var modifier_0 = modifier;
    var $composer_1 = $composer_0;
    if (!((0 & 1) === 0))
      modifier_0 = Companion_instance;
    var compositeKeyHash = get_currentCompositeKeyHashCode($composer_1, 0).hashCode();
    var materialized = materialize($composer_1, modifier_0);
    var localMap = $composer_1.t31();
    // Inline function 'androidx.compose.runtime.ReusableComposeNode' call
    var factory = Companion_getInstance_2().oah_1;
    var $composer_2 = $composer_1;
    var tmp = $composer_2.g30();
    if (!isInterface(tmp, Applier)) {
      invalidApplier();
    }
    $composer_2.b31();
    if ($composer_2.h30()) {
      $composer_2.c31(factory);
    } else {
      $composer_2.d31();
    }
    var $this$ReusableComposeNode = _Updater___init__impl__rbfxm8($composer_2);
    Updater__set_impl_v7kwss($this$ReusableComposeNode, SpacerMeasurePolicy_instance, Companion_getInstance_2().tah_1);
    Updater__set_impl_v7kwss($this$ReusableComposeNode, localMap, Companion_getInstance_2().sah_1);
    Updater__reconcile_impl_1mfi6g($this$ReusableComposeNode, Companion_getInstance_2().xah_1);
    Updater__set_impl_v7kwss($this$ReusableComposeNode, materialized, Companion_getInstance_2().qah_1);
    Updater__set_impl_v7kwss($this$ReusableComposeNode, compositeKeyHash, Companion_getInstance_2().wah_1);
    $composer_2.e31();
  }
  function SpacerMeasurePolicy$measure$lambda($this$layout) {
    return Unit_instance;
  }
  function SpacerMeasurePolicy() {
  }
  protoOf(SpacerMeasurePolicy).mak = function (_this__u8e3s4, measurables, constraints) {
    // Inline function 'kotlin.with' call
    var width = _Constraints___get_hasFixedWidth__impl__4p17wc(constraints) ? _Constraints___get_maxWidth__impl__uuyqc(constraints) : 0;
    var height = _Constraints___get_hasFixedHeight__impl__y56fxx(constraints) ? _Constraints___get_maxHeight__impl__dt3e8z(constraints) : 0;
    return _this__u8e3s4.n8y(width, height, VOID, SpacerMeasurePolicy$measure$lambda);
  };
  var SpacerMeasurePolicy_instance;
  function SpacerMeasurePolicy_getInstance() {
    return SpacerMeasurePolicy_instance;
  }
  function get_EmptyWindowInsets() {
    _init_properties_WindowInsets_kt__lpu9pi();
    return EmptyWindowInsets;
  }
  var EmptyWindowInsets;
  var androidx_compose_foundation_layout_MutableWindowInsets$stable;
  var androidx_compose_foundation_layout_ValueInsets$stable;
  var androidx_compose_foundation_layout_InsetsValues$stable;
  function Companion_2() {
  }
  var Companion_instance_4;
  function Companion_getInstance_8() {
    return Companion_instance_4;
  }
  function WindowInsets(left, top, right, bottom) {
    left = left === VOID ? 0 : left;
    top = top === VOID ? 0 : top;
    right = right === VOID ? 0 : right;
    bottom = bottom === VOID ? 0 : bottom;
    _init_properties_WindowInsets_kt__lpu9pi();
    return new FixedIntInsets(left, top, right, bottom);
  }
  function only(_this__u8e3s4, sides) {
    _init_properties_WindowInsets_kt__lpu9pi();
    return new LimitInsets(_this__u8e3s4, sides);
  }
  function _WindowInsetsSides___init__impl__nuufbx(value) {
    return value;
  }
  function _get_value__a43j40($this) {
    return $this;
  }
  function WindowInsetsSides__plus_impl_9q9m59($this, sides) {
    return _WindowInsetsSides___init__impl__nuufbx(_get_value__a43j40($this) | _get_value__a43j40(sides));
  }
  function WindowInsetsSides__hasAny_impl_v1wjnf($this, sides) {
    return !((_get_value__a43j40($this) & _get_value__a43j40(sides)) === 0);
  }
  function WindowInsetsSides__toString_impl_h23h9x($this) {
    return 'WindowInsetsSides(' + valueToString($this) + ')';
  }
  function valueToString($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().xe3_1)) === _get_value__a43j40(Companion_getInstance_9().xe3_1)) {
      valueToString$appendPlus(this_0, 'Start');
    }
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().be4_1)) === _get_value__a43j40(Companion_getInstance_9().be4_1)) {
      valueToString$appendPlus(this_0, 'Left');
    }
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().ze3_1)) === _get_value__a43j40(Companion_getInstance_9().ze3_1)) {
      valueToString$appendPlus(this_0, 'Top');
    }
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().ye3_1)) === _get_value__a43j40(Companion_getInstance_9().ye3_1)) {
      valueToString$appendPlus(this_0, 'End');
    }
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().ce4_1)) === _get_value__a43j40(Companion_getInstance_9().ce4_1)) {
      valueToString$appendPlus(this_0, 'Right');
    }
    if ((_get_value__a43j40($this) & _get_value__a43j40(Companion_getInstance_9().ae4_1)) === _get_value__a43j40(Companion_getInstance_9().ae4_1)) {
      valueToString$appendPlus(this_0, 'Bottom');
    }
    return this_0.toString();
  }
  function Companion_3() {
    Companion_instance_5 = this;
    this.te3_1 = _WindowInsetsSides___init__impl__nuufbx(8);
    this.ue3_1 = _WindowInsetsSides___init__impl__nuufbx(4);
    this.ve3_1 = _WindowInsetsSides___init__impl__nuufbx(2);
    this.we3_1 = _WindowInsetsSides___init__impl__nuufbx(1);
    this.xe3_1 = WindowInsetsSides__plus_impl_9q9m59(this.te3_1, this.we3_1);
    this.ye3_1 = WindowInsetsSides__plus_impl_9q9m59(this.ue3_1, this.ve3_1);
    this.ze3_1 = _WindowInsetsSides___init__impl__nuufbx(16);
    this.ae4_1 = _WindowInsetsSides___init__impl__nuufbx(32);
    this.be4_1 = WindowInsetsSides__plus_impl_9q9m59(this.te3_1, this.ve3_1);
    this.ce4_1 = WindowInsetsSides__plus_impl_9q9m59(this.ue3_1, this.we3_1);
    this.de4_1 = WindowInsetsSides__plus_impl_9q9m59(this.be4_1, this.ce4_1);
    this.ee4_1 = WindowInsetsSides__plus_impl_9q9m59(this.ze3_1, this.ae4_1);
  }
  var Companion_instance_5;
  function Companion_getInstance_9() {
    if (Companion_instance_5 == null)
      new Companion_3();
    return Companion_instance_5;
  }
  function WindowInsetsSides__hashCode_impl_w7unwc($this) {
    return $this;
  }
  function valueToString$appendPlus($this_buildString, text) {
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength($this_buildString) > 0) {
      $this_buildString.s(_Char___init__impl__6a9atx(43));
    }
    $this_buildString.q(text);
  }
  function FixedIntInsets(leftVal, topVal, rightVal, bottomVal) {
    this.fe4_1 = leftVal;
    this.ge4_1 = topVal;
    this.he4_1 = rightVal;
    this.ie4_1 = bottomVal;
  }
  protoOf(FixedIntInsets).je4 = function (density, layoutDirection) {
    return this.fe4_1;
  };
  protoOf(FixedIntInsets).ke4 = function (density) {
    return this.ge4_1;
  };
  protoOf(FixedIntInsets).le4 = function (density, layoutDirection) {
    return this.he4_1;
  };
  protoOf(FixedIntInsets).me4 = function (density) {
    return this.ie4_1;
  };
  protoOf(FixedIntInsets).toString = function () {
    return 'Insets(left=' + this.fe4_1 + ', top=' + this.ge4_1 + ', right=' + this.he4_1 + ', bottom=' + this.ie4_1 + ')';
  };
  protoOf(FixedIntInsets).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof FixedIntInsets)) {
      return false;
    }
    return this.fe4_1 === other.fe4_1 && this.ge4_1 === other.ge4_1 && this.he4_1 === other.he4_1 && this.ie4_1 === other.ie4_1;
  };
  protoOf(FixedIntInsets).hashCode = function () {
    var result = this.fe4_1;
    result = imul(31, result) + this.ge4_1 | 0;
    result = imul(31, result) + this.he4_1 | 0;
    result = imul(31, result) + this.ie4_1 | 0;
    return result;
  };
  function LimitInsets(insets, sides) {
    this.ne4_1 = insets;
    this.oe4_1 = sides;
  }
  protoOf(LimitInsets).je4 = function (density, layoutDirection) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = Companion_getInstance_9().te3_1;
    } else {
      tmp = Companion_getInstance_9().ve3_1;
    }
    var layoutDirectionSide = tmp;
    var allowLeft = WindowInsetsSides__hasAny_impl_v1wjnf(this.oe4_1, layoutDirectionSide);
    var tmp_0;
    if (allowLeft) {
      tmp_0 = this.ne4_1.je4(density, layoutDirection);
    } else {
      tmp_0 = 0;
    }
    return tmp_0;
  };
  protoOf(LimitInsets).ke4 = function (density) {
    return WindowInsetsSides__hasAny_impl_v1wjnf(this.oe4_1, Companion_getInstance_9().ze3_1) ? this.ne4_1.ke4(density) : 0;
  };
  protoOf(LimitInsets).le4 = function (density, layoutDirection) {
    var tmp;
    if (layoutDirection.equals(LayoutDirection_Ltr_getInstance())) {
      tmp = Companion_getInstance_9().ue3_1;
    } else {
      tmp = Companion_getInstance_9().we3_1;
    }
    var layoutDirectionSide = tmp;
    var allowRight = WindowInsetsSides__hasAny_impl_v1wjnf(this.oe4_1, layoutDirectionSide);
    var tmp_0;
    if (allowRight) {
      tmp_0 = this.ne4_1.le4(density, layoutDirection);
    } else {
      tmp_0 = 0;
    }
    return tmp_0;
  };
  protoOf(LimitInsets).me4 = function (density) {
    return WindowInsetsSides__hasAny_impl_v1wjnf(this.oe4_1, Companion_getInstance_9().ae4_1) ? this.ne4_1.me4(density) : 0;
  };
  protoOf(LimitInsets).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof LimitInsets)) {
      return false;
    }
    return equals(this.ne4_1, other.ne4_1) && this.oe4_1 === other.oe4_1;
  };
  protoOf(LimitInsets).hashCode = function () {
    var result = hashCode(this.ne4_1);
    result = imul(31, result) + WindowInsetsSides__hashCode_impl_w7unwc(this.oe4_1) | 0;
    return result;
  };
  protoOf(LimitInsets).toString = function () {
    return '(' + toString_0(this.ne4_1) + ' only ' + WindowInsetsSides__toString_impl_h23h9x(this.oe4_1) + ')';
  };
  function union(_this__u8e3s4, insets) {
    _init_properties_WindowInsets_kt__lpu9pi();
    return new UnionInsets(_this__u8e3s4, insets);
  }
  function makeEmptyWindowInsets() {
    _init_properties_WindowInsets_kt__lpu9pi();
    return get_EmptyWindowInsets();
  }
  function UnionInsets(first, second) {
    this.pe4_1 = first;
    this.qe4_1 = second;
  }
  protoOf(UnionInsets).je4 = function (density, layoutDirection) {
    var tmp0 = this.pe4_1.je4(density, layoutDirection);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.qe4_1.je4(density, layoutDirection);
    return Math.max(tmp0, b);
  };
  protoOf(UnionInsets).ke4 = function (density) {
    var tmp0 = this.pe4_1.ke4(density);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.qe4_1.ke4(density);
    return Math.max(tmp0, b);
  };
  protoOf(UnionInsets).le4 = function (density, layoutDirection) {
    var tmp0 = this.pe4_1.le4(density, layoutDirection);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.qe4_1.le4(density, layoutDirection);
    return Math.max(tmp0, b);
  };
  protoOf(UnionInsets).me4 = function (density) {
    var tmp0 = this.pe4_1.me4(density);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = this.qe4_1.me4(density);
    return Math.max(tmp0, b);
  };
  protoOf(UnionInsets).hashCode = function () {
    return hashCode(this.pe4_1) + imul(hashCode(this.qe4_1), 31) | 0;
  };
  protoOf(UnionInsets).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof UnionInsets)) {
      return false;
    }
    return equals(other.pe4_1, this.pe4_1) && equals(other.qe4_1, this.qe4_1);
  };
  protoOf(UnionInsets).toString = function () {
    return '(' + toString_0(this.pe4_1) + ' \u222A ' + toString_0(this.qe4_1) + ')';
  };
  function exclude(_this__u8e3s4, insets) {
    _init_properties_WindowInsets_kt__lpu9pi();
    return new ExcludeInsets(_this__u8e3s4, insets);
  }
  function asPaddingValues(_this__u8e3s4, density) {
    _init_properties_WindowInsets_kt__lpu9pi();
    return new InsetsPaddingValues(_this__u8e3s4, density);
  }
  function ExcludeInsets(included, excluded) {
    this.re4_1 = included;
    this.se4_1 = excluded;
  }
  protoOf(ExcludeInsets).je4 = function (density, layoutDirection) {
    return coerceAtLeast(this.re4_1.je4(density, layoutDirection) - this.se4_1.je4(density, layoutDirection) | 0, 0);
  };
  protoOf(ExcludeInsets).ke4 = function (density) {
    return coerceAtLeast(this.re4_1.ke4(density) - this.se4_1.ke4(density) | 0, 0);
  };
  protoOf(ExcludeInsets).le4 = function (density, layoutDirection) {
    return coerceAtLeast(this.re4_1.le4(density, layoutDirection) - this.se4_1.le4(density, layoutDirection) | 0, 0);
  };
  protoOf(ExcludeInsets).me4 = function (density) {
    return coerceAtLeast(this.re4_1.me4(density) - this.se4_1.me4(density) | 0, 0);
  };
  protoOf(ExcludeInsets).toString = function () {
    return '(' + toString_0(this.re4_1) + ' - ' + toString_0(this.se4_1) + ')';
  };
  protoOf(ExcludeInsets).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof ExcludeInsets)) {
      return false;
    }
    return equals(other.re4_1, this.re4_1) && equals(other.se4_1, this.se4_1);
  };
  protoOf(ExcludeInsets).hashCode = function () {
    return imul(31, hashCode(this.re4_1)) + hashCode(this.se4_1) | 0;
  };
  function InsetsPaddingValues(insets, density) {
    this.te4_1 = insets;
    this.ue4_1 = density;
  }
  protoOf(InsetsPaddingValues).adw = function (layoutDirection) {
    // Inline function 'kotlin.with' call
    var $this$with = this.ue4_1;
    return $this$with.d5f(this.te4_1.je4($this$with, layoutDirection));
  };
  protoOf(InsetsPaddingValues).fdw = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.ue4_1;
    return $this$with.d5f(this.te4_1.ke4($this$with));
  };
  protoOf(InsetsPaddingValues).zdv = function (layoutDirection) {
    // Inline function 'kotlin.with' call
    var $this$with = this.ue4_1;
    return $this$with.d5f(this.te4_1.le4($this$with, layoutDirection));
  };
  protoOf(InsetsPaddingValues).gdw = function () {
    // Inline function 'kotlin.with' call
    var $this$with = this.ue4_1;
    return $this$with.d5f(this.te4_1.me4($this$with));
  };
  protoOf(InsetsPaddingValues).toString = function () {
    return 'InsetsPaddingValues(insets=' + toString_0(this.te4_1) + ', density=' + toString_0(this.ue4_1) + ')';
  };
  protoOf(InsetsPaddingValues).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof InsetsPaddingValues)) {
      return false;
    }
    return equals(this.te4_1, other.te4_1) && equals(this.ue4_1, other.ue4_1);
  };
  protoOf(InsetsPaddingValues).hashCode = function () {
    var result = hashCode(this.te4_1);
    result = imul(31, result) + hashCode(this.ue4_1) | 0;
    return result;
  };
  var properties_initialized_WindowInsets_kt_2k4ux4;
  function _init_properties_WindowInsets_kt__lpu9pi() {
    if (!properties_initialized_WindowInsets_kt_2k4ux4) {
      properties_initialized_WindowInsets_kt_2k4ux4 = true;
      EmptyWindowInsets = new FixedIntInsets(0, 0, 0, 0);
      androidx_compose_foundation_layout_MutableWindowInsets$stable = 0;
      androidx_compose_foundation_layout_ValueInsets$stable = 0;
      androidx_compose_foundation_layout_InsetsValues$stable = 0;
    }
  }
  var androidx_compose_foundation_layout_InsetsPaddingModifier$stable;
  var androidx_compose_foundation_layout_InsetsConsumingModifierNode$stable;
  var androidx_compose_foundation_layout_InsetsPaddingModifierNode$stable;
  function windowInsetsPadding(_this__u8e3s4, insets) {
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = windowInsetsPadding$lambda(insets);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new InsetsPaddingModifierElement(insets, tmp$ret$0));
  }
  function InsetsPaddingModifierElement(insets, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.we4_1 = insets;
    this.xe4_1 = inspectorInfo;
  }
  protoOf(InsetsPaddingModifierElement).r3d = function () {
    return new InsetsPaddingModifierNode(this.we4_1);
  };
  protoOf(InsetsPaddingModifierElement).ye4 = function (node) {
    node.qe5(this.we4_1);
  };
  protoOf(InsetsPaddingModifierElement).d8y = function (node) {
    return this.ye4(node instanceof InsetsPaddingModifierNode ? node : THROW_CCE());
  };
  protoOf(InsetsPaddingModifierElement).hashCode = function () {
    return hashCode(this.we4_1);
  };
  protoOf(InsetsPaddingModifierElement).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof InsetsPaddingModifierElement)) {
      return false;
    }
    return equals(other.we4_1, this.we4_1);
  };
  function InsetsPaddingModifierNode$measure$lambda($placeable, $left, $top) {
    return function ($this$layout) {
      $this$layout.jal($placeable, $left, $top);
      return Unit_instance;
    };
  }
  function InsetsPaddingModifierNode(insets) {
    InsetsConsumingModifierNode.call(this);
    this.pe5_1 = insets;
  }
  protoOf(InsetsPaddingModifierNode).re5 = function (ancestorConsumedInsets) {
    return union(ancestorConsumedInsets, this.pe5_1);
  };
  protoOf(InsetsPaddingModifierNode).se5 = function () {
    protoOf(InsetsConsumingModifierNode).se5.call(this);
    invalidateMeasurement(this);
  };
  protoOf(InsetsPaddingModifierNode).qe5 = function (insets) {
    if (!equals(insets, this.pe5_1)) {
      this.pe5_1 = insets;
      this.se5();
    }
  };
  protoOf(InsetsPaddingModifierNode).g8y = function (_this__u8e3s4, measurable, constraints) {
    var left = this.ie6_1.je4(_this__u8e3s4, _this__u8e3s4.r6p()) - this.he6_1.je4(_this__u8e3s4, _this__u8e3s4.r6p()) | 0;
    var top = this.ie6_1.ke4(_this__u8e3s4) - this.he6_1.ke4(_this__u8e3s4) | 0;
    var right = this.ie6_1.le4(_this__u8e3s4, _this__u8e3s4.r6p()) - this.he6_1.le4(_this__u8e3s4, _this__u8e3s4.r6p()) | 0;
    var bottom = this.ie6_1.me4(_this__u8e3s4) - this.he6_1.me4(_this__u8e3s4) | 0;
    var horizontal = left + right | 0;
    var vertical = top + bottom | 0;
    var childConstraints = offset(constraints, -horizontal | 0, -vertical | 0);
    var placeable = measurable.h8y(childConstraints);
    var width = constrainWidth(constraints, placeable.i8y_1 + horizontal | 0);
    var height = constrainHeight(constraints, placeable.j8y_1 + vertical | 0);
    return _this__u8e3s4.n8y(width, height, VOID, InsetsPaddingModifierNode$measure$lambda(placeable, left, top));
  };
  function setAncestorConsumedInsets($this, ancestorConsumedInsets) {
    if (!equals($this.he6_1, ancestorConsumedInsets)) {
      $this.he6_1 = ancestorConsumedInsets;
      $this.se5();
    }
  }
  function invalidateChildConsumedInsets($this) {
    var tmp = $this.t91();
    traverseDescendants($this, tmp, InsetsConsumingModifierNode$invalidateChildConsumedInsets$lambda($this));
  }
  function InsetsConsumingModifierNode$onAttach$lambda(this$0) {
    return function (parent) {
      var tmp = this$0;
      tmp.he6_1 = (parent instanceof InsetsConsumingModifierNode ? parent : THROW_CCE()).ie6_1;
      return false;
    };
  }
  function InsetsConsumingModifierNode$invalidateChildConsumedInsets$lambda(this$0) {
    return function (child) {
      setAncestorConsumedInsets(child instanceof InsetsConsumingModifierNode ? child : THROW_CCE(), this$0.ie6_1);
      return TraverseDescendantsAction_SkipSubtreeAndContinueTraversal_getInstance();
    };
  }
  function InsetsConsumingModifierNode() {
    Node.call(this);
    this.he6_1 = makeEmptyWindowInsets();
    this.ie6_1 = makeEmptyWindowInsets();
  }
  protoOf(InsetsConsumingModifierNode).t91 = function () {
    return 'androidx.compose.foundation.layout.ConsumedInsetsProvider';
  };
  protoOf(InsetsConsumingModifierNode).f8w = function () {
    var tmp = this.t91();
    traverseAncestors(this, tmp, InsetsConsumingModifierNode$onAttach$lambda(this));
    this.se5();
    protoOf(Node).f8w.call(this);
  };
  protoOf(InsetsConsumingModifierNode).h8w = function () {
    this.ie6_1 = this.he6_1;
    invalidateChildConsumedInsets(this);
    protoOf(Node).h8w.call(this);
  };
  protoOf(InsetsConsumingModifierNode).k8w = function () {
    protoOf(Node).k8w.call(this);
    this.he6_1 = makeEmptyWindowInsets();
  };
  protoOf(InsetsConsumingModifierNode).se5 = function () {
    this.ie6_1 = this.re5(this.he6_1);
    invalidateChildConsumedInsets(this);
  };
  function consumeWindowInsets(_this__u8e3s4, insets) {
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = consumeWindowInsets$lambda(insets);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new UnionInsetsConsumingModifierElement(insets, tmp$ret$0));
  }
  function onConsumedWindowInsetsChanged(_this__u8e3s4, block) {
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = onConsumedWindowInsetsChanged$lambda(block);
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return _this__u8e3s4.d8v(new ConsumedInsetsModifierElement(block, tmp$ret$0));
  }
  function UnionInsetsConsumingModifierElement(insets, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.ke6_1 = insets;
    this.le6_1 = inspectorInfo;
  }
  protoOf(UnionInsetsConsumingModifierElement).r3d = function () {
    return new UnionInsetsConsumingModifierNode(this.ke6_1);
  };
  protoOf(UnionInsetsConsumingModifierElement).me6 = function (node) {
    node.qe5(this.ke6_1);
  };
  protoOf(UnionInsetsConsumingModifierElement).d8y = function (node) {
    return this.me6(node instanceof UnionInsetsConsumingModifierNode ? node : THROW_CCE());
  };
  protoOf(UnionInsetsConsumingModifierElement).hashCode = function () {
    return hashCode(this.ke6_1);
  };
  protoOf(UnionInsetsConsumingModifierElement).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof UnionInsetsConsumingModifierElement)) {
      return false;
    }
    return equals(other.ke6_1, this.ke6_1);
  };
  function ConsumedInsetsModifierElement(block, inspectorInfo) {
    ModifierNodeElement.call(this);
    this.fe7_1 = block;
    this.ge7_1 = inspectorInfo;
  }
  protoOf(ConsumedInsetsModifierElement).r3d = function () {
    return new ConsumedInsetsModifierNode(this.fe7_1);
  };
  protoOf(ConsumedInsetsModifierElement).he7 = function (node) {
    node.ze7(this.fe7_1);
  };
  protoOf(ConsumedInsetsModifierElement).d8y = function (node) {
    return this.he7(node instanceof ConsumedInsetsModifierNode ? node : THROW_CCE());
  };
  protoOf(ConsumedInsetsModifierElement).hashCode = function () {
    return hashCode(this.fe7_1);
  };
  protoOf(ConsumedInsetsModifierElement).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (!(other instanceof ConsumedInsetsModifierElement)) {
      return false;
    }
    return other.fe7_1 === this.fe7_1;
  };
  function UnionInsetsConsumingModifierNode(insets) {
    InsetsConsumingModifierNode.call(this);
    this.de7_1 = insets;
  }
  protoOf(UnionInsetsConsumingModifierNode).re5 = function (ancestorConsumedInsets) {
    return union(ancestorConsumedInsets, this.de7_1);
  };
  protoOf(UnionInsetsConsumingModifierNode).qe5 = function (insets) {
    if (!equals(insets, this.de7_1)) {
      this.de7_1 = insets;
      this.se5();
    }
  };
  function ConsumedInsetsModifierNode(block) {
    InsetsConsumingModifierNode.call(this);
    this.ye7_1 = block;
  }
  protoOf(ConsumedInsetsModifierNode).re5 = function (ancestorConsumedInsets) {
    this.ye7_1(ancestorConsumedInsets);
    return ancestorConsumedInsets;
  };
  protoOf(ConsumedInsetsModifierNode).ze7 = function (block) {
    if (!(block === this.ye7_1)) {
      this.ye7_1 = block;
    }
  };
  function windowInsetsPadding$lambda($insets) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'windowInsetsPadding';
      _this__u8e3s4.mdp_1.odp('insets', $insets);
      return Unit_instance;
    };
  }
  function consumeWindowInsets$lambda($insets) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'consumeWindowInsets';
      _this__u8e3s4.mdp_1.odp('insets', $insets);
      return Unit_instance;
    };
  }
  function onConsumedWindowInsetsChanged$lambda($block) {
    return function (_this__u8e3s4) {
      _this__u8e3s4.kdp_1 = 'onConsumedWindowInsetsChanged';
      _this__u8e3s4.mdp_1.odp('block', $block);
      return Unit_instance;
    };
  }
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function throwIllegalStateException(message) {
    throw IllegalStateException_init_$Create$(message);
  }
  function get_safeDrawing_0(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalPlatformWindowInsets();
    var $composer_1 = $composer_0;
    var tmp$ret$0 = $composer_1.u31(this_0);
    return toWindowInsets(get_safeDrawing(tmp$ret$0));
  }
  function get_systemBars(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalPlatformWindowInsets();
    var $composer_1 = $composer_0;
    var tmp$ret$0 = $composer_1.u31(this_0);
    return toWindowInsets(tmp$ret$0.xcz());
  }
  function toWindowInsets(_this__u8e3s4) {
    return new toWindowInsets$1(_this__u8e3s4);
  }
  function get_statusBars(_this__u8e3s4, $composer, $changed) {
    var $composer_0 = $composer;
    // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
    var this_0 = get_LocalPlatformWindowInsets();
    var $composer_1 = $composer_0;
    var tmp$ret$0 = $composer_1.u31(this_0);
    return toWindowInsets(tmp$ret$0.qc8());
  }
  function toWindowInsets$1($this_toWindowInsets) {
    this.ae8_1 = $this_toWindowInsets;
  }
  protoOf(toWindowInsets$1).je4 = function (density, layoutDirection) {
    return this.ae8_1.e9f();
  };
  protoOf(toWindowInsets$1).ke4 = function (density) {
    return this.ae8_1.map();
  };
  protoOf(toWindowInsets$1).le4 = function (density, layoutDirection) {
    return this.ae8_1.x61();
  };
  protoOf(toWindowInsets$1).me4 = function (density) {
    return this.ae8_1.nap();
  };
  protoOf(toWindowInsets$1).toString = function () {
    return 'PlatformInsets.toWindowInsets(getLeft=' + this.ae8_1.e9f() + ', getTop=' + this.ae8_1.map() + ', getRight=' + this.ae8_1.x61() + ', getBottom=' + this.ae8_1.nap() + ')';
  };
  var safeDrawingPaddingLambda;
  var safeGesturesPaddingLambda;
  var safeContentPaddingLambda;
  var systemBarsPaddingLambda;
  var displayCutoutPaddingLambda;
  var statusBarsPaddingLambda;
  function get_imePaddingLambda() {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return imePaddingLambda;
  }
  var imePaddingLambda;
  var navigationBarsPaddingLambda;
  var captionBarPaddingLambda;
  var waterfallPaddingLambda;
  var systemGesturesPaddingLambda;
  var mandatorySystemGesturesPaddingLambda;
  function imePadding(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    // Inline function 'androidx.compose.ui.platform.debugInspectorInfo' call
    var tmp;
    if (get_isDebugInspectorInfoEnabled()) {
      tmp = imePadding$lambda;
    } else {
      tmp = get_NoInspectorInfo();
    }
    var tmp$ret$0 = tmp;
    return windowInsetsPadding_0(_this__u8e3s4, tmp$ret$0, get_imePaddingLambda());
  }
  function windowInsetsPadding_0(_this__u8e3s4, inspectorInfo, insetsCalculation) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return _this__u8e3s4.d8v(new PlatformInsetsPaddingModifierElement(inspectorInfo)).d8v(new PlatformWindowInsetsPaddingModifierElement(inspectorInfo, insetsCalculation));
  }
  function PlatformInsetsPaddingModifierElement(inspectorInfo) {
    ModifierNodeElement.call(this);
    this.ce8_1 = inspectorInfo;
  }
  protoOf(PlatformInsetsPaddingModifierElement).r3d = function () {
    return new PlatformInsetsPaddingModifierNode();
  };
  protoOf(PlatformInsetsPaddingModifierElement).de8 = function (node) {
  };
  protoOf(PlatformInsetsPaddingModifierElement).d8y = function (node) {
    return this.de8(node instanceof PlatformInsetsPaddingModifierNode ? node : THROW_CCE());
  };
  protoOf(PlatformInsetsPaddingModifierElement).hashCode = function () {
    return 0;
  };
  protoOf(PlatformInsetsPaddingModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlatformInsetsPaddingModifierElement))
      return false;
    return this.ce8_1 === other.ce8_1;
  };
  function PlatformWindowInsetsPaddingModifierElement(inspectorInfo, insetsGetter) {
    ModifierNodeElement.call(this);
    this.fe8_1 = inspectorInfo;
    this.ge8_1 = insetsGetter;
  }
  protoOf(PlatformWindowInsetsPaddingModifierElement).r3d = function () {
    return new PlatformWindowInsetsPaddingModifierNode(this.ge8_1);
  };
  protoOf(PlatformWindowInsetsPaddingModifierElement).he8 = function (node) {
    return node.ce9(this.ge8_1);
  };
  protoOf(PlatformWindowInsetsPaddingModifierElement).d8y = function (node) {
    return this.he8(node instanceof PlatformWindowInsetsPaddingModifierNode ? node : THROW_CCE());
  };
  protoOf(PlatformWindowInsetsPaddingModifierElement).hashCode = function () {
    return hashCode(this.ge8_1);
  };
  protoOf(PlatformWindowInsetsPaddingModifierElement).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PlatformWindowInsetsPaddingModifierElement))
      return false;
    return this.ge8_1 === other.ge8_1;
  };
  function PlatformInsetsPaddingModifierNode() {
    InsetsPaddingModifierNode.call(this, makeEmptyWindowInsets());
  }
  function PlatformWindowInsetsPaddingModifierNode$onAttach$lambda(this$0) {
    return function (node) {
      var tmp;
      if (node instanceof PlatformInsetsPaddingModifierNode) {
        this$0.be9_1 = node;
        tmp = false;
      } else {
        tmp = true;
      }
      return tmp;
    };
  }
  function PlatformWindowInsetsPaddingModifierNode$onObservedReadsChanged$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.be9_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.qe5(this$0.ae9_1(this$0.jct_1));
      }
      return Unit_instance;
    };
  }
  function PlatformWindowInsetsPaddingModifierNode(insetsGetter) {
    PlatformWindowInsetsProviderNode.call(this);
    this.ae9_1 = insetsGetter;
    this.be9_1 = null;
  }
  protoOf(PlatformWindowInsetsPaddingModifierNode).ce9 = function (insetsGetter) {
    if (!(this.ae9_1 === insetsGetter)) {
      this.ae9_1 = insetsGetter;
      this.lct();
    }
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).scs = function (ancestorWindowInsets) {
    return ancestorWindowInsets;
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).f8w = function () {
    protoOf(PlatformWindowInsetsProviderNode).f8w.call(this);
    traverseAncestors(this, 'androidx.compose.foundation.layout.ConsumedInsetsProvider', PlatformWindowInsetsPaddingModifierNode$onAttach$lambda(this));
    this.w95();
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).k8w = function () {
    this.be9_1 = null;
    protoOf(PlatformWindowInsetsProviderNode).k8w.call(this);
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).h8w = function () {
    this.be9_1 = null;
    protoOf(PlatformWindowInsetsProviderNode).h8w.call(this);
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).lct = function () {
    protoOf(PlatformWindowInsetsProviderNode).lct.call(this);
    this.w95();
  };
  protoOf(PlatformWindowInsetsPaddingModifierNode).w95 = function () {
    observeReads(this, PlatformWindowInsetsPaddingModifierNode$onObservedReadsChanged$lambda(this));
  };
  function safeDrawingPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(get_safeDrawing(_this__u8e3s4));
  }
  function safeGesturesPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(get_safeGestures(_this__u8e3s4));
  }
  function safeContentPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(get_safeContent(_this__u8e3s4));
  }
  function systemBarsPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.xcz());
  }
  function displayCutoutPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.mc8());
  }
  function statusBarsPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.qc8());
  }
  function imePaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.nc8());
  }
  function navigationBarsPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.pc8());
  }
  function captionBarPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.lc8());
  }
  function waterfallPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.tc8());
  }
  function systemGesturesPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.rc8());
  }
  function mandatorySystemGesturesPaddingLambda$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    return toWindowInsets(_this__u8e3s4.oc8());
  }
  function imePadding$lambda(_this__u8e3s4) {
    _init_properties_WindowInsetsPadding_skiko_kt__j76ce8();
    _this__u8e3s4.kdp_1 = 'imePadding';
    return Unit_instance;
  }
  var properties_initialized_WindowInsetsPadding_skiko_kt_tc289q;
  function _init_properties_WindowInsetsPadding_skiko_kt__j76ce8() {
    if (!properties_initialized_WindowInsetsPadding_skiko_kt_tc289q) {
      properties_initialized_WindowInsetsPadding_skiko_kt_tc289q = true;
      safeDrawingPaddingLambda = safeDrawingPaddingLambda$lambda;
      safeGesturesPaddingLambda = safeGesturesPaddingLambda$lambda;
      safeContentPaddingLambda = safeContentPaddingLambda$lambda;
      systemBarsPaddingLambda = systemBarsPaddingLambda$lambda;
      displayCutoutPaddingLambda = displayCutoutPaddingLambda$lambda;
      statusBarsPaddingLambda = statusBarsPaddingLambda$lambda;
      imePaddingLambda = imePaddingLambda$lambda;
      navigationBarsPaddingLambda = navigationBarsPaddingLambda$lambda;
      captionBarPaddingLambda = captionBarPaddingLambda$lambda;
      waterfallPaddingLambda = waterfallPaddingLambda$lambda;
      systemGesturesPaddingLambda = systemGesturesPaddingLambda$lambda;
      mandatorySystemGesturesPaddingLambda = mandatorySystemGesturesPaddingLambda$lambda;
    }
  }
  //region block: post-declaration
  protoOf(AlignmentLineOffsetDpNode).o8y = minIntrinsicWidth;
  protoOf(AlignmentLineOffsetDpNode).p8y = minIntrinsicHeight;
  protoOf(AlignmentLineOffsetDpNode).q8y = maxIntrinsicWidth;
  protoOf(AlignmentLineOffsetDpNode).r8y = maxIntrinsicHeight;
  protoOf(Arrangement$Absolute$Left$1).zdp = get_spacing;
  protoOf(Arrangement$Absolute$Center$1).zdp = get_spacing;
  protoOf(Arrangement$Absolute$Right$1).zdp = get_spacing;
  protoOf(Arrangement$Absolute$SpaceBetween$1).zdp = get_spacing;
  protoOf(Arrangement$Absolute$SpaceEvenly$1).zdp = get_spacing;
  protoOf(Arrangement$Absolute$SpaceAround$1).zdp = get_spacing;
  protoOf(Arrangement$Start$1).zdp = get_spacing;
  protoOf(Arrangement$End$1).zdp = get_spacing;
  protoOf(Arrangement$Top$1).zdp = get_spacing_0;
  protoOf(Arrangement$Bottom$1).zdp = get_spacing_0;
  protoOf(BoxMeasurePolicy).nak = minIntrinsicWidth_0;
  protoOf(BoxMeasurePolicy).oak = minIntrinsicHeight_0;
  protoOf(BoxMeasurePolicy).pak = maxIntrinsicWidth_0;
  protoOf(BoxMeasurePolicy).qak = maxIntrinsicHeight_0;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).nak = minIntrinsicWidth_0;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).oak = minIntrinsicHeight_0;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).pak = maxIntrinsicWidth_0;
  protoOf(sam$androidx_compose_ui_layout_MeasurePolicy$0).qak = maxIntrinsicHeight_0;
  protoOf(ColumnMeasurePolicy).mdt = createConstraints$default;
  protoOf(ColumnScopeInstance).yds = weight$default;
  protoOf(OffsetPxNode).o8y = minIntrinsicWidth;
  protoOf(OffsetPxNode).p8y = minIntrinsicHeight;
  protoOf(OffsetPxNode).q8y = maxIntrinsicWidth;
  protoOf(OffsetPxNode).r8y = maxIntrinsicHeight;
  protoOf(PaddingNode).o8y = minIntrinsicWidth;
  protoOf(PaddingNode).p8y = minIntrinsicHeight;
  protoOf(PaddingNode).q8y = maxIntrinsicWidth;
  protoOf(PaddingNode).r8y = maxIntrinsicHeight;
  protoOf(PaddingValuesModifier).o8y = minIntrinsicWidth;
  protoOf(PaddingValuesModifier).p8y = minIntrinsicHeight;
  protoOf(PaddingValuesModifier).q8y = maxIntrinsicWidth;
  protoOf(PaddingValuesModifier).r8y = maxIntrinsicHeight;
  protoOf(RowMeasurePolicy).mdt = createConstraints$default;
  protoOf(RowScopeInstance).bdy = weight$default_0;
  protoOf(FillNode).o8y = minIntrinsicWidth;
  protoOf(FillNode).p8y = minIntrinsicHeight;
  protoOf(FillNode).q8y = maxIntrinsicWidth;
  protoOf(FillNode).r8y = maxIntrinsicHeight;
  protoOf(WrapContentNode).o8y = minIntrinsicWidth;
  protoOf(WrapContentNode).p8y = minIntrinsicHeight;
  protoOf(WrapContentNode).q8y = maxIntrinsicWidth;
  protoOf(WrapContentNode).r8y = maxIntrinsicHeight;
  protoOf(SpacerMeasurePolicy).nak = minIntrinsicWidth_0;
  protoOf(SpacerMeasurePolicy).oak = minIntrinsicHeight_0;
  protoOf(SpacerMeasurePolicy).pak = maxIntrinsicWidth_0;
  protoOf(SpacerMeasurePolicy).qak = maxIntrinsicHeight_0;
  protoOf(InsetsPaddingModifierNode).o8y = minIntrinsicWidth;
  protoOf(InsetsPaddingModifierNode).p8y = minIntrinsicHeight;
  protoOf(InsetsPaddingModifierNode).q8y = maxIntrinsicWidth;
  protoOf(InsetsPaddingModifierNode).r8y = maxIntrinsicHeight;
  //endregion
  //region block: init
  androidx_compose_foundation_layout_Arrangement_Absolute$stable = 0;
  androidx_compose_foundation_layout_Arrangement_SpacedAligned$stable = 0;
  androidx_compose_foundation_layout_Arrangement$stable = 0;
  BoxScopeInstance_instance = new BoxScopeInstance();
  ColumnScopeInstance_instance = new ColumnScopeInstance();
  androidx_compose_foundation_layout_ComposeFoundationLayoutFlags$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowRowScopeImpl$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowColumnScopeImpl$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowRowOverflowScopeImpl$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowColumnOverflowScopeImpl$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowItemIterator$stable = 8;
  androidx_compose_foundation_layout_FlowLineInfo$stable = 8;
  androidx_compose_foundation_layout_FlowLayoutBuildingBlocks_WrapInfo$stable = 0;
  androidx_compose_foundation_layout_FlowLayoutBuildingBlocks_WrapEllipsisInfo$stable = 8;
  androidx_compose_foundation_layout_FlowLayoutBuildingBlocks$stable = 8;
  androidx_compose_foundation_layout_FlowRowOverflow$stable = 0;
  androidx_compose_foundation_layout_FlowColumnOverflow$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowRowOverflow$stable = 0;
  androidx_compose_foundation_layout_ContextualFlowColumnOverflow$stable = 0;
  androidx_compose_foundation_layout_FlowLayoutOverflow$stable = 0;
  androidx_compose_foundation_layout_FlowLayoutOverflowState$stable = 8;
  androidx_compose_foundation_layout_GridScopeInstance$stable = 0;
  androidx_compose_foundation_layout_GridMeasurePolicy$stable = 0;
  androidx_compose_foundation_layout_PaddingValues_Absolute$stable = 0;
  androidx_compose_foundation_layout_PaddingValuesImpl$stable = 0;
  RowScopeInstance_instance = new RowScopeInstance();
  Companion_instance_1 = new Companion();
  IntrinsicMeasureBlocks_instance = new IntrinsicMeasureBlocks();
  Companion_instance_2 = new Companion_0();
  Companion_instance_3 = new Companion_1();
  SpacerMeasurePolicy_instance = new SpacerMeasurePolicy();
  Companion_instance_4 = new Companion_2();
  androidx_compose_foundation_layout_InsetsPaddingModifier$stable = 0;
  androidx_compose_foundation_layout_InsetsConsumingModifierNode$stable = 8;
  androidx_compose_foundation_layout_InsetsPaddingModifierNode$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = BoxWithConstraints;
  _.$_$.b = Box;
  _.$_$.c = PaddingValues_1;
  _.$_$.d = PaddingValues;
  _.$_$.e = PaddingValues_0;
  _.$_$.f = Spacer;
  _.$_$.g = WindowInsets;
  _.$_$.h = asPaddingValues;
  _.$_$.i = aspectRatio;
  _.$_$.j = calculateEndPadding;
  _.$_$.k = calculateStartPadding;
  _.$_$.l = columnMeasurePolicy;
  _.$_$.m = consumeWindowInsets;
  _.$_$.n = defaultMinSize;
  _.$_$.o = exclude;
  _.$_$.p = fillMaxHeight;
  _.$_$.q = fillMaxSize;
  _.$_$.r = fillMaxWidth;
  _.$_$.s = heightIn;
  _.$_$.t = height;
  _.$_$.u = imePadding;
  _.$_$.v = maybeCachedBoxMeasurePolicy;
  _.$_$.w = offset_0;
  _.$_$.x = onConsumedWindowInsetsChanged;
  _.$_$.y = only;
  _.$_$.z = paddingFromBaseline;
  _.$_$.a1 = padding_2;
  _.$_$.b1 = padding_1;
  _.$_$.c1 = padding;
  _.$_$.d1 = padding_0;
  _.$_$.e1 = requiredHeight;
  _.$_$.f1 = requiredSizeIn;
  _.$_$.g1 = requiredSize_0;
  _.$_$.h1 = requiredSize;
  _.$_$.i1 = requiredWidth;
  _.$_$.j1 = rowMeasurePolicy;
  _.$_$.k1 = get_safeDrawing_0;
  _.$_$.l1 = sizeIn;
  _.$_$.m1 = size_0;
  _.$_$.n1 = size_1;
  _.$_$.o1 = size;
  _.$_$.p1 = get_statusBars;
  _.$_$.q1 = get_systemBars;
  _.$_$.r1 = widthIn;
  _.$_$.s1 = width;
  _.$_$.t1 = width_0;
  _.$_$.u1 = windowInsetsPadding;
  _.$_$.v1 = wrapContentHeight;
  _.$_$.w1 = wrapContentSize;
  _.$_$.x1 = wrapContentWidth;
  _.$_$.y1 = WindowInsetsSides__plus_impl_9q9m59;
  _.$_$.z1 = Absolute_getInstance;
  _.$_$.a2 = Arrangement_getInstance;
  _.$_$.b2 = BoxScopeInstance_instance;
  _.$_$.c2 = ColumnScopeInstance_instance;
  _.$_$.d2 = RowScopeInstance_instance;
  _.$_$.e2 = Companion_instance_4;
  _.$_$.f2 = Companion_getInstance_9;
  _.$_$.g2 = IntrinsicSize_Max_getInstance;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-foundation-foundation-layout.js.map
